import React, { useState, useEffect, useRef, useCallback } from "react";
import
    {
        Image,
        Divider,
        HStack,
        Pressable,
        Hidden,
        Box,
        Badge,
        VStack,
        Text,
        Button,
        Input,
        CloseIcon,
        ScrollView,
        FlatList,
        Tooltip,
        HamburgerIcon,
        Center,
        ChevronDownIcon,
        ChevronUpIcon,
        IconButton
    } from "native-base";
import LogoSvg from "../../assets/images/Actavivo-Logo.svg";
import Dropdown from "../../assets/images/dropdown.svg";
import { AVAuth } from "../../Platform/AVAuth";
import { Alert } from "../../AVCore/Alert";
import Moment from "moment";
import { SignalRService } from "../../AVCore/SignalR";
import
    {
        NotificationIcon,
        MessageIcon,
        SearchIcon,
        TickIcon,
        FollowingIcon,
        CrossIcon,
        EventsIcon,
        GroupIcon,
        CreateClass,
        CreateCommunity,
        CreateElite,
        CreateGraduation,
        CreateGroup,
        CreateNeighborhood,
        CreateOrganization,
        CreateSchool,
        CreateTeam,
        ChatIcon,
        CreateClub,
        MicIcon,
        VideoIcon,
    } from "../../assets/icons/icon-assets";
import QuickSearch from "./QuickSearch";
import Menu from "./Menu";
import ProfilePic from "../common/ProfilePicture";
import { Person } from "../../AVCore/Person";
import AVGradientBox from "../../Platform/AVGradientBox";
import useConvoChat from "../../Hooks/useConvoChat";
import useFollowRequest from "../../Hooks/useFollowRequest";
import useAlerts from "../../Hooks/useAlerts";
import { Link } from "../../AVCore/Link";
import * as AV from "../../AVCore/AVCore";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import AVCancel from "../../components/common/AVCancel";
import { TouchableOpacity, Linking } from "react-native";
import
    {
        setUser,
        setFeedsLoad,
        setToastShow,
        setLastFeedUpdate,
        setEntitydata,
        setMediaList,
        setConvoOpen,
        setBackgroundMessage,
        setIsConvoScreenOpen,
        setIsNotificationEnabled,
        setFeedShowing,
        setFollowersData,
        setEntityToken,
        setSearch,
        setLocation,
        setusersLang,
        setusersprofile,
        setDeviceFcmToken,
        setNewPosts,
        setRealUpdate,
    } from "../../Redux/Actions/userActions";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import
    {
        setFeedOwners,
        setFeeds,
        setFeedsScrollUpdate,
        setFeedsState,
        setFeedsUpdate,
        setProcessedHomeFeeds,
        setFetchProcess,
        setLastUpdatedPostDate,
        setPostList,
        setProcessedEntityIds,
        setRemainingEntities,
        setRemainingPosts,
    } from "../../Redux/Actions/feedsAction";
import { setAlerts, setNewAlerts, setLastScore } from "../../Redux/Actions/alertActions";
import { setConvo } from "../../Redux/Actions/convoActions";
import {
  addLiveStream,
  setShowLiveHostModal,
  setShowLiveViewModal,
  setLiveEntity,
  setShowLiveViewer,
} from "../../Redux/Actions/liveStreamActions";
import { Loc } from "../../App/Loc";
import { useWindowDimension } from "../../Utility/WindowDimensions";
import { Server } from "../../Platform/Server";
import
    {
        setLoginLink,
        setuserisguardian,
        setFollowRequestData,
        setPostPopupExpanded,
    } from "../../Redux/Actions/userActions";
import seting from "../../assets/images/setings.png";
import about from "../../assets/images/About.png";
import adduser from "../../assets/images/AddUser.png";
import help from "../../assets/images/help.png";
import _ from "lodash";
import { isMobile as isMobileDevice } from "react-device-detect";
import InviteFriends from "./InviteFriends";
import AVImageSlider from "../../components/common/AVImageSlider";
import { Media } from "../../AVCore/Media";
import CreateNewMessage from "../../Screens/chat/conversations/CreateNewMessage";
import Messages from "../../Screens/chat/screens/MainScreen";
import useClearCache from "../../Hooks/useClearCache";
import unauthorPopup from "../../assets/images/unauthorPopup.png";
import settings from "../../Platform/settings.json";
import VoiceMessage from '../common/VoiceMessage';
import AVConfirmationModal from '../../components/common/AVConfirmationModal';
import { persistor } from '../../Redux/store';
import PreviewCard from "../../components/posts/PreviewCard";
import EntityProfilePic from "../common/EntityProfilePic";
import PurchaseCreditsPopup from "../../components/common/PurchaseCreditsPopup";

const Logo = React.memo( () =>
{
    let person = useSelector( ( state : RootStateOrAny ) => state?.user?.user[ 0 ] );
    const dispatch = useDispatch();
    const { handlerefetch } = useAlerts();
    const location = useLocation();
    const navigate = useNavigate();

    const handlePress = () =>
    {
        if ( person?.status !== "Deleted" )
        {
            const currentUrlPath = window.location.pathname;
            if ( currentUrlPath == "/" )
            {
                dispatch( setFeedsScrollUpdate( true ) );
                //handlerefetch();
            } else
            {
                // Navigate to home without refresh
                navigate( "/" );
            }
        }
    };

    return (
        <React.Fragment>
            <Pressable
                isDisabled={ person?.status === "NewUser" || person?.status === "Deleted" }
                onPress={ handlePress }
            >
                { ( () =>
                {
                    return (
                        <Image
                            source={ { uri: LogoSvg } }
                            alt="Actavivo"
                            size={ [ "40px", "56px" ] }
                            color="red.200"
                        />
                    );
                } )() }
            </Pressable>
        </React.Fragment>
    );
} );

interface ILastFeedUpdate
{
    feed : AV.IFeed;
    lastGetFeedApiCall : Date;
    category : string;
}

function Header ( props : any )
{
    const location : any = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const dimensions = useWindowDimension();
    const [ allAlertData, setAllAlertData ] = useState( [] );
    const [ unreadAlertData, setUnreadAlertData ] = useState( [] );
    const stateUser = useSelector( ( state : RootStateOrAny ) => state );
    let userFeeds : any = useSelector(
        ( state : RootStateOrAny ) => state?.feeds.feeds[ 0 ]
    );
    const followRequestData : any = useSelector(
        ( state : RootStateOrAny ) => state?.user?.followRequestData
    );
    let NewlyUpdatedPost = useSelector(
        ( state : RootStateOrAny ) => state?.user?.newPost
    );
    let RealyUpdatedPost = useSelector(
        ( state : RootStateOrAny ) => state?.user?.realUpdate
    );
    const lastUpdateFeed = useSelector(
        ( state : RootStateOrAny ) => state.user.lastUpdateFeed
    );
    const postPopupExpanded = useSelector(
        ( state : RootStateOrAny ) => state.user.postPopupExpanded
    );
    const isOnline = useSelector(
        ( state : RootStateOrAny ) => state.user.isOnline
    );
    const showLiveHostModal = useSelector(
        ( state : RootStateOrAny ) => state.liveStream.showLiveHostModal,
    );
    const showLiveViewModal = useSelector(
        ( state : RootStateOrAny ) => state.liveStream.showLiveViewModal,
    );
    const isHostLiveMinimized = useSelector(
        ( state : RootStateOrAny ) => state.liveStream.isHostLiveMinimized,
    );
    const isViewLiveMinimized = useSelector(
        ( state : RootStateOrAny ) => state.liveStream.isViewLiveMinimized,
    );
    const [ commentValue, setCommentValue ] = useState<any>( "" );
    const [ lastfeed, setlastfeed ] = useState<any>( [] );
    const [ isNewChat, setIsNewChat ] = useState( false );
    const currentUser = stateUser?.user?.user[ 0 ];
    const useralertList = useSelector( ( state : RootStateOrAny ) =>
        state?.alerts?.alert[ 0 ]?.length > 0 ? state?.alerts?.alert[ 0 ] : []
    );
    useralertList?.sort( function ( a, b )
    {
        let c : any = new Date( b.date );
        let d : any = new Date( a.date );
        return c - d;
    } );
    let followreqlist = useralertList?.filter(
        ( x ) =>
            x?.actionTaken === undefined &&
            x?.alertType !== "NewRequest" &&
            ( x?.data?.type === "Follow" ||
                x?.type === "Follow" ||
                x?.data?.type === "StaffRequest" ||
                x?.type === "StaffRequest" ||
                x?.data?.type === "OrgParent" ||
                x?.type == "OrgParent" ||
                x?.alertType == "NewRequestToStaff" )
    );
    const customUniq = ( array ) =>
        _.uniqWith(
            array,
            ( a : any, b : any ) =>
                a?.id === b?.id &&
                a?.source?.id === b?.source?.id &&
                a?.target?.id === b?.target?.id &&
                a?.type === b?.type
        );
    const [ requestdata, setrequestdata ] = useState(
        _.orderBy(
            customUniq( [
                ...( followRequestData || [] ),
                ...( currentUser?.requests?.filter(
                    ( x ) => x?.actionTaken === undefined
                ) || [] ),
                ...( followreqlist || [] ),
            ] ),
            [ "date" ],
            [ "desc" ]
        )
    );
    const [ requestdata1, setrequestdata1 ] = useState(
        _.orderBy(
            customUniq( [
                ...( followRequestData || [] ),
                ...( currentUser?.requests?.filter(
                    ( x ) => x?.actionTaken === undefined
                ) || [] ),
                ...( followreqlist || [] ),
            ] ),
            [ "date" ],
            [ "desc" ]
        )
    );
    const [ managerequestdata, setManageRequestdata ] = useState( [] );
    const [ singleImage, setSingleImage ] = useState();
    const [ allImages, setShowAllImage ] = useState( [] );
    const [ showProfile, setShowProfile ] = useState( false );
    const [ showAddinviteModal, setshowAddinviteModal ] = useState( false );
    const [ personname, setpersonname ] = useState<string>();
    const [ personEmail, setpersonEmail ] = useState<string>();
    const [ personPhone, setpersonPhone ] = useState<string>();
    const [ isrequest ] = useState( true );
    const [ ismanagerequest ] = useState( false );
    const [ isunread, setIsUnread ] = useState( true );
    const [ isall, setIsAll ] = useState( false );
    const [ valuess, setvalues ] = useState<any>();
    const [ isCreateNew, setIsCreateNew ] = useState( true );
    const [ itemHeights, setItemHeights ] = useState( [] );
    const [ setConvoImage ] = useState();
    const [ showPreview, setShowPreview ] = useState( false );
    const [ isDisable, setIsDisable ] = useState( false );
    const [ isCreate, setIsCreate ] = useState( false );
    const convoval = useSelector( ( state : RootStateOrAny ) => state.convo.convo[ 0 ] );
    const [ convoListData, setconvoListData ] = useState( convoval );
    const [ convosearch, setconvosearch ] = useState( false );
    const isMobile = props?.dimensions?.width <= 600 || false;
    const isHeaderResponsive = props?.dimensions?.width <= 1000 || false;
    const [ showBurgerMenu, setShowBurgerMenu ] = useState( false );
    const userisguardian = stateUser?.user?.userisguardian;
    const loginLink = stateUser?.user?.loginLink;
    const [ isOpen, setIsOpen ] = useState( true );
    const [ isLoader, setIsLoader ] = useState( false );
    const [ searchRequestVal, setRequestVal ] = useState( "" );
    const [ isConfirmLogout, setIsConfirmLogout ] = useState( false );
    const [ showunauthorizedDetails, setshowunauthorizedDetails ] =
        useState( false );
    const toastShow = useSelector(
        ( state : RootStateOrAny ) => state?.user?.toastShow
    );
    const [ previewitem, setpreviewitem ] = useState();
    const [ ViewedItem, setViewedItem ] = useState( "" );
    const [ isHeader, setHeader ] = useState( false );
    const deviceFCMToken = useSelector(
        ( state : RootStateOrAny ) => state.user.devicefcmtoken
    );
    const clearCache = useClearCache();
    const isConvoScreenOpen = useSelector(
        ( state : RootStateOrAny ) => state.user.isConvoScreenOpen
    );
    let userconvolistdata = useSelector(
        ( state : RootStateOrAny ) => state.convo.convo[ 0 ]
    )?.sort( function ( a, b )
    {
        let c : any = new Date( b?.lastUpdated );
        let d : any = new Date( a?.lastUpdated );
        return c - d;
    } );

    const userconvo = useSelector(
        ( state : RootStateOrAny ) => state.convo.convo[ 0 ]
    );
    const usernewalert = useSelector(
        ( state : RootStateOrAny ) => state?.alerts?.newalert[ 0 ]
    );
    const entitydatalist : any = useSelector(
        ( state : RootStateOrAny ) => state.user.entitydatalist
    );
    const [ showEmoji, setShowEmoji ] = useState( false );
    const [ unread, setunread ] = useState(
        useralertList?.filter(
            ( x ) =>
                x.actionTaken === undefined &&
                x.alertType !== "EntityUpdate" &&
                x.alertType !== "DeletePost" &&
                x.alertType !== "NewRequest" &&
                x.alertType !== "NewRequestToStaff" &&
                x.alertType !== "NewRequestToStaff" &&
                x.alertType !== "Follow" &&
                x.alertType !== "NewRequest-Ward" &&
                x?.data?.type !== "Dependent" &&
                x?.alertType !== "Dependent" &&
                x?.wardName === undefined &&
                x?.alertType !== "UnBlock" &&
                x?.alertType !== "Block" &&
                x?.alertType !== "UnBlock" &&
                x?.alertType !== "Block" &&
                x?.alertType !== "UnBlocked" &&
                x?.alertType !== "Blocked" &&
                x?.alertType !== "DeleteDM"
        )
    );
    const [ all ] = useState(
        useralertList?.filter(
            ( x ) =>
                x.alertType !== "EntityUpdate" &&
                x.alertType !== "DeletePost" &&
                x.alertType !== "NewRequest" &&
                x.alertType !== "NewRequestToStaff" &&
                x.alertType !== "Follow" &&
                x.alertType !== "NewRequest-Ward" &&
                x?.data?.type !== "Dependent" &&
                x?.alertType !== "Dependent" &&
                x?.wardName == undefined &&
                x?.alertType !== "UnBlock" &&
                x?.alertType !== "Block" &&
                x?.alertType !== "UnBlock" &&
                x?.alertType !== "Block" &&
                x?.alertType !== "UnBlocked" &&
                x?.alertType !== "Blocked" &&
                x?.alertType !== "DeleteDM"
        )
    );
    const UnReadChatMessage = useralertList?.filter(
        ( x : any ) =>
            x?.actionTaken == undefined &&
            ( x?.alertType == "NewDM" || x?.alertType == "ReplyDM" ) &&
            x?.data?.person?.id !== currentUser?.id
    );
    const isDesktopView = props?.dimensions?.width <= 1200 || false;
    const googlePlayUrl : any =
        "https://play.google.com/store/apps/details?id=com.actavivo";
    const appStoreUrl : any = "https://apps.apple.com/app/actavivo/id1611252168";

    const [showCreditsPopup, setShowCreditsPopup] = useState(false);
    const [sharedPlan, setSharedPlan] = useState<AV.ISharedPlan>();
    const [entity, setEntity] = useState<AV.IAVEntity>(currentUser);
    const [eventParentEntity, setEventParentEntity] = useState<AV.IAVEntity>();

    const menuRef = useRef( null );
    useOutsideAlerter( menuRef );

    //Bind follow request modal
    const { handleUnFollow, unfollowLoader } = useFollowRequest();

    //Bind Convo list modal
    const [ showConvoListModal, setShowConvoListModal ] = useState( false );

    const getnewOrUpdatedPost = async () =>
    {
        let Newpost = usernewalert;
        let GalleryIds : any = "";
        let IsPass =
            usernewalert?.data?.postObj?.gallery?.items?.length > 0 ? true : false;
        if ( IsPass )
        {
            GalleryIds = usernewalert?.data?.postObj?.gallery?.items;
        }
        let listOfPost : any = {
            feed: {
                id: usernewalert?.data?.feed?.id,
                pk: usernewalert?.data?.feed?.id,
                type: "Feed",
            },
            posts: usernewalert?.data?.postObj,
            ids: IsPass ? GalleryIds : [],
            alertType: usernewalert?.alertType,
        };
        console.log( "listOfPost", listOfPost );
        if ( usernewalert?.alertType === "DeletePost" )
        {
            let userfeedsValue = userFeeds?.filter(
                ( x ) => x?.id === usernewalert?.target?.id
            );
            if ( userfeedsValue?.length > 0 )
            {
                let finalValue = userFeeds?.filter(
                    ( x ) => x?.id !== usernewalert?.target?.id
                );
                dispatch( setFeeds( finalValue ) );
            } else
            {
                if (
                    NewlyUpdatedPost?.filter(
                        ( x ) => x?.posts?.id === listOfPost?.posts?.id
                    )?.length > 0
                )
                {
                    NewlyUpdatedPost = NewlyUpdatedPost?.filter(
                        ( x ) => x?.posts?.id !== listOfPost?.posts?.id
                    );
                    dispatch( setNewPosts( NewlyUpdatedPost ) );
                }
            }
        } else
        {
            if ( NewlyUpdatedPost?.length > 0 )
            {
                if (
                    NewlyUpdatedPost?.filter(
                        ( x ) => x?.posts?.id === listOfPost?.posts?.id
                    )?.length == 0
                )
                {
                    NewlyUpdatedPost?.push( listOfPost );
                } else
                {
                    let UpdatedPostIndex = NewlyUpdatedPost?.findIndex(
                        ( x ) => x?.posts?.id === listOfPost?.posts?.id
                    );
                    NewlyUpdatedPost[ UpdatedPostIndex ] = listOfPost;
                }
                dispatch( setNewPosts( NewlyUpdatedPost ) );
            } else
            {
                let newpost : any = [];
                newpost?.push( listOfPost );
                dispatch( setNewPosts( newpost ) );
            }
        }
        if (
            usernewalert?.alertType === "UpdatePost" ||
            usernewalert?.alertType === "DeletePost" ||
            usernewalert?.alertType === "PostReview"
        )
        {
            if ( RealyUpdatedPost?.length > 0 )
            {
                if (
                    RealyUpdatedPost?.filter(
                        ( x ) => x?.posts?.id === listOfPost?.posts?.id
                    )?.length == 0
                )
                {
                    RealyUpdatedPost?.push( listOfPost );
                } else
                {
                    let UpdatedPostIndex = RealyUpdatedPost?.findIndex(
                        ( x ) => x?.posts?.id === listOfPost?.posts?.id
                    );
                    RealyUpdatedPost[ UpdatedPostIndex ] = listOfPost;
                }
                dispatch( setRealUpdate( RealyUpdatedPost ) );
            } else
            {
                let newpost : any = [];
                newpost?.push( listOfPost );
                dispatch( setRealUpdate( newpost ) );
            }
        }
    };
    function handleConvoDelete ( list : any, usernewalert : any )
    {
        var currentChat = list?.find(
            ( x : any ) => x?.id === usernewalert?.data?.feed?.id
        );
        if ( currentChat )
        {
            currentChat.posts = currentChat?.posts?.filter(
                ( x : any ) => x?.id !== usernewalert?.target?.id
            );
            currentChat.posts = currentChat?.posts?.filter(
                ( x : any ) => x?.parentPost !== usernewalert?.target?.id
            );
            list[ list.indexOf( currentChat ) ] = currentChat;
            dispatch( setConvo( list ) );
        }
    }

    const getEntity = async (entityFK, activity = "") => {
      if (!entityFK?.id) return null;
    
      let entity = entitydatalist?.find((x) => x?.id === entityFK?.id) ?? null;
      if (!entity) {
        let entityAPI: AV.IAVEntity | null = null;
    
        if (entityFK.type === "LeagueGameBase") {
          const param: AV.ILeagueGameParam = {
            source: entityFK,
            scoreType: activity,
          };
          entityAPI = await AV.Game.getLeagueGame(param);
        } else {
          entityAPI = await AV.AVEntity.get(entityFK);
        }
    
        if (entityAPI) {
          const updatedEntityData = [...(entitydatalist || []), entityAPI];
          dispatch(setEntitydata(updatedEntityData));
          entity = entityAPI;
        }
      }
    
      return entity;
    };
    
    async function handleUpdateScore(usernewalert) {
      try {
        const gameEntity = await getEntity(usernewalert?.target);
        if (!gameEntity?.leagueGame) return;
    
        //const isStaff = gameEntity?.participants?.some(
        //  (x) =>
        //    x?.id === currentUser?.id &&
        //    (x?.linkType === "Owner" || x?.linkType === "Staff"),
        //);
        //if (isStaff) return;
    
        const leagueGameEntity = await getEntity(
          gameEntity?.leagueGame,
          gameEntity?.scoreType,
        );
        if (!leagueGameEntity) return;
    
        const scoreData = usernewalert?.data?.score
          ? JSON.parse(usernewalert.data.score)
          : null;
    
        if (
          usernewalert?.alertType === "StartGame" ||
          usernewalert?.alertType === "FinishGame"
        ) {
            leagueGameEntity.status = usernewalert.data?.status;
        }
    
        if (
          usernewalert?.alertType === "UpdateScore" &&
          usernewalert?.data?.action === "AddScore"
        ) {
          const alreadyExists =
            leagueGameEntity?.scoreHistory?.some(
              (x) =>
                x?.id ===
                scoreData?.id /* || x?.gameClock === scoreData?.gameClock*/,
            ) ?? false;
    
          leagueGameEntity.score = scoreData;
    
          leagueGameEntity.scoreHistory = alreadyExists
            ? leagueGameEntity?.scoreHistory || []
            : [...(leagueGameEntity?.scoreHistory || []), scoreData];
        } else if (
          usernewalert?.alertType === "UpdateScore" &&
          usernewalert?.data?.action === "DeleteScore"
        ) {
          const newScoreHistory = (leagueGameEntity?.scoreHistory || []).filter(
            (x) => x?.id !== scoreData?.id,
          );
    
          leagueGameEntity.score =
            newScoreHistory[newScoreHistory.length - 1] || null;
    
          leagueGameEntity.scoreHistory = newScoreHistory;
        }
    
        // update redux
        let updatedEntityData = [...(entitydatalist || [])];
        let index = updatedEntityData?.findIndex(
          (x) => x?.id === leagueGameEntity?.id,
        );
    
        if (index !== -1) {
          updatedEntityData[index] = leagueGameEntity;
        } else {
          updatedEntityData.push(leagueGameEntity);
        }
    
        dispatch(setEntitydata(updatedEntityData));
      } catch (err) {
        console.log("handleUpdateScore error", err);
      }
    }

    const {
        showAlertModal,
        setShowAlertModal,
        handleSaveAlert,
        handleAlert,
        showFollowingModal,
        setShowFollowingModal,
        handleDeleteAll,
        Loader,
        setisAcceptAll,
        isAcceptAll,
        isRejectAll,
        setisRejectAll,
        disable,
        handleSetAlert,
    } = useAlerts();

    //Bind Create convo modal
    const {
        textSearchRef,
        mdlCreateConvoVisible,
        setMdlCreateConvoVisible,
        toFK,
        searchInput,
        filteredResults,
        showSearch,
        showFilePicker,
        handleCreateModel,
        searchItems,
        handleSentToProfile,
        handleSendMessage,
        setConvoLoading,
        isLoading,
        handleSubject,
        subject,
        handleMessage,
        handleRemoveItem,
        getImageGalleryFromFilePickerCreateConvo,
        mdlConvoVisible,
        convoSubject,
        setMdlConvoVisible,
        convoPost,
        convo,
        showConvoFilePicker,
        handleGetConvo,
        handleSendConvoMessage,
        replyValue,
        setreplyValue,
        handleChatMessage,
        media,
        value,
        profile,
        Setprofile,
        setValue,
        Loading,
        images,
        setImages,
        isDelete,
        setIsdelete,
        setDeletedImages,
        setUpdateConvoImage,
        setUpdateConvoVideo,
        videoUrls,
        setvideos,
        handleImages,
        handleVoice,
        handleFilePicker,
        onRefresh,
        setSubject,
        settoFK,
        handlePublish,
        setIsHide,
        isHide,
        isImageProcessing,
        setMedia,
        refConvoList,
        setShowConvoFilePicker,
        HandleEditSet,
        handleUpdatePost,
        itemEdit,
        setItemEdit,
        editingImage,
        setEditingImage,
        setConvoPost,
        scrollToMessageWithDelay,
        fetchloading,
        setSearchInput,
        setShowSearch,
        imageInputRef,
        setConvoSubject,
        setConvos,
        typingUserName,
        setIsOpenBox,
        setIsOpenCemera,
        handleOpenPicker,
        setExternalLink,
        HandleAddOneDrive,
        setShowExternalLinkInput,
        showExternalLinkInput,
        HandleAddDropBoxLink,
        isOpenBox,
        isOpenCemera,
        HandleAddExternalUrl,
        handleExternalLink,
        externalLink,
        camera,
        isSetText,
        TriggerOpenConvo,
        setIsTriggerOpenConvo,
        isYoutube,
        setIsYouTube,
        setChatMessage,
        shrink,
        setShrink,
        translateItem,
        handleTranslateText,
        handleShowOriginalText,
        setIsOneDriveData,
        showInsufficientCredits,
        setShowInsufficientCredits,
        scrollRef,
        prevScrollHeightRef,
        prevScrollTopRef,
        loadingOldMessagesRef,
        messagesEndRef,
        setupSignalRConnection,
        cameraMode,
        setCameraMode,
        webcamRef,
        recording,
        setRecording,
        duration,
        setDuration,
        formatDuration,
        toggleMode,
        isCancelledRef,
        handleCameraPhotoCapture,
        handleStartRecording,
        handleStopRecording,
        onClose,
        addLinkLoad,
        setAddLinkLoad,
        editorRef,
        useRichText,
        setUseRichText,
        rteValue,
        setRteValue,
        toolbarOptions,
        isExpanded,
        setIsExpanded,
        setPostPopupExpanded,
        bgColor,
        setBgColor,
        bgImage,
        setBgImage,
        bgImgWidth,
        setBgImgWidth,
        bgImgHeight,
        setBgImgHeight,
        clickedUrl,
        setClickedUrl,
        showConfirmLinkPopup,
        setShowConfirmLinkPopup,
    } = useConvoChat();

    // Calculate length based on itemHeights array
    const getItemLayout = ( data, index ) => ( {
        length: itemHeights[ index ] || 0, // Use itemHeights[index], if available, otherwise default to 0
        offset: itemHeights
            .slice( 0, index )
            .reduce( ( acc, height ) => acc + height, 0 ),
        index,
    } );

    const handleAlertRedirect = async (item: any, type: string = "") => {
      // ---- Mark as viewed ----
      if (item?.actionTaken !== "Viewed") {
        const updatedItem = { ...item, actionTaken: "Viewed" };
    
        setViewedItem(updatedItem);
        handleSaveAlert(updatedItem, "Viewed");
    
        // Remove from unread list
        setUnreadAlertData((prev: any) =>
          prev?.filter((x: any) => x?.id !== updatedItem?.id),
        );
    
        // Update alert list
        const updatedAlerts = _.uniqBy(
          useralertList.map((x: any) =>
            x?.id === updatedItem?.id ? updatedItem : x,
          ),
          "id",
        );
    
        dispatch(setAlerts(updatedAlerts));
      }
    
      const targetType = item?.target?.type;
    
      if (
        ["Club", "School", "SchoolYear", "Alumni", "PlayerOrg"].includes(targetType)
      ) {
        AV.AVEntity.get(item?.target).then(() => {
          navigate(`/season/${item?.target?.id}/${item?.target?.region}`, {
            state: { isCreate: false, team: item?.target },
          });
        });
        return;
      }
    
      // ---- EVENT ----
      if ((targetType === "Event" || (targetType === "Game" /*&& item?.targetObj?.status !== "Started"*/)) && item?.alertType !== "NewLiveStream") {
        AV.AVEntity.get(item?.target).then(() => {
          let newSeriesId = item?.data?.occurId;
          const selectedEvent = currentUser?.events?.filter(
            (x) => x?.id === item?.target?.id,
          );
    
          if (
            selectedEvent !== undefined &&
            (selectedEvent[0]?.linkType === "Meeting" ||
              selectedEvent[0]?.linkType === "Practice")
          ) {
            newSeriesId =
              selectedEvent[0]?.events !== undefined &&
              selectedEvent[0]?.events?.length > 0
                ? selectedEvent[0]?.events[0].id
                : item?.data?.occurId;
          } else {
            newSeriesId = item?.data?.occurId;
          }
    
          navigate(
            `/Events/${item?.target?.id}/${item?.target?.region}/${newSeriesId}`,
            {
              state: { isCreate: false, team: item?.target },
            },
          );
        });
        return;
      }
    
      // ---- STAFF ----
      if (item?.data?.type === "Staff") {
        navigate(`/teams/${item?.target?.id}/${item?.target?.region}`, {
          state: { isCreate: false, team: item?.target },
        });
        return;
      }
    
      // ---- CONVERSATION ----
      if (item?.data?.feed?.type === "Convo" || item?.data?.feed?.type === "GameGroupConvo") {
        messagealert(item);
        return;
      }
    
      // ---- NOT ENOUGH CREDITS ----
      if (item?.alertType === "NotEnoughCredits") {
        let finalEntity =
          item?.target?.type === "Post" ? item?.ownerObj : item?.target;
        if (/*!finalEntity && */ item?.target?.pk === currentUser?.id)
          finalEntity = currentUser;
        if (!finalEntity) return;
    
        navigate(`/accountsettings/${finalEntity?.id}/${finalEntity?.region}`, {
          state: {
            triggerBuyCredits: true,
            page: "MyPlan",
            accountsetting: "HomePage",
            Entity: finalEntity,
          },
        });
    
        //const fk = AV.AVEntity.getFk(finalEntity);
    
        //// Helper: Load Shared Plan Credits
        //const loadSharedPlanCredits = async (entity: AV.IAVEntity) => {
        //  try {
        //    let shared =
        //      entitydatalist?.find((x) => x?.id === entity.plan?.shared?.id) ??
        //      null;
    
        //    if (!shared) {
        //      shared = await AV.AVEntity.getSharedPlan(AV.AVEntity.getFk(entity));
        //      entitydatalist?.push(shared);
        //      dispatch(setEntitydata(entitydatalist));
        //    }
    
        //    setSharedPlan(shared);
        //    setEntity(entity);
        //    setShowCreditsPopup(true);
        //  } catch (e) {
        //    console.error("Failed to load shared plan:", e);
        //  }
        //};
    
        //// NOT EVENT, check shared plan directly
        //if (finalEntity?.type !== "Event") {
        //  if (finalEntity.plan?.shared) {
        //    await loadSharedPlanCredits(finalEntity);
        //  } else {
        //    setEntity(finalEntity);
        //    setShowCreditsPopup(true);
        //  }
        //  return;
        //}
    
        //// EVENT, lookup parent entity
        //try {
        //  let parentEntity =
        //    entitydatalist?.find((x) => x?.id === finalEntity.parent.id) ?? null;
    
        //  if (!parentEntity) {
        //    parentEntity = await AV.AVEntity.get(finalEntity.parent);
        //    entitydatalist?.push(parentEntity);
        //    dispatch(setEntitydata(entitydatalist));
        //  }
    
        //  // Parent Shared Plan?
        //  if (parentEntity.plan?.shared) {
        //    await loadSharedPlanCredits(parentEntity);
        //  } else {
        //    setEntity(parentEntity);
        //    setShowCreditsPopup(true);
        //  }
        //  setEventParentEntity(parentEntity);
        //} catch (error) {
        //  console.error("Failed to load event credits:", error);
        //}
    
        return;
      }
    
      // ---- POSTS ----
      if (
        ["Impression", "PostReply", "PostReview", "NewPost", "UpdatePost"].includes(
          item?.alertType,
        ) ||
        targetType === "Post"
      ) {
        handlePost(item);
        return;
      }
    
      // ---- View Live ----
      if (item?.alertType === "NewLiveStream") {
        const { channelId, token, host, owner, date, status, resourceId, sid } = item?.data || {};
        console.log("Livestream data: ", item?.data);
        dispatch(
          addLiveStream({
            channelId,
            token,
            hostId: owner?.id,
            hostName: owner?.title,
            sid,
          }),
        );

       dispatch(setShowLiveViewer(item?.data));
    
        if (type == "host") {
          if (owner?.type !== "Person" && (owner as AV.ILink)) {
            let entityData =
              entitydatalist?.find((x) => x?.id === owner?.id) ?? null;
    
            if (!entityData) {
              entityData = await AV.AVEntity.get(owner as AV.ILink);
              entitydatalist?.push(entityData);
              dispatch(setEntitydata(entitydatalist));
            }
    
            setEntity(entityData);
            dispatch(setShowLiveHostModal(true));
            dispatch(setLiveEntity(entityData));
          }
        } else {
          dispatch(setShowLiveViewModal(true));
        }

        handleCancelAlert();
        return;
      }
    
      // ---- DEFAULT PROFILE ----
      navigate(`/profile/${item?.target?.id}/${item?.target?.region}`, {
        state: { user: item?.target },
      });
    };

    async function updateUnreadMessages ( item )
    {
        let id = item?.id;
        const UnReadChatMessage = useralertList?.filter(
            ( x : any ) =>
                x?.actionTaken == undefined &&
                x?.data?.feed?.id === id &&
                ( x?.alertType === "NewDM" || x?.alertType === "ReplyDM" )
        );

        if ( UnReadChatMessage?.length > 0 )
        {
            for ( const message of useralertList )
            {
                if (
                    message?.data?.feed?.id === id &&
                    message?.actionTaken !== "Viewed" &&
                    ( message?.alertType === "NewDM" || message?.alertType === "ReplyDM" )
                )
                {
                    message.actionTaken = "Viewed";
                }
            }
            dispatch( setAlerts( useralertList ) );
            for ( let i = 0; i < UnReadChatMessage.length; i++ )
            {
                await Alert.Save( UnReadChatMessage[ i ] );
            }
        }
    }

    const messagealert = async (convo) => {
      const huddleData = currentUser.orgs.filter(
        (x) => x.type === "Channel" && x.data === convo?.data?.feed?.id,
      );
    
      if (huddleData.length > 0) {
        navigate(`/huddles/${huddleData[0]?.id ?? 1}`, {
          state: { HuddleData: huddleData[0] },
        });
      } else if (convo?.data?.feed?.type === "GameGroupConvo") {
        const gameEntity = await getEntity(convo?.data?.feedOwnerOwner);
        const leagueGameEntity = await getEntity(
          gameEntity?.leagueGame,
          gameEntity?.scoreType,
        );
    
        navigate(`/Events/${gameEntity?.id}/${gameEntity?.region}/undefined`, {
          state: { isCreate: false, team: gameEntity },
        });
      } else {
        setShowAlertModal(false);
        //let convoPosts = userconvo?.filter((x) => x?.id == convo?.data?.feed?.id)[0];
        //if (convoPosts === undefined) {
        //  updateUnreadMessages(convo);
        //  setshowunauthorizedDetails(true);
        //  return false;
        //}
    
        updateUnreadMessages(convo);
        props?.setIsOpenConvo(true);
        setShowConvoListModal(true);
        getConvo(convo);
        handleGetConvo(convo);
      }
    };

    const replaceChildrenInParent = (
        postId,
        parentpostId,
        nestedData,
        newChildren
    ) =>
    {
        if ( !nestedData ) {
            return;
        }

        for ( const item of nestedData )
        {
            if ( item.id === parentpostId )
            {
                if ( !item?.children ) item.children = [];
                let val = item.children.filter( ( x ) => x?.id == postId );
                if ( val?.length > 0 )
                    item.children[ item.children.indexOf( val[ 0 ] ) ] = newChildren;
                else item.children.push( newChildren );
                return item;
            }

            if ( item.children && item.children.length > 0 )
            {
                // Continue searching in children
                const updatedChild = replaceChildrenInParent(
                    postId,
                    parentpostId,
                    item.children,
                    newChildren
                );
                if ( updatedChild )
                {
                    return item; // Return the parent with updated children
                }
            }
            if ( item?.galleryPost && item.galleryPost.length > 0 )
            {
                // Continue searching in children
                const updatedChild = replaceChildrenInParent(
                    postId,
                    parentpostId,
                    item.galleryPost,
                    newChildren
                );
                if ( updatedChild )
                {
                    return item; // Return the parent with updated children
                }
            }
        }
        return null; // Parent post not found
    };

    const handlePost = async ( item ) =>
    {
        if ( item?.data?.isConvo )
        {
            let convopost = userconvo?.filter( ( x : any ) => x?.id === item?.target?.pk );
            if ( convopost?.length > 0 )
            {
                if ( convopost[ 0 ]?.owner?.type == "Channel" )
                {
                    let HuddleData : any = currentUser?.orgs?.filter(
                        ( x ) => x?.id == convopost[ 0 ]?.owner?.id
                    );
                    navigate( `/huddles/${ HuddleData[ 0 ]?.id ?? 1 }`, {
                        state: {
                            HuddleData: HuddleData[ 0 ],
                            type: Loc.currentLang.activity.headers.chat
                        },
                    } );
                } else
                {
                    messagealert( convopost[ 0 ] );
                    scrollToMessageWithDelay( item, convopost[ 0 ] );
                }
            }
        } else
        {
            setvalues( item );
            if ( item?.alertType === "PostReply" )
            {
                let post = await AV.Post.get( item?.target );
                let ppost = userFeeds?.filter( ( x ) => x.id == post?.parentPost );
                let replypost = ppost[ 0 ]?.children?.filter(
                    ( x ) => x.id === item?.target?.id
                );
                if ( ppost?.length > 0 )
                {
                    navigate( "/", { state: { previewdata: ppost[ 0 ] } } );
                }
            } else if ( item?.alertType === "Impression" )
            {
                let post = userFeeds?.filter( ( x : any ) => x?.id === item?.target?.id );
                if ( post?.length === 0 || post == undefined )
                {
                    post = await AV.Post.get( item?.target );
                    const updatedParentPost = replaceChildrenInParent(
                        post?.id,
                        post?.parentPost,
                        userFeeds,
                        post
                    );
                    if ( updatedParentPost !== null )
                    {
                        navigate( "/", { state: { previewdata: post } } );
                    }
                } else
                    navigate( "/", {
                        state: { previewdata: post?.length > 0 ? post[ 0 ] : item },
                    } );
            } else
            {
                try
                {
                    let post : any = await AV.Post.get( item?.target );

                    if (
                        ( post?.modStatus === "NR" || post?.modStatus === "AR" ) &&
                        currentUser.id !== post.owner.id
                    )
                    {
                        setshowunauthorizedDetails( true );
                        return false;
                    }

                    if ( post?.gallery?.items?.length > 0 )
                    {
                        for ( var i = 0; i < post?.gallery?.items?.length; i++ )
                        {
                            let parentPost = await AV.Post.get( {
                                id: post?.gallery?.items[ i ],
                                pk: post?.pk,
                                region: post?.region,
                                type: post?.type,
                            } );
                            if ( !post?.galleryPost || post?.galleryPost?.length === 0 )
                                post.galleryPost = [];
                            post.galleryPost.push( parentPost );
                        }
                    }

                    if (item?.alertType === "NewPost" || item?.alertType === "UpdatePost") {
                        const NewPosts = post ? post : item;
                        const isPass = userFeeds?.filter((x) => x?.id === NewPosts?.id)?.length === 0;
                        let previewData = NewPosts;

                        if (isPass) {
                          const updatedFeeds = [NewPosts, ...(userFeeds || [])];
                          dispatch(setFeeds(updatedFeeds));
                          previewData = NewPosts;

                          //if (window.location.pathname == "/") {
                          //    dispatch(setFeedsScrollUpdate(true));
                          //}
                        } else {
                          const findIndex = userFeeds?.findIndex((x) => x?.id === NewPosts?.id);

                          if (findIndex !== -1) {
                            const updatedFeeds = [...userFeeds];

                            updatedFeeds[findIndex] = {
                              ...NewPosts,
                              children: NewPosts?.children ?? updatedFeeds[findIndex]?.children,
                              gallery: NewPosts?.gallery ?? updatedFeeds[findIndex]?.gallery,
                              galleryPost: NewPosts?.galleryPost ?? updatedFeeds[findIndex]?.galleryPost,
                            };

                            //dispatch(setFeeds(updatedFeeds));

                            previewData = updatedFeeds[findIndex];
                          } else {
                            const updatedFeeds = [NewPosts, ...(userFeeds || [])];
                            dispatch(setFeeds(updatedFeeds));
                            previewData = NewPosts;
                          }
                        }

                        navigate("/", {state: { previewdata: previewData }});

                        //setShowPreview(true);
                        //setpreviewitem(post ? post : item);
                    } else
                    {
                        const updatedParentPost = replaceChildrenInParent(
                            post?.id,
                            post?.parentPost,
                            userFeeds,
                            post
                        );
                        navigate( "/", {
                            state: {
                                previewdata:
                                    updatedParentPost != undefined && updatedParentPost != null
                                        ? updatedParentPost
                                        : post,
                            },
                        } );
                    }
                } catch ( error )
                {
                    console.error( "Error during the process:", error );
                    //setshowunauthorizedDetails(true);
                }
            }
        }
        if ( item?.alertType === "Impression" )
        {
            let post = userFeeds?.filter( ( x : any ) => x?.id === item?.target?.id );

            // Check if gallery post impression
            let galleryPostImpression = userFeeds?.filter(
                ( x ) => x.galleryPost?.length > 0
            );

            if ( galleryPostImpression?.length > 0 )
            {
                galleryPostImpression?.some( ( x ) =>
                {
                    return x.galleryPost?.some( ( gPost ) =>
                    {
                        if ( gPost.id === item?.target?.id )
                        {
                            post = userFeeds?.filter( ( y : any ) => y?.id === x.id );
                            return true; // exit inner .some() and then outer .some()
                        }
                        return false;
                    } );
                } );
            }

            if ( post?.length === 0 || post == undefined )
            {
                post = await AV.Post.get( item?.target );
                const updatedParentPost = replaceChildrenInParent(
                    post?.id,
                    post?.parentPost,
                    userFeeds,
                    post
                );
                if ( updatedParentPost )
                {
                    navigate( "/", {
                        state: {
                            previewdata: updatedParentPost ? updatedParentPost : post,
                        },
                    } );
                }
            } else
                navigate( "/", {
                    state: { previewdata: post?.length > 0 ? post[ 0 ] : item },
                } );
        }
        setShowAlertModal( false );
    };

    const onEmojiClick = ( event, emojiObject ) =>
    {
        const newVal = value + emojiObject.emoji;
        setValue( newVal );
        setChatMessage( newVal );
        //setShowEmoji( false );
        setShrink( newVal?.trim()?.length > 0 ? true : false );
    };

    const commentValueRef : any = useRef( null );

    const searchfollowing = async ( val, isrequest ) =>
    {
        if ( isrequest )
        {
            setRequestVal(val);
            let requestval = _.orderBy(
                customUniq( [
                    ...( followRequestData || [] ),
                    ...( currentUser?.requests?.filter(
                        ( x ) => x?.actionTaken === undefined
                    ) || [] ),
                    ...( followreqlist || [] ),
                ] ),
                [ "date" ],
                [ "desc" ]
            );
            setrequestdata(
                requestval?.filter(
                    ( x ) =>
                        ( x?.target?.title !== undefined &&
                            x?.target?.title
                                ?.toLocaleLowerCase()
                                .includes( val.toLocaleLowerCase() ) ) ||
                        ( x?.source?.title !== undefined &&
                            x?.source?.title
                                ?.toLocaleLowerCase()
                                .includes( val.toLocaleLowerCase() ) ) ||
                        ( x?.title !== undefined &&
                            x?.title?.toLocaleLowerCase().includes( val.toLocaleLowerCase() ) )
                )
            );
        } else
        {
            setManageRequestdata(
                currentUser?.follows.filter(
                    ( x ) =>
                        ( x?.target?.title !== undefined &&
                            x?.target?.title
                                ?.toLocaleLowerCase()
                                .includes( val.toLocaleLowerCase() ) ) ||
                        ( x?.title !== undefined &&
                            x?.title?.toLocaleLowerCase().includes( val.toLocaleLowerCase() ) )
                )
            );
        }
    };

    const RenderalertTab = useCallback(
        ( alert ) =>
        {
            let item = alert.item;
            return (
                <VStack>
                    <Pressable
                        _hover={ { backgroundColor: "gray.100" } }
                        width={ "100%" }
                        height={ "104px" }
                        justifyContent={ "center" }
                        onPress={ () =>
                        {
                            handleAlertRedirect( item );
                        } }
                    >
                        <HStack>
                            <HStack width={ "100%" }>
                                { ( item?.alertType === "NewEvent" ||
                                    item?.alertType === "DelResource" ||
                                    item?.alertType === "UpdateResource" ||
                                    item?.alertType === "UpdateEvent" ||
                                    item?.alertType === "CancelEvent" ||
                                    item?.alertType === "CancelEventOccurence" ||
                                    item?.alertType === "UpdateEventOccurence" ||
                                    item?.alertType === "UpdateEventSeries" ||
                                    item?.alertType === "NewEventSeries" ||
                                    item?.alertType === "CancelEventSeries" ||
                                    item?.alertType === "NewResource" ) && (
                                        <>
                                            <HStack space={ "12px" }>
                                            { item?.target?.type === "Person" ? (
                                                <ProfilePic
                                                    width={ "56px" }
                                                    height={ "56px" }
                                                    link={ item?.target }
                                                />
                                            ) : (
                                                <EntityProfilePic
                                                    width={ "56px" }
                                                    height={ "56px" }
                                                    link={ item?.target }
                                                />
                                            )}
                                                <VStack width={ "100%" }>
                                                    <Pressable
                                                        onPress={ () =>
                                                        {
                                                            handleAlertRedirect( item );
                                                            setConvoLoading( false );
                                                            setValue( "" );
                                                        } }
                                                    >
                                                        <Text
                                                            color={ "black" }
                                                            fontSize={ "18px" }
                                                            width={ "80%" }
                                                            fontWeight={ 500 }
                                                            text-overflow={ "ellipsis" }
                                                            numberOfLines={ 1 }
                                                            textTransform={ "capitalize" }
                                                        >
                                                            { item?.target?.title }
                                                        </Text>
                                                    </Pressable>
                                                    <Text
                                                        fontSize={ "16px" }
                                                        color={
                                                            item?.target?.title === "" ||
                                                                item?.target?.title === undefined
                                                                ? "black"
                                                                : "gray.400"
                                                        }
                                                        fontWeight={ 500 }
                                                    >
                                                        { item?.alertType === "NewEvent"
                                                            ? Loc.currentLang.alertType.newEvent
                                                            : item?.alertType === "DelResource"
                                                                ? Loc.currentLang.alertType.delResource
                                                                : item?.alertType === "UpdateResource"
                                                                    ? Loc.currentLang.alertType.updResource
                                                                    : item?.alertType === "UpdateEvent"
                                                                        ? Loc.currentLang.alertType.updateEvent
                                                                        : item?.alertType === "CancelEvent"
                                                                            ? Loc.currentLang.alertType.cancelEvent
                                                                            : item?.alertType === "UpdateEventOccurence"
                                                                                ? Loc.currentLang.menu.updateEventOccurence
                                                                                : item?.alertType === "CancelEventOccurence"
                                                                                    ? Loc.currentLang.menu.cancelEventOccurence
                                                                                    : item?.alertType === "UpdateEventSeries"
                                                                                        ? Loc.currentLang.menu.updateEventSeries
                                                                                        : item?.alertType === "NewEventSeries"
                                                                                            ? Loc.currentLang.menu.newEventSeries
                                                                                            : item?.alertType === "CancelEventSeries"
                                                                                                ? Loc.currentLang.menu.cancelEventSeries
                                                                                                : item?.alertType === "UpdateResource"
                                                                                                   ? Loc.currentLang.menu.updResource
                                                                                                   : Loc.currentLang.alertType.newResource }
                                                    </Text>
                                                    <Text fontSize={ "16px" } color={ "gray.400" }>
                                                        { Moment( item?.date ).fromNow() }..
                                                    </Text>
                                                </VStack>
                                            </HStack>
                                        </>
                                    ) }
                                { ( item?.alertType === "PostReview" ||
                                    item?.alertType === "NewPost" ||
                                    item?.alertType === "UpdatePost" ) && (
                                        <>
                                            <TouchableOpacity
                                                delayPressIn={ 0 }
                                                onPress={ () =>
                                                {
                                                    handleAlertRedirect( item );
                                                } }
                                            >
                                                <HStack space={ "12px" }>
                                                    <EntityProfilePic
                                                        width={ "56px" }
                                                        height={ "56px" }
                                                        link={
                                                            item?.target?.thumb
                                                                ? item?.target
                                                                : item?.data?.feed?.type == "Person"
                                                                    ? item?.data?.person
                                                                    : item?.data?.feed
                                                        }
                                                    />

                                                    <VStack width={ "100%" }>
                                                        <Pressable
                                                            onPress={ () =>
                                                            {
                                                                handleAlertRedirect( item );
                                                            } }
                                                        >
                                                            <Text
                                                                color={ "black" }
                                                                fontSize={ "18px" }
                                                                fontWeight={ 500 }
                                                                text-overflow={ "ellipsis" }
                                                                width={ "80%" }
                                                                numberOfLines={ 1 }
                                                                textTransform={ "capitalize" }
                                                            >
                                                                { item?.data?.feed?.title
                                                                    ? item?.data?.feed?.title
                                                                    : item?.target?.title }
                                                            </Text>
                                                        </Pressable>
                                                        <Text
                                                            fontSize={ "16px" }
                                                            color={
                                                                item?.data?.feed?.title
                                                                    ? item?.data?.feed?.title
                                                                    : item?.target?.title === "" ||
                                                                        item?.data?.feed?.title
                                                                        ? item?.data?.feed?.title
                                                                        : item?.target?.title === undefined
                                                                            ? "black"
                                                                            : "gray.400"
                                                            }
                                                            fontWeight={ 500 }
                                                        >
                                                            { item?.alertType === "PostReview"
                                                                ? Loc.currentLang.alertType.postReview
                                                                : item?.alertType === "NewPost"
                                                                    ? (item?.data?.postObj?.media?.storeId === "ST-USDWLS" || item?.data?.postObj?.media?.storeId === "ST-USTWLS" || item?.data?.postObj?.media?.storeId === "ST-USCWLS")
                                                                    ? Loc.currentLang.alertType.newLivestreamPost : Loc.currentLang.alertType.newPost
                                                                    : item?.alertType === "UpdatePost"
                                                                    ? Loc.currentLang.alertType.updatePost
                                                                        : item?.alertType }
                                                        </Text>
                                                        <Text fontSize={ "16px" } color={ "gray.400" }>
                                                            { Moment( item?.date ).fromNow() }
                                                        </Text>
                                                    </VStack>
                                                </HStack>
                                            </TouchableOpacity>
                                        </>
                                    ) }
                                { ( item?.alertType === "NewDM" ||
                                    item?.alertType === "ReplyDM" ||
                                    item?.alertType === "NewDM-Ward" ||
                                    item?.alertType === "ReplyDM-Ward" ) && (
                                        <>
                                            <TouchableOpacity
                                                delayPressIn={ 0 }
                                                onPress={ () =>
                                                {
                                                    handleAlertRedirect( item );
                                                } }
                                            >
                                            <HStack space={ "12px" }>
                                                <Box
                                                  w="60px"
                                                  h="60px"
                                                  borderRadius="full"
                                                  bg="gray.100"
                                                  alignItems="center"
                                                  justifyContent="center"
                                                  mb={ 4 }
                                                >
                                                  <MessageIcon size={ "34px" } color={ "#32AE78" } />
                                                </Box>

                                                    <VStack width={ "100%" }>
                                                        {/* <Tooltip label={ "New message" } openDelay={ 500 }>*/ }
                                                        <Pressable
                                                            onPress={ () =>
                                                            {
                                                                handleAlertRedirect( item );
                                                            } }
                                                        >
                                                            <Text
                                                                color={ "black" }
                                                                fontSize={ "18px" }
                                                                fontWeight={ 500 }
                                                                width={ "80%" }
                                                                text-overflow={ "ellipsis" }
                                                                numberOfLines={ 1 }
                                                                textTransform={ "capitalize" }
                                                            >
                                                                { item?.alertType === "NewDM"
                                                                    ? Loc.currentLang.message.newMessage
                                                                    : Loc.currentLang.message.replyMessage }
                                                            </Text>
                                                        </Pressable>
                                                        {/*</Tooltip>*/ }
                                                        {(() => {
                                                          const convo = convoListData?.find((x) => x?.id === item?.data?.feed?.id);
                                                          const post = convo?.posts?.find((x) => x?.id === item?.target?.id);
                                                        
                                                          const text = post?.text ?? item?.data?.postObj?.text;
                                                          const isHtml = post?.ptype === "H" || item?.data?.postObj?.ptype === "H";

                                                          if (isHtml)
                                                            return;

                                                          //if (isHtml) {
                                                          //  return (
                                                          //    <div
                                                          //      style={{
                                                          //        fontWeight: 500,
                                                          //        width: "240px",
                                                          //        overflow: "hidden",
                                                          //        whiteSpace: "nowrap",
                                                          //        textOverflow: "ellipsis",
                                                          //        fontSize: "14px",
                                                          //        color: "gray",
                                                          //        maxHeight: "35px"
                                                          //      }}
                                                          //      dangerouslySetInnerHTML={{ __html: text }}
                                                          //    />
                                                          //  );
                                                          //}
                                                        
                                                          return (
                                                            <Text
                                                              fontSize={"14px"}
                                                              color={"gray.400"}
                                                              numberOfLines={1}
                                                              ellipsizeMode="tail"
                                                              style={{ maxWidth: 240 }}
                                                            >
                                                              {text}
                                                            </Text>
                                                          );
                                                        })()}
                                                        <Text fontSize={ "16px" } color={ "gray.400" }>
                                                            { Moment( item?.date ).fromNow() }
                                                        </Text>
                                                    </VStack>
                                                </HStack>
                                            </TouchableOpacity>
                                        </>
                                    ) }
                                { item?.alertType === "PostReply" && (
                                    <>
                                        <TouchableOpacity
                                            delayPressIn={ 0 }
                                            onPress={ () =>
                                            {
                                                handleAlertRedirect( item );
                                            } }
                                        >
                                            <HStack space={ "12px" }>
                                                { item?.data?.person?.type == "Person" ? (
                                                    <ProfilePic
                                                        width={ "56px" }
                                                        height={ "56px" }
                                                        link={
                                                            item?.data?.person
                                                                ? item?.data?.person
                                                                : item?.target?.thumb
                                                                    ? item?.target
                                                                    : item?.data?.source
                                                        }
                                                    />
                                                ) : (
                                                    <EntityProfilePic
                                                        width={ "56px" }
                                                        height={ "56px" }
                                                        link={
                                                            item?.data?.person
                                                                ? item?.data?.person
                                                                : item?.target?.thumb
                                                                    ? item?.target
                                                                    : item?.data?.source
                                                        }
                                                    />
                                                )}

                                                <VStack width={ "100%" }>
                                                    {/* <Tooltip label={ item?.data?.person?.title ? item?.data?.person?.title : item?.data?.source?.title } openDelay={ 500 }>*/ }
                                                    <Pressable
                                                        onPress={ () =>
                                                        {
                                                            handleAlertRedirect( item );
                                                        } }
                                                    >
                                                        <Text
                                                            color={ "black" }
                                                            fontSize={ "18px" }
                                                            width={ "80%" }
                                                            fontWeight={ 500 }
                                                            text-overflow={ "ellipsis" }
                                                            numberOfLines={ 1 }
                                                            textTransform={ "capitalize" }
                                                        >
                                                            { item?.data?.person?.title
                                                                ? item?.data?.person?.title
                                                                : item?.data?.source?.title }
                                                        </Text>
                                                    </Pressable>
                                                    {/* </Tooltip>*/ }
                                                    <Text fontSize={ "16px" } color={ "gray.400" }>
                                                        { item?.data?.source?.type
                                                            ? item?.data?.source?.type
                                                            : Loc.currentLang.alertType.commentsOn }{ " " }
                                                        { item?.data?.isComment
                                                            ? Loc.currentLang.menu.yourComment
                                                            : item?.data?.isConvo
                                                                ? Loc.currentLang.menu.yourMessage
                                                                : Loc.currentLang.menu.yourPost }
                                                    </Text>
                                                    <Text fontSize={ "16px" } color={ "gray.400" }>
                                                        { Moment( item?.date ).fromNow() }
                                                    </Text>
                                                </VStack>
                                            </HStack>
                                        </TouchableOpacity>
                                    </>
                                ) }
                                { item?.alertType === "Impression" && (
                                    <>
                                        <TouchableOpacity
                                            delayPressIn={ 0 }
                                            onPress={ () =>
                                            {
                                                handleAlertRedirect( item );
                                            } }
                                        >
                                            <HStack space={ "12px" }>
                                                { item?.data?.source?.type == "Person" ? (
                                                    <ProfilePic
                                                        width={ "56px" }
                                                        height={ "56px" }
                                                        link={ item?.data?.source }
                                                    />
                                                ) : (
                                                    <EntityProfilePic
                                                        width={ "56px" }
                                                        height={ "56px" }
                                                        link={ item?.data?.source }
                                                    />
                                                )}

                                                <VStack width={ "100%" }>
                                                    {/* <Tooltip label={ item?.data?.person?.title ? item?.data?.person?.title : item?.data?.source?.title } openDelay={ 500 }>*/ }
                                                    <Pressable
                                                        onPress={ () =>
                                                        {
                                                            handleAlertRedirect( item );
                                                        } }
                                                    >
                                                        <Text
                                                            color={ "black" }
                                                            fontSize={ "18px" }
                                                            width={ "80%" }
                                                            fontWeight={ 500 }
                                                            text-overflow={ "ellipsis" }
                                                            numberOfLines={ 1 }
                                                            textTransform={ "capitalize" }
                                                        >
                                                            { item?.data?.person?.title
                                                                ? item?.data?.person?.title
                                                                : item?.data?.source?.title }
                                                        </Text>
                                                    </Pressable>
                                                    {/* </Tooltip>*/ }
                                                    <Text fontSize="16px" color="gray.400">
                                                        { item?.data?.source?.title
                                                            ? `${ item.data.source.title }${ item?.data?.isConvo
                                                                ? Loc.currentLang.menu.reactOnYourMessage
                                                                : Loc.currentLang.menu.reactOnYourPost
                                                            }`
                                                            : "" }
                                                    </Text>
                                                    <Text fontSize={ "16px" } color={ "gray.400" }>
                                                        { Moment( item?.date ).fromNow() }
                                                    </Text>
                                                </VStack>
                                            </HStack>
                                        </TouchableOpacity>
                                    </>
                                ) }

                                {
                                  item?.alertType === "NewLiveStream" && (
                                    <TouchableOpacity
                                      delayPressIn={0}
                                      //onPress={() => handleAlertRedirect(item)}
                                    >
                                      <HStack space={"12px"} alignItems="center">
                                        {/* PROFILE */}
                                        <Box
                                          w="56px"
                                          h="56px"
                                          borderRadius="full"
                                          bg="gray.100"
                                          alignItems="center"
                                          justifyContent="center"
                                        >
                                          <EntityProfilePic
                                            width={"56px"}
                                            height={"56px"}
                                            link={item?.data?.owner}
                                          />
                                        </Box>
                                
                                        {/* CONTENT */}
                                        <VStack flex={1}>
                                          {/*<Pressable onPress={() => handleAlertRedirect(item)}>*/}
                                            <Text
                                              color={"black"}
                                              fontSize={"18px"}
                                              fontWeight={500}
                                              numberOfLines={1}
                                              textTransform={"capitalize"}
                                            >
                                              {item?.data?.owner?.title}
                                            </Text>
                                          {/*</Pressable>*/}
                                
                                          {/* DESCRIPTION */}
                                          <Text fontSize="16px" color="gray.400" numberOfLines={1}>
                                            {item?.data?.owner?.type === "Person"
                                              ? `${Loc.currentLang.alertType.startedLiveStream}`
                                              : `${item?.data?.host?.title} ${Loc.currentLang.alertType.startedLiveStream}`}
                                          </Text>
                                
                                          {/* TIME */}
                                          <Text fontSize={"16px"} color={"gray.400"}>
                                            {Moment(item?.date).fromNow()}
                                          </Text>
                                        </VStack>
                                
                                        {/* ACTION BUTTONS */}
                                        <VStack
                                          space={2}
                                          alignItems="flex-end"
                                          justifyContent="center"
                                        >
                                          {/* WATCH BUTTON */}
                                          <Button
                                            bgColor={"#32AE78"}
                                            width={"80px"}
                                            height={"30px"}
                                            rounded="full"
                                            isLoading={item === Loader?.alert && Loader?.type === "watch"}
                                            onPress={() => handleAlertRedirect(item, "watch")}
                                          >
                                            <Text color={"#ffffff"} fontWeight={400}>
                                              {Loc.currentLang.liveStream.watch}
                                            </Text>
                                          </Button>
                                
                                          {/* HOST BUTTON (ONLY FOR STAFF) */}
                                          {/*{item?.data?.allowHostAccess && (*/}
                                          {/*  <Button*/}
                                          {/*    background={"#32AE78"}*/}
                                          {/*    width={"80px"}*/}
                                          {/*    height={"30px"}*/}
                                          {/*    rounded="full"*/}
                                          {/*    isLoading={item === Loader?.alert && Loader?.type === "host"}*/}
                                          {/*    onPress={() => handleAlertRedirect(item, "host")}*/}
                                          {/*  >*/}
                                          {/*    <Text color={"#ffffff"} fontWeight={400}>*/}
                                          {/*      {Loc.currentLang.liveStream.host || "Host"}*/}
                                          {/*    </Text>*/}
                                          {/*  </Button>*/}
                                          {/*)}*/}
                                        </VStack>
                                      </HStack>
                                    </TouchableOpacity>
                                  )
                                }

                                { item?.alertType !== "PostReview" &&
                                    item?.alertType !== "CancelEvent" &&
                                    item?.alertType !== "NewEvent" &&
                                    item?.alertType !== "DelResource" &&
                                    item?.alertType !== "Impression" &&
                                    item?.alertType !== "UpdateEventOccurence" &&
                                    item?.alertType !== "CancelEventOccurence" &&
                                    item?.alertType !== "UpdateEvent" &&
                                    item?.alertType !== "NewPost" &&
                                    item?.alertType !== "UpdatePost" &&
                                    item?.alertType !== "PostReply" &&
                                    item?.alertType !== "UpdateResource" &&
                                    item?.alertType !== "NewDM" &&
                                    item?.alertType !== "ReplyDM" &&
                                    item?.alertType !== undefined &&
                                    item?.alertType !== "ReplyDM-Ward" &&
                                    item?.alertType !== "EntityUpdate" &&
                                    item?.alertType !== "NewResource" &&
                                    item?.alertType !== "NewDM-Ward" &&
                                    item?.alertType !== "NewLiveStream" && (
                                        <>
                                            <TouchableOpacity
                                                delayPressIn={ 0 }
                                                onPress={ () =>
                                                {
                                                    handleAlertRedirect( item );
                                                } }
                                            >
                                            <HStack space={ "12px" }>
                                                {(
                                                   item?.data?.source?.type === "Person" ||
                                                   item?.target?.type === "Person" ||
                                                   (
                                                     item?.alertType === "NotEnoughCredits" &&
                                                     (
                                                       (item?.target?.type === "Post" &&
                                                         (!item?.ownerObj || item?.ownerObj?.type === "Person")
                                                       ) ||
                                                       item?.target?.type === "Person"
                                                     )
                                                   )
                                                 ) ? (
                                                   <ProfilePic
                                                     width="56px"
                                                     height="56px"
                                                     link={
                                                       item?.alertType === "NotEnoughCredits"
                                                         ? (
                                                             item?.target?.type === "Post" &&
                                                             (!item?.ownerObj || item?.ownerObj?.type === "Person")
                                                           )
                                                             ? item?.ownerObj ?? currentUser
                                                             : item?.target?.type === "Person"
                                                               ? item?.target
                                                               : item?.data?.source ?? item?.target
                                                         : item?.data?.source ?? item?.target
                                                     }
                                                   />
                                                 ) : (
                                                   <EntityProfilePic
                                                     width="56px"
                                                     height="56px"
                                                     link={item?.data?.source ?? item?.target}
                                                   />
                                                 )}

                                                    <VStack width={ "100%" }>
                                                        {/* <Tooltip label={ item?.target?.title } openDelay={ 500 }>*/ }
                                                        <Pressable
                                                            onPress={ () =>
                                                            {
                                                                handleAlertRedirect( item );
                                                            } }
                                                        >
                                                            <Text
                                                                color={ "black" }
                                                                fontSize={ "18px" }
                                                                fontWeight={ 500 }
                                                                width={ "80%" }
                                                                text-overflow={ "ellipsis" }
                                                                numberOfLines={ 1 }
                                                                textTransform={ "capitalize" }
                                                            >
                                                                { item?.target?.title }
                                                            </Text>
                                                    </Pressable>
                                                        {/*</Tooltip>*/ }
                                                        
                                                        <Text
                                                          fontWeight={500}
                                                          color={item?.alertType === "NotEnoughCredits" ? "black" : "gray.400"}
                                                          fontSize={item?.alertType === "NotEnoughCredits" ? "18px" : "16px"}
                                                        >
                                                          {item?.alertType
                                                            ? item?.alertType === "EventSoon"
                                                              ? Loc.currentLang.alertType.eventSoon
                                                              : item?.alertType === "RemoveGuardian"
                                                                ? Loc.currentLang.alertType.removeGuardian
                                                                : item?.alertType === "UnCancelEvent"
                                                                  ? Loc.currentLang.alertType.unCancelEvent
                                                                  : item?.alertType === "UnCancelEventOccurence"
                                                                    ? Loc.currentLang.alertType.unCancelEventOccurence
                                                                    : item?.alertType === "NotEnoughCredits"
                                                                      ? Loc.currentLang.alertType.notEnoughCredits
                                                                      : item?.alertType === "StartGame"
                                                                        ? Loc.currentLang.alertType.startGame
                                                                        : item?.alertType === "FinishGame"
                                                                          ? Loc.currentLang.alertType.finishGame
                                                                          : item?.alertType === "UpdateScore"
                                                                            ? Loc.currentLang.alertType.updateScore
                                                                            : item?.alertType
                                                            : item?.data?.type}{" "}
                                                        </Text>

                                                        <Text color={ "gray.400" } fontSize={ "16px" }>
                                                            { Moment( item?.date ).fromNow() }
                                                        </Text>
                                                    </VStack>
                                                </HStack>
                                            </TouchableOpacity>
                                        </>
                                    ) }
                            </HStack>
                            <HStack alignSelf={ "flex-end" } right={ 10 } bottom={ "8px" }>
                                { ( item?.alertType === "NewRequest" ||
                                    item?.alertType === "NewRequestToStaff" ) &&
                                    item?.actionTaken !== "Accepted" &&
                                    item?.actionTaken !== "Rejected" && (
                                        <VStack space={ 1 } width={ "15%" }>
                                            <Button
                                                p={ 1 }
                                                bgColor={
                                                    item === location?.state?.alert &&
                                                        location?.state?.type === "Accepted"
                                                        ? "AVColor.primary"
                                                        : "#eeeeee"
                                                }
                                                borderRadius={ 50 }
                                                height="max-content"
                                                width="min-content"
                                                margin-left="100%"
                                                isDisabled={ isLoading }
                                                onPress={ () => handleAlert( item, "Accepted" ) }
                                                isLoading={
                                                    item === location?.state?.alert &&
                                                        location?.state?.type === "Accepted"
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <TickIcon size="md" color="#32AE78" />
                                            </Button>
                                            <Button
                                                p={ 1 }
                                                bgColor={
                                                    item === location?.state?.alert &&
                                                        location?.state?.type === "Rejected"
                                                        ? "AVColor.primary"
                                                        : "#eeeeee"
                                                }
                                                borderRadius={ 50 }
                                                height="max-content"
                                                width="min-content"
                                                margin-left="100%"
                                                isDisabled={ isLoading }
                                                onPress={ () => handleAlert( item, "Rejected" ) }
                                                isLoading={
                                                    item === location?.state?.alert &&
                                                        location?.state?.type === "Rejected"
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <CrossIcon size="20px" color="#E02020" />
                                            </Button>
                                        </VStack>
                                    ) }
                            </HStack>
                        </HStack>
                    </Pressable>
                    <Divider />
                </VStack>
            );
        },
        [ allAlertData, unreadAlertData ]
    );

    const handleuserRedirect = async ( profile ) =>
    {
        setShowConvoListModal( false );
        setMdlConvoVisible( false );
        setMdlCreateConvoVisible( false );
        setConvoLoading( false );
        props?.setIsOpenConvo( false );
        navigate( `/profile/${ profile?.id }/${ profile?.region }`, {
            state: { user: profile },
        } );
    };

    const handleClearCache = () =>
    {
        localStorage.clear(); // Clears all local storage data
        sessionStorage.clear(); // Clears all session storage data

        // If using authentication tokens in local storage
        localStorage.removeItem( "AVAuth" );
        localStorage.removeItem( "MediaStore" );
        localStorage.removeItem( "persist:root" );
    };

    const handleLogout = async () =>
    {
        try
        {
            setIsLoader(true);
            if ( deviceFCMToken?.length > 0 )
            {
                await Person.removeFCMToken( deviceFCMToken );
            }

            navigate("/", { state: { isLogout: "true" } });

            await clearCache( false );
            await handleClearCache();
            localStorage.clear();

            console.log( "Log out clearance is done!" );
            setTimeout(() => {
                AVAuth.logout();
            }, 100);
            setIsLoader(false);
        } catch ( error )
        {
            console.error( "Error during logout process:", error );
        }
    };

    const handleMessageIconClick = async () =>
    {
        if ( !showConvoListModal )
        {
            setShowConvoListModal( true );
            setShowAlertModal( false );
            setShowFollowingModal( false );
            setShowProfile( false );

            const hasToken = deviceFCMToken && deviceFCMToken.length > 0;
            const userFCMList = currentUser?.fcm ?? [];

            if (
                hasToken &&
                ( userFCMList.filter( ( x ) => x.token === deviceFCMToken ).length === 0 ||
                    userFCMList.length === 0 )
            )
            {
                AV.Person.addFCMToken( deviceFCMToken );
                getConvo();
            }
        } else
        {
            setShowConvoListModal( false );
            setMdlConvoVisible( false );
            setMdlCreateConvoVisible( false );
            setConvoLoading( false );
            props?.setIsOpenConvo?.( false );
        }
    };

    const list_to_tree = (list: any) => {
      var map: any = {},
        node: any,
        roots: any = [],
        i;
    
      for (i = 0; i < list?.length; i += 1) {
        map[list[i]?.id] = i; // initialize the map
        if (list[i]?.children?.length === 0 || !list[i]?.children)
          list[i]["children"] = []; // initialize the children
        if (list[i]?.galleryPost?.length === 0 || !list[i]?.galleryPost)
          list[i]["galleryPost"] = [];
        list[i]["ReplyPost"] = [];
      }
    
      for (i = 0; i < list?.length; i += 1) {
        node = list[i];
        if (node.parentPost !== undefined) {
          if (
            list[map[node.parentPost]]?.gallery?.items?.filter(
              (x: any) => x === node.id
            )?.length > 0 &&
            node.gallery == undefined
          ) {
            let excitingpost = list[map[node.parentPost]]?.galleryPost?.filter(
              (x: any) => x?.id === node?.id
            );
            if (excitingpost?.length === 0 || excitingpost === undefined)
              list[map[node.parentPost]]?.galleryPost.push(node);
          } else {
            let PPost = list.filter((x: any) => x?.id === node?.parentPost);
            node.ReplyPost.push(PPost[0]);
            roots.push(node);
          }
        } else {
          roots.push(node);
        }
      }
      return roots;
    };

    const getConvo = async (item? : any) =>
    {
        let convovalue : AV.IConversation[] = [];
        let r = 0;
        let person : AV.IPerson = await AV.Person.getSelf();
        let ConvovalList = convoval;

        if (item?.data?.feed?.id) {
          let post = userconvo?.find((x) => x?.id === convo?.id); // Find current convo in userconvo list
          let userPost = post.posts; // Get existing posts

          const param: AV.IFeedParam = {
            feed: item?.data?.feed,
            checkArchive: false,
            startDate: item?.data?.postObj?.lastUpdated
              ? new Date(new Date(item?.data?.postObj?.lastUpdated).getTime() - 30 * 60 * 1000)
              : new Date(0),
            forward: true,
          };
    
          const feedParams: AV.IFeedParam[] = [param];
          const feedsResponse: any = (await AV.Feed.getAllFeeds(
            feedParams
          )) as AV.IConversation[];
    
          feedsResponse[0].privateIds = _.uniqBy(feedsResponse[0].privateIds, "id");
          feedsResponse[0].privateIds = _.orderBy(
            feedsResponse[0].privateIds,
            ["date"],
            ["desc"]
          );
          const group: { [key: string]: AV.IPostListParam } = {};
    
          // Group privateIds by owner/feed ID
          feedsResponse[0].privateIds.forEach(({ id }) => {
            if (!group[item.id]) group[item.id] = { feed: item?.data?.feed, ids: [] };
            (group[item.id].ids as string[]).push(id);
          });
    
          const batched: AV.IPostListParam[] = Object.values(group); // Convert to array
          const flattened = batched.flatMap((group) =>
            (group?.ids ?? []).map((id) => ({
              feed: group.feed,
              id,
            }))
          );
    
          const first20 = flattened.slice(0, 20); // Take only first 20 posts for batching
    
          // Group again for Feed.getAllPosts format
          const groupByFeed = (items: { feed: any; id: string }[]) => {
            const map = new Map<string, { feed: any; ids: string[] }>();
            items.forEach(({ feed, id }) => {
              if (!map.has(feed.id)) {
                map.set(feed.id, { feed, ids: [] });
              }
              map.get(feed.id)!.ids.push(id);
            });
            return Array.from(map.values());
          };
    
          const firstBatch = groupByFeed(first20); // Final grouped format for API
    
          // Fetch posts for first batch
          let fetchPosts = firstBatch.length
            ? await AV.Feed.getAllPosts(firstBatch)
            : [];
    
          // Fetch replies if nested posts exist
          if (fetchPosts && Array.isArray(fetchPosts)) {
            const updatedPostList = await fetchReplyPosts(fetchPosts, firstBatch);
            fetchPosts = updatedPostList;
          }

          let allFeeds = userPost.concat(fetchPosts)
            ? userPost.concat(fetchPosts)
            : fetchPosts; // Combine existing and fetched posts
          allFeeds = _.uniqBy(allFeeds, "id"); // Remove duplicate posts
          allFeeds = list_to_tree(allFeeds); // Convert flat list to tree (for threaded posts)
    
          // Sort posts by createDate descending
          allFeeds = allFeeds.sort((a, b) => {
            const dateA = new Date(a?.createDate).getTime() ?? 0;
            const dateB = new Date(b?.createDate).getTime() ?? 0;
            return dateB - dateA;
          });
    
          feedsResponse[0].posts = allFeeds; // Set updated posts to the convo
    
          userconvo?.push(feedsResponse[0]);
          handleGetConvo(feedsResponse[0]);
          dispatch(setConvo(userconvo));
        }
        else if ( person.convos !== undefined )
        {
            for ( let i = 0; i < person.convos.length; i++ )
            {
                let param : AV.IFeedParam = {
                    feed: person?.convos[ i ],
                    checkArchive: false,
                    startDate: new Date(
                        ConvovalList?.length > 0 ? ConvovalList[ 0 ]?.lastUpdated : 0
                    ),
                    forward: true,
                };

                // Create a function to handle the delay
                const delay = ( ms ) => new Promise( ( resolve ) => setTimeout( resolve, ms ) );

                // eslint-disable-next-line no-loop-func
                let data : any = {
                    Ifeed: param,
                    lasttime: new Date(),
                };
                lastfeed?.push( data );
                dispatch( setLastFeedUpdate( lastfeed ) );
                setlastfeed( lastUpdateFeed );
                await AV.Feed.getFeed( param ).then( ( response : any ) =>
                {
                    let PostList = AV.Feed.getPostList( response );
                    if ( PostList?.length > 0 )
                    {
                        AV.Feed.getPosts(
                            AV.AVEntity.getFk( response ),
                            PostList?.slice( 0, 10 )
                        ).then( ( x : any ) =>
                        {
                            if ( x?.length > 0 )
                            {
                                x.sort( ( a : any, b : any ) =>
                                {
                                    const createDateA = new Date( a.createDate ) as any;
                                    const createDateB = new Date( b.createDate ) as any;
                                    return createDateB - createDateA;
                                } );
                                response.posts = x;
                                if (
                                    response?.posts !== undefined &&
                                    response?.posts?.length > 0
                                )
                                    convovalue.push( response );
                            }
                        } );
                    }
                    r++;
                } );
                if ( person?.convos !== undefined && r === person?.convos?.length )
                {
                    Convoupdate( convovalue, ConvovalList );
                }

                // Add 10 seconds delay
                await delay( 100 );
            }
        }
    };

    const Convoupdate = ( convovalue, ConvovalList ) =>
    {
        if (
            ConvovalList?.length === 0 ||
            ConvovalList === undefined ||
            ConvovalList === null
        )
            ConvovalList = [];
        for ( let i = 0; i < convovalue?.length; i++ )
        {
            let excitingconvo = ConvovalList?.filter(
                ( x ) => x?.id == convovalue[ i ]?.id
            );
            if ( excitingconvo?.length > 0 )
            {
                for ( let j = 0; j < convovalue[ i ]?.posts?.length; j++ )
                {
                    let excitingconvopost = excitingconvo[ 0 ]?.posts?.filter(
                        ( x ) => x?.id === convovalue[ i ]?.posts[ j ]?.id
                    );
                    if ( excitingconvopost?.length === 0 )
                    {
                        excitingconvo[ 0 ]?.posts.push( convovalue[ i ]?.posts[ j ] );
                    }
                }
            } else ConvovalList.unshift( convovalue[ i ] );
        }
        ConvovalList = _.uniqBy( ConvovalList, "id" );
        dispatch( setConvo( ConvovalList ) );
    };

    async function fetchReplyPosts(
      postList: AV.IPost[],
      postsToFetch: AV.IPostListParam[]
    ): Promise<AV.IPost[]> {
      const replyPostIds = postList
        .filter((x) => Array.isArray(x.posts) && x.posts.length > 0) // Only posts with nested replies
        .map((x) => ({ id: x.id, pk: x.pk, posts: x.posts })); // Collect their post IDs and pk
    
      if (replyPostIds.length === 0) return postList; // No replies to fetch
    
      const replyPostListParams: AV.IPostListParam[] = [];
      const uniquePks = [
        ...new Set(
          replyPostIds.map((r) => r.pk).filter((pk): pk is string => !!pk)
        ),
      ]; // Unique pk list
    
      // Match original fetch request with replies using pk
      uniquePks.forEach((pk) => {
        const matchedFeed = postsToFetch.filter((x) => x.feed.pk === pk);
        if (matchedFeed.length > 0) {
          replyPostListParams.push({
            feed: matchedFeed[0].feed,
            ids: replyPostIds.find((x) => x.pk === pk)?.posts || [],
          });
        }
      });
    
      const replyPostList = await AV.Feed.getAllPosts(replyPostListParams); // Fetch reply posts
      return _.uniqBy([...postList, ...replyPostList], "id"); // Merge with original and dedupe
    }

    const HandleRemoveFollowRequestData = ( item ) =>
    {
        setrequestdata( requestdata.filter( ( f : any ) => f?.id != item.id ) );
        setrequestdata1( requestdata.filter( ( f : any ) => f?.id != item.id ) );
        dispatch(
            setFollowRequestData(
                followRequestData.filter( ( f : any ) => f?.id != item.id )
            )
        );
    };

    const handleCancelAlert = () =>
    {
        setShowAlertModal( false );
        setShowFollowingModal( false );
        setShowConvoListModal( false );
        setMdlConvoVisible( false );
        setMdlCreateConvoVisible( false );
        setConvoLoading( false );
        setRequestVal( "" );

        let requestval = _.orderBy(
            customUniq( [
                ...( followRequestData || [] ),
                ...( currentUser?.requests?.filter(
                    ( x ) => x?.actionTaken === undefined
                ) || [] ),
                ...( followreqlist || [] ),
            ] ),
            [ "date" ],
            [ "desc" ]
        );
        setrequestdata(requestval);
    };

    const redirectToApp = () =>
    {
        if ( isMobileDevice )
        {
            const isIOS = /iPad|iPhone|iPod/.test( navigator.userAgent );
            const storeUrl = isIOS ? appStoreUrl : googlePlayUrl;

            if ( isIOS )
            {
                // For iOS
                const appUrl = "actavivo://";

                // Try to open app first
                window.location.href = appUrl;

                // Fallback to App Store after a delay
                setTimeout( () =>
                {
                    const hidden = document.hidden;
                    if ( !hidden )
                    {
                        window.location.href = storeUrl;
                    }
                }, 2000 );
            } else
            {
                // For Android
                const androidIntent =
                    "intent://actavivo.com/#Intent;" +
                    "scheme=actavivo;" +
                    "package=com.actavivo;" +
                    "S.browser_fallback_url=" +
                    encodeURIComponent( storeUrl ) +
                    ";" +
                    "end";
                window.location.href = androidIntent;
            }
        }
    };

    const OpenNotification = () =>
    {
        setShowAlertModal( !showAlertModal );
        setShowFollowingModal( false );
        setShowConvoListModal( false );
        setShowProfile( false );
        setShowBurgerMenu( !showBurgerMenu );
        setShowFollowingModal( false );
        setShowConvoListModal( false );
        setMdlConvoVisible( false );
        setMdlCreateConvoVisible( false );
        setConvoLoading( false );
    };

    const ClearCachedData = () =>
    {
        dispatch( setAlerts( [] ) );
        dispatch( setNewAlerts( [] ) );
        dispatch( setConvo( [] ) );
        dispatch( setFeeds( [] ) );
        dispatch( setPostList( [] ) );
        dispatch( setFetchProcess( [] ) );
        dispatch( setFeedOwners( [] ) );
        dispatch( setFeedsUpdate( false ) );
        dispatch( setFeedsScrollUpdate( false ) );
        dispatch( setLastUpdatedPostDate( null ) );
        dispatch( setFeedsState() );
        dispatch( setRemainingPosts( [] ) );
        dispatch( setProcessedEntityIds( [] ) );
        dispatch( setRemainingEntities( [] ) );
        dispatch( setUser( [] ) );
        dispatch( setDeviceFcmToken( [] ) );
        dispatch( setusersprofile( [] ) );
        dispatch( setuserisguardian( true ) );
        dispatch( setLoginLink( [] ) );
        dispatch( setusersLang( [] ) );
        dispatch( setLocation( [] ) );
        dispatch( setSearch( [] ) );
        dispatch( setEntityToken( [] ) );
        dispatch( setEntitydata( [] ) );
        dispatch( setFollowersData( [] ) );
        dispatch( setFeedsLoad( false ) );
        dispatch( setToastShow( true ) );
        dispatch( setFeedShowing( true ) );
        dispatch( setLastFeedUpdate( [] ) );
        dispatch( setFollowRequestData( [] ) );
        dispatch( setIsNotificationEnabled( true ) );
        dispatch(setIsConvoScreenOpen({ isOpen: false, convoId: null }));
        dispatch( setBackgroundMessage( [] ) );
        dispatch( setConvoOpen( false ) );
        dispatch( setMediaList( [] ) );
    };

    const handleuserchange = async (item) => {
        //setispageLoading(true);
        let val = await Server.impersonate(item, currentUser);
        let val1 = await Server.GetLoginLink();
        await handlePersonData( item, val1 );
        //setispageLoading(false);
    };

    const handlePersonData = async (item: any, val1: any) => {
      try {
        //await persistor.purge();
        const personData = await Person.getSelf(true);
        dispatch(setUser(personData));
        await dispatch(setLoginLink(val1));
        await dispatch(setuserisguardian(false));
        await dispatch(setFeeds([]));
        await dispatch(setFeeds([]));
        await dispatch(setProcessedHomeFeeds([]));
        await dispatch(setAlerts([]));
        await dispatch(setConvo([]));
        navigate( `/profile/${ item?.id }/${ item?.region }`, {
            state: {
                user: {
                    id: item?.id,
                    pk: item?.pk,
                    region: item?.region,
                    type: item?.type,
                    name: item?.title,
                },
            },
        } );

        //navigate("/");
        //await getConvo();
        //await gtalerts();
      } catch (error) {
        console.error('Error fetching person data:', error);
      }
    };

    const handleGuardianChange = async ( item ) =>
    {
        if ( !loginLink?.id )
        {
            await ClearCachedData();
            await dispatch( setFeeds( [] ) );
            await dispatch( setConvo( [] ) );
            await dispatch( setAlerts( [] ) );
            await Server.impersonate( item, currentUser );
            let user = await Server.GetLoginLink();
            dispatch( setLoginLink( user ) );
            dispatch( setuserisguardian( false ) );
        } else
        {
            await Server.impersonate();
            dispatch( setLoginLink( [] ) );
            dispatch( setuserisguardian( true ) );
        }
        setShowProfile( false );
        await AV.Person.getSelf( true ).then( ( x ) => dispatch( setUser( x ) ) );
        navigate( "/" );
        //navigate( `/profile/${ item?.id }/${ item?.region }`, {
        //    state: {
        //        user: {
        //            id: item?.id,
        //            pk: item?.pk,
        //            region: item?.region,
        //            type: item?.type,
        //            name: item?.title,
        //        },
        //    },
        //} )
    };

    const handleAllRequest = async ( type ) =>
    {
        setIsDisable( true );
        if ( type == "Accepted" ) setisAcceptAll( true );
        else setisRejectAll( true );
        for ( var i = 0; i < requestdata.length; i++ )
        {
            await handleAlert(
                requestdata[ i ],
                followRequestData?.filter( ( x ) => x?.id == requestdata[ i ]?.id )?.length >
                    0
                    ? "followback"
                    : type
            );
        }
        if ( type == "Accepted" ) setisAcceptAll( false );
        else setisRejectAll( false );
        setIsDisable( false );
    };

    const handlePress = (item) => {
      setShowFollowingModal(!showFollowingModal);
    
      const target = item?.source || item?.target;
    
      if (!target) return;
    
      if (item?.source?.type === "Channel" && item?.type === "Staff") {
        const huddleData = currentUser.orgs.filter(
          (x) => x.type === "Channel" && x.data === item?.source?.data
        );
    
        if (huddleData.length > 0) {
          navigate(`/huddles/${huddleData[0]?.id ?? 1}`, {
            state: { HuddleData: huddleData[0] },
          });
          return;
        } else {
          navigate(`/profile/${target.id}/${target.region}`, {
            state: {
              user: {
                id: target.id,
                pk: target.pk,
                region: target.region,
                type: target.type,
                name: target.title,
              },
            },
          });
        }
      }

      handleNavigate(item);
      //navigate(`/profile/${target.id}/${target.region}`, {
      //  state: {
      //    user: {
      //      id: target.id,
      //      pk: target.pk,
      //      region: target.region,
      //      type: target.type,
      //      name: target.title,
      //    },
      //  },
      //});
    };

    const handleNavigate = (item: any) => {
      if (
        item?.alertType === "NewRequestToStaff" &&
        item?.data?.type === "Share" &&
        item?.data?.target
      ) {
        navigate(
          `/organizations/${item?.data?.target?.id}/${item?.data?.target?.region}/${item?.data?.target?.type}`,
          {
            state: {
              isCreate: false,
              orgType: item?.data?.target?.type,
              org: item?.data?.target,
            },
          },
        );
      } else if (
        (item?.source?.type === "Club" ||
          item?.source?.type === "School" ||
          item?.source?.type === "Alumni" ||
          item?.source?.type === "SchoolYear" ||
          item?.source?.subType === "Department") &&
        item?.source
      ) {
        navigate(
          `/organizations/${item?.source?.id}/${item?.source?.region}/${item?.source?.type}`,
          {
            state: {
              isCreate: false,
              orgType: item?.source?.type,
              org: item?.source,
            },
          },
        );
      } else if (item?.target?.type === "Club" || item?.target?.type === "School") {
        navigate(
          `/organizations/${item?.target?.id}/${item?.target?.region}/${item?.target?.type}`,
          {
            state: {
              isCreate: false,
              orgType: item?.target?.type,
              org: item?.target,
            },
          },
        );
      } else if (item?.source?.type === "PlayerOrg" && item?.source) {
        navigate(`/season/${item?.source?.id}/${item?.source?.region}`, {
          state: { isCreate: false, team: item?.source },
        });
      } else if (item?.target?.type === "PlayerOrg") {
        navigate(`/season/${item?.target?.id}/${item?.target?.region}`, {
          state: { isCreate: false, team: item?.target },
        });
      } else if (
        (item?.source?.type === "Team" ||
          item?.source?.type === "Organization" ||
          item?.source?.type === "Neighborhood") &&
        item?.source
      ) {
        navigate(`/teams/${item?.source?.id}/${item?.source?.region}`, {
          state: { isCreate: false, team: item?.source },
        });
      } else if (item?.target?.type === "Team") {
        navigate(`/teams/${item?.target?.id}/${item?.target?.region}`, {
          state: { isCreate: false, team: item?.target },
        });
      } else if (item?.source?.type === "Person" || item?.source?.type === "Pet") {
        navigate(`/profile/${item?.source?.id}/${item?.source?.region}`, {
          state: {
            user: {
              id: item?.source?.id,
              pk: item?.source?.pk,
              region: item?.source?.region,
              type: item?.source?.type,
              name: item?.source?.title,
            },
          },
        });
      } else if (item?.target?.type === "profile") {
        navigate(`/profile/${item?.target?.id}/${item?.target?.region}`, {
          state: {
            user: {
              id: item?.target?.id,
              pk: item?.target?.pk,
              region: item?.target?.region,
              type: item?.target?.type,
              name: item?.target?.title,
            },
          },
        });
      } else if (item?.source?.type === "Channel" && item?.type === "Staff") {
        const huddleData = currentUser.orgs.filter(
          (x) => x.type === "Channel" && x.data === item?.source?.data,
        );
    
        if (huddleData.length > 0) {
          navigate(`/huddles/${huddleData[0]?.id ?? 1}`, {
            state: { HuddleData: huddleData[0] },
          });
        } else {
          navigate(`/profile/${item?.target?.id}/${item?.target?.region}`, {
            state: {
              user: {
                id: item?.target?.id,
                pk: item?.target?.pk,
                region: item?.target?.region,
                type: item?.target?.type,
                name: item?.target?.title,
              },
            },
          });
        }
      } else {
        navigate(`/profile/${item?.target?.id}/${item?.target?.region}`, {
          state: {
            user: {
              id: item?.target?.id,
              pk: item?.target?.pk,
              region: item?.target?.region,
              type: item?.target?.type,
              name: item?.target?.title,
            },
          },
        });
      }
    };

    useEffect(() => {
      let isMounted = true;
    
      async function fetchData() {
        if (!isMounted) return;
    
        try {
          console.log("Alert useEffect: ", usernewalert?.alertType);
          switch (usernewalert?.alertType) {
            case "DeletePost":
              if (currentUser?.id !== usernewalert?.target?.id) {
                await getnewOrUpdatedPost();
              } else {
                let post = await AV.Post.get(usernewalert?.target);
                let ppost = userFeeds?.find((x) => x.id === post?.parentPost);
    
                if (ppost) {
                  let finalValue =
                    ppost.children?.filter(
                      (x) => x?.id !== usernewalert?.target?.id
                    ) || [];
    
                  ppost.children = finalValue.length > 0 ? [...finalValue] : [];
                  ppost.posts =
                    finalValue.length > 0
                      ? ppost.posts?.filter((x) => x !== usernewalert?.target?.id)
                      : [];
    
                  userFeeds = userFeeds.map((feed) =>
                    feed.id === ppost.id ? ppost : feed
                  );
                  dispatch(setFeeds(userFeeds));
                }
              }
    
              let index = useralertList?.findIndex(
                (x) => x?.id == usernewalert?.target?.id
              );
              if (index !== -1) {
                useralertList[index].alertType = "DeletePost";
              }
              dispatch(setAlerts(useralertList));
              handleSaveAlert(usernewalert, "deleted");
              break;
            case "ConvoUpdate":
              const feedParam: AV.IFeedParam = {
                feed: {
                  id: usernewalert?.target?.id,
                  pk: usernewalert?.target?.id,
                  region: currentUser?.region,
                  type: "Convo",
                },
                startDate: new Date(0),
                forward: true,
              };
    
              const response: any = await AV.Feed.getFeed(feedParam);
              if (response?.id) {
                /* var userPeople = response?.people?.filter( ( x ) => response?.people?.length === 2 && x.id !== currentUser?.id );*/
                response.people = _.uniqBy(response.people, "id");
                let Index = userconvo?.findIndex((x) => x?.id == response?.id);
                if (userconvo !== -1) {
                  userconvo[Index].people = response?.people;
                  userconvo[Index].enabled = response.enabled;
                  userconvo[Index].subject = response.subject;
                }
                dispatch(setConvo(userconvo));
              }
              break;
            case "NewEvent":
              let excitingfeeds = userFeeds?.filter(
                (x) => x?.owner.id === usernewalert?.target?.id
              );
              let param: AV.IFeedParam = {
                feed: AV.AVEntity.getFk(usernewalert?.target),
                startDate: new Date(
                  excitingfeeds?.length > 0 ? excitingfeeds[0]?.lastUpdated : 0
                ),
                forward: false,
              };
              if (param?.feed?.id) {
                AV.Feed.getFeed(param).then((responsepost: any) => {
                  if (responsepost?.posts && Array.isArray(responsepost.posts)) {
                    let feeds = userFeeds.concat(
                      responsepost.posts.filter((x) => x.status !== "Deleted")
                    );
                    feeds = _.uniqBy(feeds, "id");
                    dispatch(setFeeds(feeds));
                  }
                });
              }
              break;
            case "CancelEvent":
              let userFeedList = userFeeds?.filter(
                (x) => x?.owner?.id !== usernewalert?.target?.id
              );
              dispatch(setFeeds(userFeedList));
              break;
            case "NewPost":
              await getnewOrUpdatedPost();
              break;
            case "UpdatePost":
              await getnewOrUpdatedPost();
              break;
            case "VisChange":
              if (currentUser?.id !== usernewalert?.target?.id) {
                const userfeedsValue = userFeeds?.filter(
                  (x) => x?.id === usernewalert?.target?.id
                );
                if (userfeedsValue?.length > 0) {
                  userFeeds = userFeeds?.filter(
                    (x) => x?.id !== usernewalert?.target?.id
                  );
                  dispatch(setFeeds(userFeeds));
                }
    
                const visChangePrivatePosts = useralertList.filter(
                  (x) =>
                    x.alertType === "VisChange" &&
                    x.data?.postObj?.visibility === "Private"
                );
    
                if (visChangePrivatePosts?.length > 0) {
                  const privatePostIds = visChangePrivatePosts.map(
                    (x) => x.data?.postObj?.id
                  );
                  const updatedUserAlertList = useralertList.filter(
                    (x) => !privatePostIds.includes(x.data?.postObj?.id)
                  );
                  dispatch(setAlerts(updatedUserAlertList));
                }
              }
              await getnewOrUpdatedPost();
              break;
            case "NewRequest":
            case "Follow":
              AV.Person.getSelf(true).then((response) => {
                dispatch(setUser(response));
              });
              break;
            case "UpdateScore":
            case "StartGame":
            case "FinishGame":
              await handleUpdateScore(usernewalert);
              dispatch(setLastScore(usernewalert));
              break;
            case "EntityUpdate":
              if (
                usernewalert?.data !== "AddList" &&
                usernewalert?.data !== "SelfConvoPost" &&
                usernewalert?.data
              ) {
                AV.Person.getSelf(true).then((response: any) => {
                  dispatch(setUser(response));
                  if (usernewalert?.data === "AddFollow") {
                    dispatch(setUser(response));
                    setrequestdata(
                      _.orderBy(
                        customUniq([
                          ...(followRequestData || []),
                          ...(currentUser?.requests?.filter(
                            (x) => x?.actionTaken === undefined
                          ) || []),
                          ...(followreqlist || []),
                        ]),
                        ["date"],
                        ["desc"]
                      )
                    );
                    setrequestdata1(
                      _.orderBy(
                        customUniq([
                          ...(followRequestData || []),
                          ...(currentUser?.requests?.filter(
                            (x) => x?.actionTaken === undefined
                          ) || []),
                          ...(followreqlist || []),
                        ]),
                        ["date"],
                        ["desc"]
                      )
                    );
                    setManageRequestdata(response?.follows);
                    if (response != null) {
                      let i = response?.follows?.length - 1;
                      let item = response?.follows[i];
                      if (window.location.pathname === "/profile/" + item?.id) {
                        navigate(`/profile/${item?.id}/${item?.region}`, {
                          state: {
                            user: {
                              id: item?.id,
                              pk: item?.pk,
                              region: item?.region,
                              type: item?.type,
                              name: item?.title,
                            },
                          },
                        });
                      }
                      let excitingfeeds = userFeeds?.filter(
                        (x) => x?.owner.id === item?.id
                      );
                      if (excitingfeeds?.length === 0) {
                        let param: AV.IFeedParam = {
                          feed: AV.AVEntity.getFk(item),
                          startDate: new Date(0),
                          forward: false,
                        };
                        if (param?.feed?.id) {
                          AV.Feed.getFeed(param).then((responsepost: any) => {
                            if (responsepost) {
                              let feeds = userFeeds.concat(
                                responsepost.posts.filter(
                                  (x) => x.status !== "Deleted"
                                )
                              );
                              dispatch(setFeeds(feeds));
                            }
                          });
                        }
                      }
                    }
                  }
                });
              } else {
                try {
                  const timer = setTimeout(async () => {
                    try {
                      // Fetching the user data
                      const response: any = await AV.Person.getSelf(true);
    
                      // Updating the user conversation
                      if (userconvo?.length > 0) {
                        const updatedUserConvo = userconvo.map((convo) => {
                          const matchingResponseConvo = response.convos.find(
                            (resConvo) => resConvo.id === convo.id
                          );
                          if (matchingResponseConvo) {
                            return {
                              ...convo,
                              subject: matchingResponseConvo.title || convo.subject, // Update subject if a title exists in response.convos
                            };
                          }
                          return convo;
                        });
    
                        // Log the updated conversations
                        console.log(
                          "updatedUserConvo::::::::::::::::::::::",
                          updatedUserConvo
                        );
    
                        // Dispatching updated user conversations
                        dispatch(setConvo(updatedUserConvo));
                      }
                      // Updating the entity data list
                      let index = entitydatalist?.findIndex(
                        (x) => x?.id === response?.id
                      );
                      if (index !== -1) {
                        entitydatalist[index] = response;
                        dispatch(setEntitydata(entitydatalist));
                      }
    
                      // Dispatching updated user data
                      dispatch(setUser(response));
                    } catch (error) {
                      console.error("Error fetching user:", error);
                    }
                  }, 5000);
    
                  // Cleanup function to clear the timeout if the component unmounts
                  return () => clearTimeout(timer);
                } catch (error) {
                  console.error("Error in setTimeout:", error);
                }
              }
              break;
            case "DeleteDM":
              handleConvoDelete(userconvo, usernewalert);
              break;
            case "PostReview":
              getnewOrUpdatedPost();
              break;
            case "PostReply":
              let postreply = await AV.Post.get(usernewalert?.target);
              let ppost = userFeeds?.filter((x) => x.id === postreply?.parentPost);
              if (ppost?.length > 0) {
                if (!ppost[0]?.children) ppost[0].children = [];
                if (!ppost[0]?.posts) ppost[0].posts = [];
                let existingVal = ppost[0]?.children?.filter(
                  (x) => x?.id === postreply?.id
                );
                if (existingVal?.length === 0) {
                  ppost[0].children.unshift(postreply);
                  ppost[0].posts.unshift(postreply?.id);
                  userFeeds[userFeeds.indexOf(ppost[0])] = ppost[0];
                  dispatch(setFeeds(userFeeds));
                  dispatch(setFeedsUpdate(true));
                } else {
                  let index = ppost[0]?.children?.findIndex(
                    (x) => x?.id === postreply?.id
                  );
                  if (index != -1) {
                    ppost[0].children[index] = postreply;
                    ppost[0].children[index].galleryPost =
                      existingVal[0]?.galleryPost;
                    userFeeds[userFeeds.indexOf(ppost[0])] = ppost[0];
                    dispatch(setFeeds(userFeeds));
                    dispatch(setFeedsUpdate(true));
                  }
                }
              } else {
                let parentPost = await AV.Post.get({
                  id: postreply?.parentPost,
                  pk: postreply?.pk,
                  region: postreply?.region,
                  type: postreply?.type,
                });
    
                let ppost1 = userFeeds?.filter(
                  (x) => x.id === parentPost?.parentPost
                );
    
                if (
                  ppost1?.[0]?.galleryPost?.some(
                    (x) => x.id == postreply?.parentPost
                  )
                ) {
                  let pmpost = ppost1[0].galleryPost.find(
                    (x) => x.id == postreply?.parentPost
                  );
    
                  if (!pmpost.children) pmpost.children = [];
                  if (!pmpost.posts) pmpost.posts = [];
    
                  let existingVal = pmpost.children.filter(
                    (x) => x?.id === postreply?.id
                  );
                  if (existingVal.length === 0) {
                    pmpost.children.unshift(postreply);
                    pmpost.posts.unshift(postreply?.id);
    
                    // Update the galleryPost in ppost1[0]
                    ppost1[0].galleryPost = ppost1[0].galleryPost.map((gp) =>
                      gp.id === postreply?.parentPost ? pmpost : gp
                    );
    
                    // Update userFeeds with modified ppost1[0]
                    userFeeds = userFeeds.map((feed) =>
                      feed.id === parentPost?.parentPost ? ppost1[0] : feed
                    );
    
                    dispatch(setFeeds(userFeeds));
                    dispatch(setFeedsUpdate(true));
                  }
                  ppost1 = [];
                }
                if (ppost1?.length > 0) {
                  let replyval = ppost1[0]?.children?.filter(
                    (x) => x?.id === postreply?.parentPost
                  );
                  if (!replyval[0]?.children) replyval[0].children = [];
                  let excitingreply = replyval[0]?.children?.filter(
                    (x) => x?.id === postreply?.id
                  );
                  if (excitingreply?.length === 0) {
                    replyval[0].children.unshift(postreply);
                    replyval[0].posts.unshift(postreply?.id);
                    ppost1[0].children[ppost1[0]?.children.indexOf(replyval[0])] =
                      replyval[0];
                    ppost1[0].posts[ppost1[0]?.posts.indexOf(replyval[0])] =
                      replyval[0];
                    userFeeds[userFeeds.indexOf(ppost1[0])] = ppost1[0];
                    dispatch(setFeeds(userFeeds));
                    dispatch(setFeedsUpdate(true));
                  }
                }
              }
    
              getnewOrUpdatedPost();
              break;
            case "Impression":
              let userFeedsImpression = userFeeds?.filter(
                (x) => x?.id === usernewalert?.target?.id
              );
    
              // If no direct post match, check inside gallery posts
              if (userFeedsImpression?.length === 0) {
                let galleryPostImpression = userFeeds?.filter(
                  (x) => x.galleryPost?.length > 0
                );
    
                if (galleryPostImpression?.length > 0) {
                  galleryPostImpression?.some((post) => {
                    return post.galleryPost?.some((gPost) => {
                      if (gPost.id === usernewalert?.target?.id) {
                        let impression = usernewalert?.data?.source;
                        impression.impression = usernewalert?.data?.type;
    
                        if (!impression.date) {
                          impression.date = usernewalert?.data?.date;
                        }
    
                        // Remove the existing impression with the same ID, if any
                        gPost.impressions = gPost.impressions?.filter(
                          (imp) => imp?.id !== impression?.id
                        );
                        gPost.impressions.unshift(impression);
    
                        let userFeedsPost = userFeeds?.find(
                          (x) => x?.id === post.id
                        );
                        if (userFeedsPost) {
                          userFeeds[userFeeds.indexOf(userFeedsPost)] = post;
                          dispatch(setFeeds(userFeeds));
                          dispatch(setFeedsUpdate(true));
                        }
    
                        return true; // exit inner .some() and then outer .some()
                      }
                      return false;
                    });
                  });
                }
              }
    
              // If a direct post match exists
              if (userFeedsImpression?.length > 0) {
                let impression = usernewalert?.data?.source;
                impression.impression = usernewalert?.data?.type;
    
                if (!impression.date) {
                  impression.date = usernewalert?.data?.date;
                }
    
                // Remove any existing impression with the same ID
                userFeedsImpression[0].impressions =
                  userFeedsImpression[0]?.impressions?.filter(
                    (x) => x.id !== usernewalert?.data?.source?.id
                  );
    
                userFeedsImpression[0].impressions.unshift(impression);
    
                userFeeds[userFeeds.indexOf(userFeedsImpression[0])] =
                  userFeedsImpression[0];
                dispatch(setFeeds(userFeeds));
                dispatch(setFeedsUpdate(true));
              }

              let matchedFeed = NewlyUpdatedPost?.find(
                (x) => x?.posts?.id === usernewalert?.target?.id
              );
              
              if (matchedFeed) {
                let impression = { ...usernewalert?.data?.source };
                impression.impression = usernewalert?.data?.type;
              
                if (!impression.date) {
                  impression.date = usernewalert?.data?.date;
                }
              
                // Remove duplicates by ID
                matchedFeed.posts.impressions = matchedFeed.posts.impressions?.filter(
                  (x) => x.id !== impression.id
                ) || [];
              
                matchedFeed.posts.impressions.unshift(impression);
                dispatch(setNewPosts(NewlyUpdatedPost));
              }

              break;
          }
        } catch (err) {
          console.error("fetchData error:", err);
        }
      }
    
      if (usernewalert) {
        handleSetAlert(usernewalert);
        fetchData();
      }
    
      // Sync block outside fetchData (for requestData, filteredAlerts, etc.)
      if (!isMounted) return;

      followreqlist = useralertList?.filter(
        (x) =>
          x?.actionTaken === undefined &&
          x?.alertType !== "NewRequest" &&
          (x?.data?.type === "Follow" ||
            x?.type === "Follow" ||
            x?.data?.type === "StaffRequest" ||
            x?.type === "StaffRequest" ||
            x?.data?.type === "OrgParent" ||
            x?.type == "OrgParent" ||
            x?.alertType == "NewRequestToStaff"),
      );

      setrequestdata(
        _.orderBy(
          customUniq([
            ...(followRequestData || []),
            ...(currentUser?.requests?.filter(
              (x) => x?.actionTaken === undefined
            ) || []),
            ...(followreqlist || []),
          ]),
          ["date"],
          ["desc"]
        )
      );
      setrequestdata1(
        _.orderBy(
          customUniq([
            ...(followRequestData || []),
            ...(currentUser?.requests?.filter(
              (x) => x?.actionTaken === undefined
            ) || []),
            ...(followreqlist || []),
          ]),
          ["date"],
          ["desc"]
        )
      );

      const filterdatalist = (x: any) =>
        x?.alertType !== "Blocked" &&
        x?.alertType !== "UpdateDM" &&
        x?.alertType !== "DeleteDM" &&
        x?.alertType !== "UnBlocked" &&
        x?.alertType !== "Block" &&
        x?.alertType !== "UnBlock" &&
        x.alertType !== "EntityUpdate" &&
        x.alertType !== "DeletePost" &&
        x?.alertType !== "NewRequest" &&
        x?.alertType !== "Rejected" &&
        x?.wardName === undefined &&
        x?.alertType !== "NewRequestToStaff" &&
        x?.alertType !== "Accepted" &&
        x?.data?.type !== "Follow" &&
        x?.alertType !== "Dependent";
    
      var filteredAlerts = useralertList?.filter((x: any) =>
        loginLink
          ? filterdatalist(x)
          : filterdatalist(x) &&
            x?.alertType !== "NewDM-Ward" &&
            x?.alertType !== "ReplyDM-Ward" &&
            x?.alertType !== "NewRequest-Ward"
      );
      var selfUpdatePost = filteredAlerts?.filter(
        (x: any) =>
          (x?.alertType === "UpdatePost" || x?.alertType === "NewPost") &&
          x?.data?.person?.id === currentUser?.id
      );
      var selfConvo = filteredAlerts.filter(
        (x: any) =>
          x?.alertType === "NewDM" && x?.data?.person?.id === currentUser?.id
      );
      filteredAlerts = filteredAlerts?.filter(
        (item1: any) =>
          !selfUpdatePost?.some((item2: any) => item2?.id === item1?.id)
      );
      filteredAlerts = filteredAlerts?.filter(
        (item1: any) => !selfConvo?.some((item2: any) => item2?.id === item1?.id)
      );
      let unreadAlertData = filteredAlerts?.filter(
        (x: any) => x?.actionTaken === undefined
      );
    
      if (isMounted) {
        setAllAlertData(filteredAlerts);
      }
    
      return () => {
        isMounted = false;
      };
    }, [usernewalert]);

    useEffect( () =>
    {
        if ( commentValueRef.current )
        {
            commentValueRef.current.focus();
        }
    }, [] );

   useEffect(() => {
     let isMounted = true;
   
     if (location?.state?.convovalue) {
       handleGetConvo(location.state.convovalue, true).then(() => {
         if (!isMounted) return;
       });
     }
   
     return () => {
       isMounted = false;
     };
   }, []);

    useEffect( () =>
    {
        setManageRequestdata( currentUser?.follows );
        setrequestdata(
            _.orderBy(
                customUniq( [
                    ...( followRequestData || [] ),
                    ...( currentUser?.requests?.filter(
                        ( x ) => x?.actionTaken === undefined
                    ) || [] ),
                    ...( followreqlist || [] ),
                ] ),
                [ "date" ],
                [ "desc" ]
            )
        );
        setrequestdata1(
            _.orderBy(
                customUniq( [
                    ...( followRequestData || [] ),
                    ...( currentUser?.requests?.filter(
                        ( x ) => x?.actionTaken === undefined
                    ) || [] ),
                    ...( followreqlist || [] ),
                ] ),
                [ "date" ],
                [ "desc" ]
            )
        );
    }, [ currentUser, followRequestData, currentUser?.requests ] );

    const [isRender, setIsRender] = useState(true);
    // Excluded alert types
    const excludedTypes = new Set([
      "Blocked",
      "UpdateDM",
      "DeleteDM",
      "UnBlocked",
      "Block",
      "UnBlock",
      "EntityUpdate",
      "NewRequest",
      "DeletePost",
      "Rejected",
      "NewRequestToStaff",
      "Accepted",
      "Dependent",
      "VisChange",
      "ConvoUpdate",
    ]);
    // Extra excluded types only when loginLink is false
    const excludedWardTypes = new Set([
      "NewDM-Ward",
      "ReplyDM-Ward",
      "NewRequest-Ward",
    ]);
    
    // Clean filter function
    const filterdatalist = (x: any, loginLink: boolean) =>
      !excludedTypes.has(x?.alertType) &&
      (loginLink || !excludedWardTypes.has(x?.alertType)) &&
      x?.wardName === undefined &&
      x?.data?.type !== "Follow";
    
    // Dedupe NotEnoughCredits alerts by target.id and target.pk
    const normalizeNotEnoughCredits = (alerts: any[]) => {
      if (!alerts || alerts.length === 0) return alerts;
    
      const latestById = new Map<string, any>();
      const latestByPk = new Map<string, any>();
    
      alerts.forEach((alert) => {
        if (alert?.alertType !== "NotEnoughCredits") return;
    
        const time = alert?.date ? new Date(alert.date).getTime() : 0;
    
        if (alert?.target?.type !== "Post") {
          const keyId = alert?.target?.id;
          if (!keyId) return;
    
          const existing = latestById.get(keyId);
          const existingTime = existing?.date
            ? new Date(existing.date).getTime()
            : 0;
    
          if (!existing || time > existingTime) {
            latestById.set(keyId, alert);
          }
        } else {
          const keyPk = alert?.target?.pk;
          if (!keyPk) return;
    
          const existing = latestByPk.get(keyPk);
          const existingTime = existing?.date
            ? new Date(existing.date).getTime()
            : 0;
    
          if (!existing || time > existingTime) {
            latestByPk.set(keyPk, alert);
          }
        }
      });
    
      // Remove all NotEnoughCredits
      const nonCreditAlerts = alerts.filter(
        (x) => x?.alertType !== "NotEnoughCredits",
      );
    
      // Merge & dedupe
      const merged = new Map<string, any>();
      [...latestById.values(), ...latestByPk.values()].forEach((a) =>
        merged.set(a.id, a),
      );
    
      const result = [...nonCreditAlerts, ...merged.values()];
    
      // Sort latest first
      return result.sort((a, b) => {
        const ta = a?.date ? new Date(a.date).getTime() : 0;
        const tb = b?.date ? new Date(b.date).getTime() : 0;
        return tb - ta;
      });
    };

    useEffect(() => {
      // Define a new variable and set it to true
      if (useralertList?.length > 0 && isRender) {
        setIsRender(false);
        const filterdatalist = (x) =>
          x?.alertType !== "Blocked" &&
          x?.alertType !== "UpdateDM" &&
          x?.alertType !== "DeleteDM" &&
          x?.alertType !== "UnBlocked" &&
          x?.alertType !== "Block" &&
          x?.alertType !== "UnBlock" &&
          x.alertType !== "EntityUpdate" &&
          x?.alertType !== "NewRequest" &&
          x.alertType !== "DeletePost" &&
          x?.alertType !== "Rejected" &&
          x?.wardName === undefined &&
          x?.alertType !== "NewRequestToStaff" &&
          x?.alertType !== "Accepted" &&
          x?.data?.type !== "Follow" &&
          x?.alertType !== "Dependent" &&
          x?.alertType !== "VisChange" &&
          x?.alertType !== "ConvoUpdate";
    
        // Temp fix
        let newUseralertList = useralertList.filter((item) => !Array.isArray(item));
        let filteredAlerts = newUseralertList?.filter((x) =>
          loginLink
            ? filterdatalist(x)
            : filterdatalist(x) &&
              x?.alertType !== "NewDM-Ward" &&
              x?.alertType !== "ReplyDM-Ward" &&
              x?.alertType !== "NewRequest-Ward",
        );
    
        const selfUpdatePost = filteredAlerts?.filter(
          (x) =>
            ((x?.alertType === "UpdatePost" ||
              x?.alertType === "PostReply" ||
              x?.alertType === "NewPost" ||
              x?.alertType === "Impression") &&
              x?.data?.person?.id === currentUser?.id) ||
            (x?.alertType == "Impression" &&
              x?.data?.source?.id == currentUser?.id),
        );
        filteredAlerts = filteredAlerts?.filter(
          (item1) => !selfUpdatePost?.some((item2) => item2?.id === item1?.id),
        );
    
        const unreadAlertData = filteredAlerts?.filter(
          (x) => x?.actionTaken === undefined,
        );
        const selfConvo = filteredAlerts?.filter(
          (x) =>
            x?.alertType === "NewDM" && x?.data?.person?.id === currentUser?.id,
        );
        const selfConvoReply = filteredAlerts?.filter(
          (x) =>
            x?.alertType === "ReplyDM" && x?.data?.person?.id === currentUser?.id,
        );
    
        let updatedAllAlertData = filteredAlerts?.filter(
          (item1) =>
            !selfConvo.some((item2) => item2?.id === item1?.id) &&
            !selfConvoReply.some((item2) => item2?.id === item1?.id),
        );
        updatedAllAlertData = updatedAllAlertData?.filter(
          (x) => x?.actionTaken === "Viewed",
        );
    
        updatedAllAlertData = normalizeNotEnoughCredits(updatedAllAlertData);
        setAllAlertData(updatedAllAlertData);
    
        let updatedUnreadAlertData = unreadAlertData?.filter(
          (item1) => !selfConvo.some((item2) => item2?.id === item1?.id),
        );
    
        updatedUnreadAlertData = normalizeNotEnoughCredits(updatedUnreadAlertData);
        setUnreadAlertData(updatedUnreadAlertData);
      }
    
      // Set a timeout to update isLoading to false after 5 seconds
      const timeout = setTimeout(() => {
        setIsRender(true);
        console.log("isLoading set to false");
      }, 3000);
    
      // Cleanup the timeout
      return () => clearTimeout(timeout);
    }, [useralertList, currentUser, isConvoScreenOpen]);

    useEffect( () =>
    {
        let img : any = [];
        let videoUrl : any = [];
        let docsUrl : any = [];
        setDeletedImages([]);
        if ( itemEdit?.media ) img.push( itemEdit.media );
        //else if ( itemEdit?.media?.type?.startsWith( 'video' ) ) videoUrl.push( itemEdit.media );
        //else if ( itemEdit?.media?.type?.startsWith( 'application' ) ) docsUrl.push( itemEdit.media );

        itemEdit?.galleryPost?.map( ( item1 ) =>
        {
            if ( item1?.media ) img.push( item1.media );
            //else if ( item1?.media?.type?.startsWith( 'video' ) ) videoUrl.push( item1.media );
            //else if ( item1?.media?.type?.startsWith( 'application' ) ) docsUrl.push( item1.media );
        } );
        if ( img?.length > 0 )
        {
            setShowConvoFilePicker( true );
            setEditingImage( true );
            setImages( img );
        }
        if ( videoUrl?.length > 0 )
        {
            setShowConvoFilePicker( true );
            setEditingImage( true );
            setvideos( videoUrl );
        }
    }, [ itemEdit ] );

    function useOutsideAlerter ( ref )
    {
        useEffect( () =>
        {
            // Alert if clicked on outside of element
            function handleClickOutside ( event )
            {
                if ( ref.current && !ref.current.contains( event.target ) )
                {
                    setShowProfile( false );
                }
            }
            // Bind the event listener
            document.addEventListener( "mousedown", handleClickOutside );
            return () =>
            {
                // Unbind the event listener on clean up
                document.removeEventListener( "mousedown", handleClickOutside );
            };
        }, [ ref ] );
    }

     React.useEffect(() => {
      if (useRichText || postPopupExpanded) {
        document.body.style.overflow = "hidden"; // disable scroll
      } else {
        document.body.style.overflow = "auto"; // enable scroll back
      }
    
      return () => {
        // cleanup to ensure scroll resets if component unmounts
        document.body.style.overflow = "auto";
      };
    }, [useRichText, postPopupExpanded]);

    React.useEffect(() => {
      const closeActiveModalsForLiveStream = async () => {
        if (
          (showLiveHostModal || showLiveViewModal) &&
          (!isHostLiveMinimized || !isViewLiveMinimized)
        ) {
          // Close Follow Request & Notifications
          handleCancelAlert();
          // Close Messenger
          setShowAlertModal(false);
          setShowFollowingModal(false);
          setShowConvoListModal(false);
          setMdlConvoVisible(false);
          setMdlCreateConvoVisible(false);
          setConvoLoading(false);
          props?.setIsOpenConvo?.(false);
          setconvoListData(userconvo);
          await SignalRService.lostFocus();
          dispatch(setIsConvoScreenOpen({isOpen: false, convoId: null}));
        }
      };
    
      closeActiveModalsForLiveStream();
    }, [showLiveHostModal, showLiveViewModal, isHostLiveMinimized, isViewLiveMinimized]);

    return (
        <>
            <VStack
                width={ "100%" }
                backgroundColor={ "#fff" }
                position={ "fixed" }
                shadow={ 1 }
                zIndex={ postPopupExpanded ? -3 : 99 }
                alignItems={ "center" }
            >
                <AVGradientBox />
                <HStack
                    width={ "100%" }
                    maxWidth={ "appMaxWidth" }
                    height={ "80px" }
                    px={ isMobile ? "5px" : "32px" }
                >
                    <HStack
                        alignItems={ "center" }
                        zIndex={ 1 }
                        borderWidth={ 0 }
                        width={ "100%" }
                    >
                        <HStack
                            alignItems={ "center" }
                            space={ "24px" }
                            width={ isMobile ? "49%" : "33%" }
                        >
                            <Logo />
                            <QuickSearch { ...props } />
                        </HStack>
                        { !isDesktopView && (
                            <HStack width={ "33%" } justifyContent={ "center" }>
                                <Menu { ...props } />
                            </HStack>
                        ) }
                        <HStack
                            alignItems={ "center" }
                            justifyContent={ "flex-end" }
                            space={ 3 }
                            borderWidth={ 0 }
                            width={
                                isDesktopView
                                    ? ""
                                    : isMobile
                                        ? "49%"
                                        : isDesktopView && !isMobile
                                            ? ""
                                            : "33%"
                            }
                            position={ isDesktopView ? "absolute" : "relative" }
                            right={ isDesktopView ? 0 : "" }
                        >
                            <UserMenu
                                isMobile={ isMobile }
                                followreqlist={ followreqlist }
                                unreadAlertData={ unreadAlertData }
                                setShowAlertModal={ setShowAlertModal }
                                setShowFollowingModal={ setShowFollowingModal }
                                setShowConvoListModal={ setShowConvoListModal }
                                showProfile={ showProfile }
                                setShowProfile={ setShowProfile }
                                currentUser={ currentUser }
                                showBurgerMenu={ showBurgerMenu }
                                setShowBurgerMenu={ setShowBurgerMenu }
                                showAddinviteModal={ showAddinviteModal }
                                setshowAddinviteModal={ setshowAddinviteModal }
                                personname={ personname }
                                setpersonname={ setpersonname }
                                personEmail={ personEmail }
                                setpersonEmail={ setpersonEmail }
                                personPhone={ personPhone }
                                setpersonPhone={ setpersonPhone }
                                customUniq={ customUniq }
                                requestdata={ requestdata }
                                convoPost={ undefined }
                                showAlertModal={ showAlertModal }
                                setMdlCreateConvoVisible={ setMdlCreateConvoVisible }
                                setMdlConvoVisible={ setMdlConvoVisible }
                                setConvoLoading={ setConvoLoading }
                                followRequestData={ followRequestData }
                                ClearCachedData={ ClearCachedData }
                                handleMessageIconClick={ handleMessageIconClick }
                                setIsOpenConvo={ props?.setIsOpenConvo }
                                isLoader={ isLoader }
                                setIsLoader={ setIsLoader }
                                isConfirmLogout={ isConfirmLogout }
                                setIsConfirmLogout={ setIsConfirmLogout }
                            />
                        </HStack>
                    </HStack>

                    {/*  menu on smaller screen sizes */ }
                    { isDesktopView && (
                        <div
                            style={ {
                                position: "fixed",
                                bottom: "env(safe-area-inset-bottom)",
                                left: 0,
                                right: 0,
                                width: "100vw", // or '100%' based on preference
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: isDesktopView ? "#32AE78" : "white",
                                borderTopWidth: "0.5px",
                                borderTopStyle: "solid",
                                borderTopColor: "rgb(0, 167, 188)",
                                transition: "0.5s",
                                WebkitTransform: "translateZ(0)",
                            } }
                        >
                            <Menu />
                        </div>
                    ) }
                </HStack>
            </VStack>

            { isOpen && isMobileDevice && toastShow && (
                <VStack
                    paddingY={ "10px" }
                    position={ "fixed" }
                    top={ "84px" }
                    backgroundColor={ "white" }
                    shadow={ 5 }
                    borderRadius={ "10px" }
                    width={ "100%" }
                    zIndex={ 999 }
                >
                    <HStack marginLeft={ "10px" } space={ 3 }>
                        <Box position={ "absolute" }>
                            <img src={ LogoSvg } height={ "45px" } width={ "45px" } />
                        </Box>
                        <Text
                            marginLeft={ "45px" }
                            width={ "55%" }
                            fontSize={ "14" }
                            fontWeight={ "medium" }
                            numberOfLines={ 2 }
                        >
                            { Loc.currentLang.landingPage.appdescription
                                ? Loc.currentLang.landingPage.appdescription
                                : "Actavivo:Download the mobile app for the best experience!" }
                        </Text>
                        <Button
                            marginRight={ "10px" }
                            bgColor={ "AVColor.primary" }
                            onPress={ redirectToApp }
                        >
                            { Loc.currentLang.landingPage.openApp
                                ? Loc.currentLang.landingPage.openApp
                                : "Open" }
                        </Button>
                        <Pressable
                            padding={ 1.5 }
                            rounded={ "full" }
                            position={ "absolute" }
                            right={ "3px" }
                            top={ -7 }
                            zIndex={ 999 }
                            _hover={ { backgroundColor: "AVColor.hovercolor2" } }
                            backgroundColor={ "AVColor.buttonBg" }
                            onPress={ () =>
                            {
                                setIsOpen( false );
                                dispatch( setToastShow( false ) );
                            } }
                        >
                            <CloseIcon size={ "10px" } color={ "AVColor.secondaryText" } />
                        </Pressable>
                    </HStack>
                </VStack>
            ) }

            {/* Following Request Screen */ }
            { showFollowingModal && (
                <Box
                    position={ [ "fixed" ] }
                    top={ [ `${ 83 - 1 }px` ] }
                    right={ [ 0 ] }
                    w={ isMobile ? "100%" : "460px" }
                    h={ "100vh" }
                    bgColor={ [ "AVColor.white" ] }
                    shadow={ [ 10 ] }
                    borderColor={ "AVColor.grey" }
                    borderWidth={ 1 }
                    zIndex={ [ 100 ] }
                >
                    <VStack padding={ "24px" } h={ "100%" } position={ "relative" }>
                        <HStack justifyContent={ "space-between" }>
                            <Text fontSize={ 24 } fontWeight={ 400 }>
                                { Loc.currentLang.menu.followingRequest }
                            </Text>
                            <HStack alignItems={ [ "center" ] } space={ "32px" }>
                                <AVCancel
                                    callback={ handleCancelAlert }
                                    color={ undefined }
                                    size={ undefined }
                                />
                            </HStack>
                        </HStack>
                        <VStack h={ "100%" } flex={ 1 } zIndex={ -1 }>
                            <Input
                                borderWidth={ 0 }
                                placeholder={
                                    isrequest
                                        ? Loc.currentLang.menu.searchRequests
                                        : Loc.currentLang.menu.searchFollowers
                                }
                                variant="AVSearchInput"
                                backgroundColor={ "#F5F5F5" }
                                marginTop={ "24px" }
                                borderRadius={ "22px" }
                                fontSize={ "16px" }
                                width={ [ "100%" ] }
                                height={ "44px" }
                                value={searchRequestVal}
                                InputLeftElement={
                                    <SearchIcon
                                        ml="2"
                                        size="24px"
                                        color="#000"
                                        left={ "10px" }
                                        p={ "7px" }
                                    />
                                }
                                InputRightElement={
                                  searchRequestVal ? (
                                    <IconButton
                                      icon={<CloseIcon size="xs" />}
                                      size="sm"
                                      variant="AVSearchInput"
                                      onPress={() => {
                                        setRequestVal("");
                                        searchfollowing("", isrequest )
                                      }}
                                      _hover={{ bg: "transparent" }}
                                    />
                                  ) : undefined
                                }
                                onChangeText={ ( e ) => searchfollowing( e, isrequest ) }
                            />

                            <VStack marginTop={ "10px" }>
                                { isrequest && (
                                    <ScrollView showsHorizontalScrollIndicator={ false }>
                                        <Box overflowY={ "scroll" } h={ dimensions.height - 310 }>
                                            { requestdata?.length === 0 ? (
                                                <HStack
                                                    alignItems={ "center" }
                                                    justifyContent={ "center" }
                                                    marginTop={ "50px" }
                                                >
                                                    <Text>{ Loc.currentLang.menu.noRequestFound }</Text>
                                                </HStack>
                                            ) : (
                                            requestdata?.map( ( item, i ) =>
                                            {
                                                Link.getTummb(
                                                    item?.data?.source,
                                                    item?.data?.source?.thumb
                                                );
                                                Link.getTummb(
                                                    item?.source ? item?.source : item?.target,
                                                    item?.source?.thumb
                                                        ? item?.source?.thumb
                                                        : item?.target?.thumb
                                                );
                                                return (
                                                    <HStack
                                                        borderBottomWidth={ 1 }
                                                        borderBottomColor={ "gray.400" }
                                                        key={ i }
                                                        height={ "125px" }
                                                    >
                                                        {followRequestData?.some((x) => x?.id === item?.id) ? (
                                                                    <Pressable
                                                                        height={ "100%" }
                                                                        padding={ "24px" }
                                                                        _hover={ { backgroundColor: "gray.100" } }
                                                                        width={ "100%" }
                                                                        onPress={ () =>
                                                                        {
                                                                            navigate(
                                                                                `/profile/${ item?.id }/${ item?.region }`,
                                                                                {
                                                                                    state: {
                                                                                        user: {
                                                                                            id: item?.id,
                                                                                            pk: item?.pk,
                                                                                            region: item?.region,
                                                                                            type: item?.type,
                                                                                            name: item?.title,
                                                                                        },
                                                                                    },
                                                                                }
                                                                            );
                                                                            setShowFollowingModal( !showFollowingModal );
                                                                        } }
                                                                    >
                                                                        <HStack>
                                                                            <EntityProfilePic
                                                                                width={ "56px" }
                                                                                height={ "56px" }
                                                                                link={ item }
                                                                            />
                                                                            <VStack left={ "24px" } width={ "70%" }>
                                                                                <Pressable>
                                                                                    <Text
                                                                                        color={ "black" }
                                                                                        fontWeight={ 500 }
                                                                                        numberOfLines={ 1 }
                                                                                        width={ "200px" }
                                                                                        fontSize={ "18px" }
                                                                                        text-overflow={ "ellipsis" }
                                                                                    >
                                                                                        { item?.title }
                                                                                    </Text>
                                                                                </Pressable>
                                                                                <HStack left={ 0 } top={ "20px" } space={ 5 }>
                                                                                    <Button
                                                                                        bgColor={ "#32AE78" }
                                                                                        width={ "120px" }
                                                                                        height={ "40px" }
                                                                                        paddingRight={ "20px" }
                                                                                        paddingLeft={ "20px" }
                                                                                        rounded="full"
                                                                                        isLoading={
                                                                                            item === Loader?.alert &&
                                                                                                Loader?.type === "followback"
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                        onPress={ () =>
                                                                                            handleAlert( item, "followback" )
                                                                                        }
                                                                                    >
                                                                                        <Text
                                                                                            color={ "#ffffff" }
                                                                                            fontWeight={ 500 }
                                                                                        >
                                                                                            {Loc.currentLang.follow.followback}
                                                                                        </Text>
                                                                                    </Button>
                                                                                    <Button
                                                                                        background={ "#EEEEEE" }
                                                                                        width={ "120px" }
                                                                                        paddingRight={ "20px" }
                                                                                        paddingLeft={ "20px" }
                                                                                        height={ "40px" }
                                                                                        rounded="full"
                                                                                        onPress={ () =>
                                                                                            HandleRemoveFollowRequestData( item )
                                                                                        }
                                                                                    >
                                                                                        <Text
                                                                                            color={ "rgba(0, 0, 0, 0.50)" }
                                                                                            fontWeight={ 500 }
                                                                                        >
                                                                                            {Loc.currentLang.menu.close}
                                                                                        </Text>
                                                                                    </Button>
                                                                                </HStack>
                                                                            </VStack>
                                                                        </HStack>
                                                                    </Pressable>
                                                           ) : (
                                                                <Pressable
                                                                    height={ "100%" }
                                                                    padding={ "24px" }
                                                                    _hover={ { backgroundColor: "gray.100" } }
                                                                    width={ "100%" }
                                                                    onPress={() => handleNavigate(item)}
                                                                >
                                                                    <HStack>
                                                                        <Box
                                                                          w="56px"
                                                                          h="56px"
                                                                          borderRadius="full"
                                                                          bg="gray.100"
                                                                          alignItems="center"
                                                                          justifyContent="center"
                                                                          mb={4}
                                                                        >
                                                                            <EntityProfilePic
                                                                                width={ "56px" }
                                                                                height={ "56px" }
                                                                                link={
                                                                                  item?.alertType === "NewRequestToStaff" &&
                                                                                  item?.data?.type === "Share" &&
                                                                                  item?.data?.target
                                                                                    ? item.data.target
                                                                                    : item?.source || item?.target
                                                                                }
                                                                            />
                                                                        </Box>     
                                                                        <VStack left={ "24px" } width={ "70%" }>
                                                                            <Pressable
                                                                                onPress={ () => handlePress( item ) }
                                                                            >
                                                                                <Text
                                                                                  color="black"
                                                                                  fontWeight={500}
                                                                                  numberOfLines={1}
                                                                                  width="200px"
                                                                                  fontSize="18px"
                                                                                  isTruncated
                                                                                >
                                                                                  {item?.alertType === "NewRequestToStaff" &&
                                                                                  item?.data?.type === "Share" &&
                                                                                  item?.data?.target
                                                                                    ? item.data.target.data || item.data.target.title
                                                                                    : item?.source?.type === "Channel"
                                                                                      ? item?.source?.title
                                                                                      : item?.source?.data || item?.source?.title || item?.target?.title}
                                                                                </Text>
                                                                            </Pressable>
                                                                            { 
                                                                              ( 
                                                                                (item?.data?.type === "Member" || item?.type === "Member") &&
                                                                                (item?.source?.type === "Person" || item?.source?.type === "Pet")
                                                                              ) ? (
                                                                                <Text
                                                                                    color={ "rgba(0, 0, 0, 0.50)" }
                                                                                    fontSize={ "16px" }
                                                                                    fontWeight={ 400 }
                                                                                >
                                                                                    { Loc?.currentLang?.alertType?.friendreq }
                                                                                </Text>
                                                                            ) : (
                                                                                <Text
                                                                                    color={ "rgba(0, 0, 0, 0.50)" }
                                                                                    width={ "190px" }
                                                                                    numberOfLines={ 1 }
                                                                                    fontSize={ "16px" }
                                                                                    fontWeight={ 400 }
                                                                                >
                                                                                    { ( () =>
                                                                                    {
                                                                                        // Check if item.data.reason exists
                                                                                        if ( item?.data?.reason )
                                                                                            return item?.data?.reason;

                                                                                        // Handle 'NewRequestToStaff' alertType and 'Follow' type
                                                                                        if (
                                                                                            item?.alertType ===
                                                                                            "NewRequestToStaff" &&
                                                                                            item?.data?.type === "Follow"
                                                                                        )
                                                                                        {
                                                                                            const subType =
                                                                                                item?.data?.target?.subType ==
                                                                                                    "MusicGroup"
                                                                                                    ? "Performan"
                                                                                                    : item?.data?.target?.subType;
                                                                                            const targetType =
                                                                                                item?.data?.target?.type;
                                                                                            return `Follow ${ subType ||
                                                                                                ( targetType === "PlayerOrg" &&
                                                                                                    !subType
                                                                                                    ? "Season"
                                                                                                    : targetType == "Club"
                                                                                                        ? "Elite Club"
                                                                                                        : targetType )
                                                                                                }`;
                                                                                        }

                                                                                        // Handle 'NewRequestToStaff' alertType and 'Joins' type
                                                                                        if (
                                                                                            item?.alertType ===
                                                                                            "NewRequestToStaff" &&
                                                                                            item?.data?.type === "Joins"
                                                                                        )
                                                                                        {
                                                                                            return `${Loc.currentLang.menu.requesToJoinYour} ${ item?.data?.target?.type }`;
                                                                                        }

                                                                                        // Fallback to item.type if available
                                                                                        if (item?.type) {
                                                                                          if (item.type === "Staff" && item?.source?.subType === "Term" && item.source.type === "PlayerOrg") {
                                                                                            return Loc.currentLang.menu.director;
                                                                                          } else if (item.type === "Staff" && item.source.type === "School") {
                                                                                            return Loc.currentLang.menu.administration;
                                                                                          } else if (item.type === "Staff") {
                                                                                            return Loc.currentLang.menu.staff;
                                                                                          } else if (item.type === "AddDependent") {
                                                                                            return Loc.currentLang.alertType.addDependent;
                                                                                          } else if (item?.source?.subType === "Term" && item.source.type === "PlayerOrg") {
                                                                                            return Loc.currentLang.menu.member;
                                                                                          } else if (item.type === "Player" && (item?.source?.subType === "Class" || item?.source?.subType === "GradClass") && item.source.type === "PlayerOrg") {
                                                                                            return Loc.currentLang.menu.student;
                                                                                          } else if (item.type === "Member" && (item?.source?.subType === "Class" || item?.source?.subType === "GradClass") && item.source.type === "PlayerOrg") {
                                                                                            return Loc.currentLang.menu.parent;
                                                                                          } else if (item.type === "Member" && item?.source?.type === "Organization") {
                                                                                            return Loc.currentLang.menu.employee;
                                                                                          } else if (item.type === "Member" && item.source.type === "Neighborhood") {
                                                                                            return Loc.currentLang.menu.neighbor;
                                                                                          } else if (item.type === "Member" && item.source.type === "School") {
                                                                                            return Loc.currentLang.menu.staff;
                                                                                          } else {
                                                                                              return item.type;
                                                                                          }
                                                                                        }

                                                                                        // Fallback to item.data.reason or 'Join Member'
                                                                                        return (
                                                                                            item?.data?.reason ||
                                                                                            ( item?.data?.type === "Join"
                                                                                                ? "Join Member"
                                                                                                : item?.data?.type )
                                                                                        );
                                                                                    } )() }{ " " }
                                                                                    { item?.alertType === "NewRequestToStaff" && item?.data?.type !== "Share"
                                                                                        ? ""
                                                                                        : Loc.currentLang.menu.request }
                                                                                </Text>
                                                                            ) }
                                                                            <Text
                                                                                color={ "rgba(0, 0, 0, 0.50)" }
                                                                                fontSize={ "16px" }
                                                                                fontWeight={ 400 }
                                                                            >
                                                                                { Moment( item?.date ).fromNow() }
                                                                            </Text>
                                                                        </VStack>
                                                                        <VStack space={ 1 } width={ "15%" }>
                                                                            <Button
                                                                                p={ "8px" }
                                                                                bgColor={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Accepted" ) ||
                                                                                        isAcceptAll
                                                                                        ? "AVColor.primary"
                                                                                        : "#eeeeee"
                                                                                }
                                                                                borderRadius={ 50 }
                                                                                height="max-content"
                                                                                width="min-content"
                                                                                margin-left="100%"
                                                                                isDisabled={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Accepted" ) ||
                                                                                        isAcceptAll ||
                                                                                        isLoading
                                                                                        ? true
                                                                                        : false ||
                                                                                            ( item === Loader?.alert &&
                                                                                                Loader?.type === "Rejected" ) ||
                                                                                            isRejectAll ||
                                                                                            isLoading
                                                                                            ? true
                                                                                            : false
                                                                                }
                                                                                isLoading={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Accepted" ) ||
                                                                                        isAcceptAll
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                onPress={ () =>
                                                                                    handleAlert( item, "Accepted" )
                                                                                }
                                                                            >
                                                                                <TickIcon size="25px" color="#32AE78" />
                                                                            </Button>

                                                                            <Button
                                                                                p={ "8px" }
                                                                                bgColor={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Rejected" ) ||
                                                                                        isRejectAll
                                                                                        ? "AVColor.primary"
                                                                                        : "#eeeeee"
                                                                                }
                                                                                borderRadius={ 50 }
                                                                                isDisabled={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Accepted" ) ||
                                                                                        isAcceptAll ||
                                                                                        isLoading
                                                                                        ? true
                                                                                        : false ||
                                                                                            ( item === Loader?.alert &&
                                                                                                Loader?.type === "Rejected" ) ||
                                                                                            isRejectAll ||
                                                                                            isLoading
                                                                                            ? true
                                                                                            : false
                                                                                }
                                                                                height="max-content"
                                                                                width="min-content"
                                                                                margin-left="100%"
                                                                                isLoading={
                                                                                    ( item === Loader?.alert &&
                                                                                        Loader?.type === "Rejected" ) ||
                                                                                        isRejectAll
                                                                                        ? true
                                                                                        : false
                                                                                }
                                                                                onPress={ () =>
                                                                                    handleAlert( item, "Rejected" )
                                                                                }
                                                                            >
                                                                                <CrossIcon size="25px" color="#E02020" />
                                                                            </Button>
                                                                        </VStack>
                                                                    </HStack>
                                                                </Pressable>
                                                            ) }
                                                    </HStack>
                                                );
                                            } )
                                            ) }
                                        </Box>
                                    </ScrollView>
                                ) }

                                { requestdata?.length > 0 && (
                                    <HStack
                                        justifyContent={ "center" }
                                        space={ "16px" }
                                        marginTop={ "20px" }
                                    >
                                        <Button
                                            backgroundColor={ "#32AE78" }
                                            rounded={ "full" }
                                            height={ "40px" }
                                            width={ "45%" }
                                            isDisabled={ isDisable ? isDisable : disable }
                                            isLoading={ isAcceptAll }
                                            onPress={ () => handleAllRequest( "Accepted" ) }
                                        >
                                            <HStack flexDirection={ "row" } space={ 2 }>
                                                <TickIcon size="25px" color="white" />
                                                <Text color={ "white" } fontSize={ "16px" }>
                                                    { Loc.currentLang.menu.acceptAll }
                                                </Text>
                                            </HStack>
                                        </Button>
                                        <Button
                                            backgroundColor={ isRejectAll ? "#32AE78" : "#EEEEEE" }
                                            rounded={ "full" }
                                            height={ "40px" }
                                            isLoading={ isRejectAll }
                                            width={ "45%" }
                                            isDisabled={ isDisable ? isDisable : disable }
                                            onPress={ () => handleAllRequest( "Rejected" ) }
                                        >
                                            <HStack flexDirection={ "row" } space={ 2 }>
                                                <CrossIcon size="25px" color="#FA6400" />
                                                <Text color={ "rgba(0,0,0,0.5)" } fontSize={ "16px" }>
                                                    { Loc.currentLang.menu.rejectAll }
                                                </Text>
                                            </HStack>
                                        </Button>
                                    </HStack>
                                ) }

                                { ismanagerequest && (
                                    <>
                                        <ScrollView showsHorizontalScrollIndicator={ false }>
                                            <Box
                                                h={ dimensions.height - 200 }
                                                overflowY={ "auto" }
                                                top={ 3 }
                                            >
                                                { managerequestdata?.map( ( item : any, i ) => (
                                                    <Pressable
                                                        key={ item.id + i }
                                                        padding={ "10px" }
                                                        onPress={ () =>
                                                        {
                                                            navigate( `/profile/${ item?.id }/${ item?.region }`, {
                                                                state: {
                                                                    user: {
                                                                        id: item?.id,
                                                                        pk: item?.pk,
                                                                        region: item?.region,
                                                                        type: item?.type,
                                                                        name: item?.title,
                                                                    },
                                                                },
                                                            } );
                                                        } }
                                                    >
                                                        <Box padding="3px" key={ item.id + i }>
                                                            <HStack space={ 2 }>
                                                                <ProfilePic
                                                                    width={ 35 }
                                                                    height={ 35 }
                                                                    link={ item }
                                                                />
                                                                <VStack>
                                                                    <Tooltip label={ item.title } openDelay={ 500 }>
                                                                        <Pressable
                                                                            onPress={ () =>
                                                                            {
                                                                                navigate(
                                                                                    `/profile/${ item?.id }/${ item?.region }`,
                                                                                    {
                                                                                        state: {
                                                                                            user: {
                                                                                                id: item?.id,
                                                                                                pk: item?.pk,
                                                                                                region: item?.region,
                                                                                                type: item?.type,
                                                                                                name: item?.title,
                                                                                            },
                                                                                        },
                                                                                    }
                                                                                );
                                                                            } }
                                                                        >
                                                                            <Text
                                                                                fontWeight="bold"
                                                                                numberOfLines={ 1 }
                                                                                width={ "250px" }
                                                                            >
                                                                                { item.title }
                                                                            </Text>
                                                                        </Pressable>
                                                                    </Tooltip>
                                                                    <Text
                                                                        fontSize={ "12px" }
                                                                        numberOfLines={ 2 }
                                                                        width={ "250px" }
                                                                    >
                                                                        { item.blurb }
                                                                    </Text>
                                                                </VStack>

                                                                <Button
                                                                    p={ 1 }
                                                                    bgColor={
                                                                        item === unfollowLoader
                                                                            ? "AVColor.primary"
                                                                            : "#eeeeee"
                                                                    }
                                                                    borderRadius={ 50 }
                                                                    height="max-content"
                                                                    width="min-content"
                                                                    margin-left="100%"
                                                                    isLoading={
                                                                        item === unfollowLoader ? true : false
                                                                    }
                                                                    onPress={ () => handleUnFollow( item ) }
                                                                >
                                                                    <CloseIcon size="15px" />
                                                                </Button>
                                                            </HStack>
                                                        </Box>
                                                    </Pressable>
                                                ) ) }
                                            </Box>
                                        </ScrollView>
                                    </>
                                ) }
                            </VStack>
                        </VStack>
                    </VStack>
                </Box>
            ) }

            {/* Notification Screen */ }
            { showAlertModal && (
                <Box
                    // position={['absolute']}
                    position="fixed"
                    top={ [ `${ 83 - 1 }px` ] }
                    right={ [ 0 ] }
                    w={ isMobile ? "100%" : "460px" }
                    h={ "calc(100vh - 50px)" }
                    bgColor={ [ "AVColor.white" ] }
                    shadow={ [ 10 ] }
                    borderColor={ "AVColor.grey" }
                    borderWidth={ 1 }
                    zIndex={ [ 1000 ] }
                //borderRadius={8}
                >
                    <VStack padding={ "24px" } h={ "96%" } position={ "relative" }>
                        <HStack justifyContent={ "space-between" }>
                            <Text fontSize={ 24 } fontWeight={ 400 }>
                                { Loc.currentLang.menu.notifications }
                            </Text>
                            <HStack alignItems={ [ "center" ] } space={ "26px" }>
                                <AVCancel
                                    callback={ handleCancelAlert }
                                    color={ undefined }
                                    size={ undefined }
                                />
                            </HStack>
                        </HStack>
                        <HStack mt={ [ 15 ] }>
                            <HStack
                                display={ "flex" }
                                flex={ 1 }
                                justifyContent={ [ "center" ] }
                                alignItems={ "center" }
                                borderBottomColor={ "AVColor.primary" }
                                borderBottomWidth={ isunread ? 4 : "0" }
                                pb={ "12px" }
                            >
                                <Pressable
                                    onPress={ () =>
                                    {
                                        setIsUnread( true );
                                        setIsAll( false );
                                    } }
                                >
                                    <Text
                                        fontSize={ "md" }
                                        fontWeight={ 500 }
                                        color={ !isunread ? "gray.500" : "" }
                                    >
                                        { Loc.currentLang.menu.unRead } ({ unreadAlertData?.length })
                                    </Text>
                                </Pressable>
                            </HStack>
                            <HStack
                                display={ "flex" }
                                flex={ 1 }
                                justifyContent={ [ "center" ] }
                                alignItems={ "center" }
                                borderBottomColor={ "AVColor.primary" }
                                borderBottomWidth={ isall ? 4 : "0" }
                            >
                                <Pressable
                                    onPress={ () =>
                                    {
                                        setIsUnread( false );
                                        setIsAll( true );
                                    } }
                                >
                                    <Text
                                        variant={ "md" }
                                        fontWeight={ 500 }
                                        color={ !isall ? "gray.500" : "" }
                                    >
                                        { Loc.currentLang.menu.all }
                                    </Text>
                                </Pressable>
                            </HStack>
                        </HStack>
                        <Divider />
                        <VStack h={ "100%" } flex={ 1 } marginTop={ "24px" }>
                            <ScrollView maxHeight={ dimensions.height - 200 }>
                                { isunread &&
                                    ( unreadAlertData?.length > 0 ? (
                                        <HStack flexWrap={ "wrap" } justifyContent={ "center" }>
                                            <FlatList
                                                removeClippedSubviews={ false }
                                                scrollEnabled={ true }
                                                disableVirtualization={ true }
                                                data={ unreadAlertData }
                                                renderItem={ RenderalertTab }
                                                initialNumToRender={ 5 }
                                                maxToRenderPerBatch={ 5 }
                                                windowSize={ 3 }
                                                onEndReachedThreshold={ 0.1 }
                                                keyExtractor={ ( item : any, index ) => item?.id + index }
                                            />
                                        </HStack>
                                    ) : (
                                        <Center height={ 300 }>
                                            { Loc.currentLang.menu.noAlertsFound }
                                        </Center>
                                    ) ) }
                                { isall &&
                                    ( allAlertData?.length > 0 ? (
                                        <HStack flexWrap={ "wrap" } justifyContent={ "center" }>
                                            <FlatList
                                                removeClippedSubviews={ false }
                                                disableVirtualization={ true }
                                                data={ allAlertData }
                                                renderItem={ RenderalertTab }
                                                initialNumToRender={ 5 }
                                                maxToRenderPerBatch={ 5 }
                                                windowSize={ 3 }
                                                scrollEnabled={ true }
                                                onEndReachedThreshold={ 0.1 }
                                                keyExtractor={ ( item : any, index ) => item?.id + index }
                                            />
                                        </HStack>
                                    ) : (
                                        <Center height={ 300 }>
                                            { Loc.currentLang.menu.noAlertsFound }
                                        </Center>
                                    ) ) }
                            </ScrollView>
                        </VStack>

                        { unreadAlertData?.length > 0 && isunread && (
                            <HStack
                                height={ "50px" }
                                width={ "100%" }
                                justifyContent={ "center" }
                                alignItems={ "center" }
                                top={ "10px" }
                            >
                                <HStack position={ "fixed" }>
                                    <Button
                                        width={ "155px" }
                                        height={ "40px" }
                                        backgroundColor={ "#EEEEEE" }
                                        rounded={ "full" }
                                        onPress={ () =>
                                        {
                                            handleDeleteAll();
                                            setUnreadAlertData( [] );
                                            setunread( [] );
                                        } }
                                    >
                                        <Text
                                            fontWeight={ 700 }
                                            fontSize={ "16px" }
                                            color={ "gray.700" }
                                            textTransform={ "uppercase" }
                                        >
                                            { Loc.currentLang.menu.deleteAll }
                                        </Text>
                                    </Button>
                                </HStack>
                            </HStack>
                        ) }
                    </VStack>
                </Box>
            ) }

            {/* Message   Screen */ }
            { showConvoListModal && (
                <CreateNewMessage
                    isNewChat={ isNewChat }
                    setIsNewChat={ setIsNewChat }
                    TriggerOpenConvo={ TriggerOpenConvo }
                    setIsTriggerOpenConvo={ setIsTriggerOpenConvo }
                    isGroupChat={ props?.isGroupChat }
                    setIsGroupChat={ props?.setIsGroupChat }
                    isHeader={ isHeader }
                    convosearch={ convosearch }
                    convoListData={ convoListData }
                    userconvolistdata={ userconvolistdata }
                    UnReadChatMessage={ UnReadChatMessage }
                    handleGetConvo={ handleGetConvo }
                    setShowEmoji={ setShowEmoji }
                    setShowConvoFilePicker={ setShowConvoFilePicker }
                    setValue={ setValue }
                    setShowAlertModal={ setShowAlertModal }
                    setShowFollowingModal={ setShowFollowingModal }
                    setShowConvoListModal={ setShowConvoListModal }
                    setMdlConvoVisible={ setMdlConvoVisible }
                    setMdlCreateConvoVisible={ setMdlCreateConvoVisible }
                    setConvoLoading={ setConvoLoading }
                    handleCreateModel={ handleCreateModel }
                    isOpenConvo={ props?.isOpenConvo }
                    setconvosearch={ setconvosearch }
                    setconvoListData={ setconvoListData }
                    convoval={ convoval }
                    setIsOpenConvo={ props?.setIsOpenConvo }
                    setIsConvoData={ props?.setIsConvoData }
                />
            ) }

            { ( props?.isOpenConvo || mdlCreateConvoVisible ) && (
                <Messages
                    camera={ camera }
                    isSetText={ isSetText }
                    isHeader={ isHeader }
                    isNewChat={ isNewChat }
                    setIsNewChat={ setIsNewChat }
                    isGroupChat={ props?.isGroupChat }
                    setIsGroupChat={ props?.setIsGroupChat }
                    isConvoData={ props?.isConvoData }
                    setIsConvoData={ props?.setIsConvoData }
                    setShowEmoji={ setShowEmoji }
                    RenderImages={ RenderImages }
                    showEmoji={ showEmoji }
                    imageInputRef={ imageInputRef }
                    onEmojiClick={ onEmojiClick }
                    handleuserRedirect={ handleuserRedirect }
                    getItemLayout={ getItemLayout }
                    ReplyLoadMedia={ ReplyLoadMedia }
                    setHeader={ setHeader }
                    setShowAllImage={ setShowAllImage }
                    setSingleImage={ setSingleImage }
                    setShowPreview={ setShowPreview }
                    setConvoImage={ setConvoImage }
                    setItemHeights={ setItemHeights }
                    itemHeights={ itemHeights }
                    props={ props }
                    mdlConvoVisible={ mdlConvoVisible }
                    textSearchRef={ textSearchRef }
                    mdlCreateConvoVisible={ mdlCreateConvoVisible }
                    typingUserName={ typingUserName }
                    setConvoSubject={ setConvoSubject }
                    setConvos={ setConvos }
                    isOpenConvo={ props?.isOpenConvo }
                    setIsOpenConvo={ props?.setIsOpenConvo }
                    setShowConvoListModal={ setShowConvoListModal }
                    setMdlCreateConvoVisible={ setMdlCreateConvoVisible }
                    toFK={ toFK }
                    searchInput={ searchInput }
                    filteredResults={ filteredResults }
                    showSearch={ showSearch }
                    handleExternalLink={ handleExternalLink }
                    externalLink={ externalLink }
                    showFilePicker={ showFilePicker }
                    handleCreateModel={ handleCreateModel }
                    searchItems={ searchItems }
                    handleSentToProfile={ handleSentToProfile }
                    handleSendMessage={ handleSendMessage }
                    setConvoLoading={ setConvoLoading }
                    isLoading={ isLoading }
                    handleSubject={ handleSubject }
                    subject={ subject }
                    isDelete={ isDelete }
                    setIsdelete={ setIsdelete }
                    setUpdateConvoImage={ setUpdateConvoImage }
                    setUpdateConvoVideo={ setUpdateConvoVideo }
                    handleMessage={ handleMessage }
                    handleRemoveItem={ handleRemoveItem }
                    getImageGalleryFromFilePickerCreateConvo={
                        getImageGalleryFromFilePickerCreateConvo
                    }
                    convoSubject={ convoSubject }
                    setMdlConvoVisible={ setMdlConvoVisible }
                    convoPost={ convoPost }
                    convo={ convo }
                    showConvoFilePicker={ showConvoFilePicker }
                    handleGetConvo={ handleGetConvo }
                    handleSendConvoMessage={ handleSendConvoMessage }
                    replyValue={ replyValue }
                    setreplyValue={ setreplyValue }
                    handleChatMessage={ handleChatMessage }
                    media={ media }
                    value={ value }
                    profile={ profile }
                    Setprofile={ Setprofile }
                    setValue={ setValue }
                    Loading={ Loading }
                    images={ images }
                    setImages={ setImages }
                    setDeletedImages={ setDeletedImages }
                    setItemEdit={ setItemEdit }
                    videoUrls={ videoUrls }
                    isOpenBox={ isOpenBox }
                    setIsOpenBox={ setIsOpenBox }
                    setExternalLink={ setExternalLink }
                    HandleAddOneDrive={ HandleAddOneDrive }
                    setShowExternalLinkInput={ setShowExternalLinkInput }
                    showExternalLinkInput={ showExternalLinkInput }
                    HandleAddDropBoxLink={ HandleAddDropBoxLink }
                    setIsOpenCemera={ setIsOpenCemera }
                    handleOpenPicker={ handleOpenPicker }
                    isOpenCemera={ isOpenCemera }
                    HandleAddExternalUrl={ HandleAddExternalUrl }
                    setvideos={ setvideos }
                    handleImages={ handleImages }
                    handleVoice={ handleVoice }
                    handleFilePicker={ handleFilePicker }
                    onRefresh={ onRefresh }
                    setSubject={ setSubject }
                    settoFK={ settoFK }
                    handlePublish={ handlePublish }
                    setIsHide={ setIsHide }
                    isHide={ isHide }
                    isImageProcessing={ isImageProcessing }
                    setMedia={ setMedia }
                    refConvoList={ refConvoList }
                    setShowConvoFilePicker={ setShowConvoFilePicker }
                    HandleEditSet={ HandleEditSet }
                    handleUpdatePost={ handleUpdatePost }
                    itemEdit={ itemEdit }
                    isYoutube={ isYoutube }
                    setIsYouTube={ setIsYouTube }
                    editingImage={ editingImage }
                    setSearchInput={ setSearchInput }
                    setShowSearch={ setShowSearch }
                    setEditingImage={ setEditingImage }
                    setConvoPost={ setConvoPost }
                    fetchloading={ fetchloading }
                    isHuddleChatTab={ false }
                    shrink={ shrink }
                    setShrink={ setShrink }
                    translateItem={ translateItem }
                    handleTranslateText={ handleTranslateText }
                    handleShowOriginalText={ handleShowOriginalText }
                    setIsOneDriveData={ setIsOneDriveData }
                    showInsufficientCredits={ showInsufficientCredits }
                    setShowInsufficientCredits={ setShowInsufficientCredits }
                    scrollRef={ scrollRef }
                    prevScrollHeightRef={ prevScrollHeightRef }
                    prevScrollTopRef={ prevScrollTopRef }
                    loadingOldMessagesRef={ loadingOldMessagesRef }
                    messagesEndRef={ messagesEndRef }
                    setupSignalRConnection={ setupSignalRConnection }
                    cameraMode={ cameraMode }
                    setCameraMode={ setCameraMode }
                    webcamRef={ webcamRef }
                    recording={ recording }
                    setRecording={ setRecording }
                    duration={ duration }
                    setDuration={ setDuration }
                    formatDuration={ formatDuration }
                    toggleMode={ toggleMode }
                    isCancelledRef={ isCancelledRef }
                    handleCameraPhotoCapture={ handleCameraPhotoCapture }
                    handleStartRecording={ handleStartRecording }
                    handleStopRecording={ handleStopRecording }
                    onClose={ onClose }
                    addLinkLoad={ addLinkLoad }
                    setAddLinkLoad={ setAddLinkLoad }
                    editorRef={ editorRef }
                    useRichText={ useRichText }
                    setUseRichText={ setUseRichText }
                    rteValue={ rteValue }
                    setRteValue={ setRteValue }
                    toolbarOptions={ toolbarOptions }
                    isExpanded={ isExpanded }
                    setIsExpanded={ setIsExpanded }
                    setPostPopupExpanded={ setPostPopupExpanded }
                    bgColor={ bgColor }
                    setBgColor={ setBgColor }
                    bgImage={ bgImage }
                    setBgImage={ setBgImage }
                    bgImgWidth={ bgImgWidth }
                    setBgImgWidth={ setBgImgWidth }
                    bgImgHeight={ bgImgHeight }
                    setBgImgHeight={ setBgImgHeight }
                    clickedUrl={ clickedUrl }
                    setClickedUrl={ setClickedUrl }
                    showConfirmLinkPopup={ showConfirmLinkPopup }
                    setShowConfirmLinkPopup={ setShowConfirmLinkPopup }
                    entityData={ undefined }
                    isGameEnded={ false }
                />
            ) }

            { showPreview && (
                <AVImageSlider
                    slideItems={ singleImage }
                    setCommentValue={ setCommentValue }
                    previewitem={ previewitem }
                    setpreviewitem={ setpreviewitem }
                    type={ "IMG" }
                    settype={ undefined }
                    fullscreen={ undefined }
                    setIsFullScreen={ undefined }
                    setShowDetails={ undefined }
                    setIscommentItem={ undefined }
                    setIsCommentSlider={ undefined }
                    isCommentSlider={ undefined }
                    handleslideChange={ undefined }
                    isHeader={ isHeader }
                    setHeader={ setHeader }
                    setShowPreview={ setShowPreview }
                    setClickedUrl={ setClickedUrl }
                    setShowConfirmLinkPopup={ setShowConfirmLinkPopup }
                />
            ) }

            {/* showBurgerMenu */ }
            { showBurgerMenu && (
                <Hidden from={ "lg" }>
                    <Box
                        position={ [ "fixed" ] }
                        top={ [ `${ 84 - 1 }px` ] }
                        right={ [ 0 ] }
                        w={ "250px" }
                        h={ "calc(100vh - 145px)" }
                        bgColor={ [ "AVColor.white" ] }
                        borderColor={ "AVColor.grey" }
                        borderWidth={ 1 }
                        zIndex={ [ 100 ] }
                    >
                        <ScrollView maxHeight={ "calc(100vh - 155px)" }>
                            <Box>
                                <Pressable
                                    onPress={ () =>
                                    {
                                        navigate( "/my-events" );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <EventsIcon size={ 26 } color="AVColor.primary" />
                                        <Text fontSize={ "19px" }>{ Loc.currentLang.menu.events }</Text>
                                    </HStack>
                                </Pressable>
                                <Pressable
                                    onPress={ () =>
                                    {
                                        navigate( "/my-teams" );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <GroupIcon size={ 26 } color="AVColor.primary" />
                                        <Text fontSize={ "19px" }>Network</Text>
                                    </HStack>
                                </Pressable>
                            </Box>
                            <Divider />
                            <Box>
                                <Pressable onPress={ () => setIsCreateNew( !isCreateNew ) }>
                                    <HStack
                                        paddingY="6px"
                                        paddingX={ "12px" }
                                        justifyContent={ "space-between" }
                                    >
                                        <Text
                                            fontWeight="medium"
                                            fontSize={ "19px" }
                                            color={ "AVColor.primary" }
                                        >
                                            { Loc.currentLang.post.createNew }
                                        </Text>
                                        { isCreateNew ? (
                                            <ChevronDownIcon size={ "22px" } />
                                        ) : (
                                            <ChevronUpIcon size={ "22px" } />
                                        ) }
                                    </HStack>
                                </Pressable>
                                { isCreateNew && (
                                    <Box>
                                        {/*Team*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate( `/teams/${ "Create" }/${ currentUser.region }`, {
                                                    state: { isCreate: true, type: "Team" },
                                                } );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateTeam
                                                    width={ "27" }
                                                    height={ "20" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.team }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Club*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Club" }`,
                                                    {
                                                        state: { isCreate: true, type: "Club" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateClub
                                                    width={ "27" }
                                                    height={ "20" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.club }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*EliteClub*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "EliteClub" }`,
                                                    {
                                                        state: { isCreate: true, type: "EliteClub" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateElite
                                                    width={ "20" }
                                                    height={ "20" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.eliteclub }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*School*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "School" }`,
                                                    {
                                                        state: { isCreate: true, type: "School" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateSchool
                                                    width={ "20" }
                                                    height={ "20" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.school }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Group*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Group" }`,
                                                    {
                                                        state: { isCreate: true, type: "Group" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateGroup
                                                    width={ "28 " }
                                                    height={ "27" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.group }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Class*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Class" }`,
                                                    {
                                                        state: { isCreate: true, type: "Class" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateClass
                                                    width={ "27" }
                                                    height={ "27" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.class }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/* Graduation Class*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "School" }`,
                                                    {
                                                        state: { isCreate: true, type: "School" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateGraduation
                                                    width={ "28 " }
                                                    height={ "23" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.graduatingClass }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Organization*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Organization" }`,
                                                    {
                                                        state: { isCreate: true, type: "Organization" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateOrganization
                                                    width={ "27" }
                                                    height={ "27" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.organization }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Neighborhood*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Neighborhood" }`,
                                                    {
                                                        state: { isCreate: true, type: "Neighborhood" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateNeighborhood
                                                    width={ "22 " }
                                                    height={ "25 " }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.neighborHood }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                        {/*Community*/ }
                                        <Pressable
                                            onPress={ () =>
                                            {
                                                navigate(
                                                    `/organizations/${ "Create" }/${ currentUser.region
                                                    }/${ "Community" }`,
                                                    {
                                                        state: { isCreate: true, type: "Community" },
                                                    }
                                                );
                                                setShowBurgerMenu( !showBurgerMenu );
                                                setIsCreateNew( !isCreateNew );
                                            } }
                                            _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                        >
                                            <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                <CreateCommunity
                                                    width={ "26" }
                                                    height={ "28" }
                                                    color={ "#32AE78" }
                                                />
                                                <Text fontSize={ "19px" }>
                                                    { Loc.currentLang.menu.community }
                                                </Text>
                                            </HStack>
                                        </Pressable>
                                    </Box>
                                ) }
                            </Box>
                            <Divider />
                            { currentUser?.wards?.length > 0 && !loginLink?.id && (
                                <VStack>
                                    <Pressable onPress={ () => setIsCreate( !isCreate ) }>
                                        <HStack
                                            paddingY="6px"
                                            paddingX={ "12px" }
                                            justifyContent={ "space-between" }
                                        >
                                            <Text
                                                fontWeight="medium"
                                                fontSize={ "19px" }
                                                color={ "AVColor.primary" }
                                            >
                                                { Loc.currentLang.menu.myDependents }
                                            </Text>
                                            { isCreate ? (
                                                <ChevronDownIcon size={ "22px" } />
                                            ) : (
                                                <ChevronUpIcon size={ "22px" } />
                                            ) }
                                        </HStack>
                                    </Pressable>
                                    <Box maxHeight={ "155px" } overflowY={ "scroll" }>
                                        { isCreate &&
                                            currentUser?.wards?.length > 0 &&
                                            userisguardian &&
                                            !loginLink?.id &&
                                            currentUser?.wards?.map( ( item, index ) => (
                                               <Pressable
                                                   isDisabled={ !isOnline }
                                                   onPress={ () =>
                                                   {
                                                       handleuserchange( item );
                                                       setShowBurgerMenu( !showBurgerMenu );
                                                       setIsCreate( !isCreate );
                                                   } }
                                                   _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                                   key={ item.id }
                                               >
                                                   <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                                       <ProfilePic
                                                           width={ "35px" }
                                                           height={ "35px" }
                                                           link={ item }
                                                       />
                                                       <Text fontSize={ "19px" } numberOfLines={ 1 }>
                                                           { item?.title }
                                                       </Text>
                                                   </HStack>
                                               </Pressable>
                                            ) ) }
                                    </Box>
                                </VStack>
                            ) }
                            <VStack>
                                <Box maxHeight={ "155px" } overflowY={ "scroll" }>
                                    { loginLink && (
                                       <Pressable
                                           isDisabled={ !isOnline }
                                           onPress={ () =>
                                           {
                                               handleGuardianChange( loginLink );
                                               setShowBurgerMenu( !showBurgerMenu );
                                               setIsCreate( !isCreate );
                                           } }
                                           _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                       >
                                           <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                               <ProfilePic
                                                   width={ "35px" }
                                                   height={ "35px" }
                                                   link={ Person.getLink( loginLink ) }
                                               />
                                               <Text fontSize={ "19px" } numberOfLines={ 1 }>
                                                   { Person.getLink( loginLink )?.title }
                                               </Text>
                                           </HStack>
                                       </Pressable>
                                    ) }
                                </Box>
                            </VStack>
                            { currentUser?.wards?.length > 0 && <Divider /> }
                            { loginLink && <Divider /> }
                            <Pressable
                                onPress={ () =>
                                {
                                    navigate( `/manageFollowings` );
                                    setShowProfile( false );
                                    setShowBurgerMenu( !showBurgerMenu );
                                } }
                                _hover={ { backgroundColor: "AVColor.buttonBg" } }
                            >
                                <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                    <FollowingIcon size={ 26 } color="AVColor.primary" />
                                    <Text fontSize={ "19px" }>
                                        { Loc.currentLang.menu.followings }
                                    </Text>
                                </HStack>
                            </Pressable>
                            <Pressable
                                isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                                onPress={ OpenNotification }
                                _hover={ { backgroundColor: "AVColor.buttonBg" } }
                            >
                                <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                    <NotificationIcon size={ 26 } color="AVColor.primary" />
                                    <Text fontSize={ "19px" }>
                                        { Loc.currentLang.menu.notifications }
                                    </Text>
                                </HStack>
                            </Pressable>
                            <Pressable
                                isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                                onPress={ () =>
                                {
                                    setShowConvoListModal( !showConvoListModal );
                                    setShowAlertModal( false );
                                    setShowFollowingModal( false );
                                    setShowProfile( false );
                                    setShowBurgerMenu( !showBurgerMenu );
                                } }
                                _hover={ { backgroundColor: "AVColor.buttonBg" } }
                            >
                                <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                    <MessageIcon size={ 26 } color="AVColor.primary" />
                                    <Text fontSize={ "19px" }>{ Loc.currentLang.menu.messages }</Text>
                                </HStack>
                            </Pressable>
                            <Divider />
                            <Box>
                                <Pressable
                                    onPress={ () =>
                                    {
                                        navigate(
                                            `/accountsettings/${ currentUser?.id }/${ currentUser?.region }`,
                                            {
                                                state: {
                                                    page: "Home",
                                                    Entity: currentUser,
                                                },
                                            }
                                        );
                                        setShowProfile( false );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <img src={ seting } height={ "25px" } width={ "25px" } />
                                        <Text fontSize={ "19px" }>
                                            { Loc.currentLang.menu.settings }
                                        </Text>
                                    </HStack>
                                </Pressable>
                            </Box>
                            <Box>
                                <Pressable
                                    isDisabled={ currentUser?.status === "Deleted" }
                                    onPress={ () =>
                                    {
                                        setshowAddinviteModal( true );
                                        setShowProfile( false );
                                        setpersonEmail( "" );
                                        setpersonPhone( "" );
                                        setpersonname( "" );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <img src={ adduser } height={ "25px" } width={ "25px" } />
                                        <Text fontSize={ "19px" }>
                                            { Loc.currentLang.menu.inviteFriends }
                                        </Text>
                                    </HStack>
                                </Pressable>
                            </Box>

                            <Box>
                                <Pressable
                                    onPress={ () =>
                                    {
                                        window.open( "https://actavivo.net/" );
                                        setShowProfile( false );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <img src={ about } height={ "25px" } width={ "25px" } />
                                        <Text fontSize={ "19px" }>{ Loc.currentLang.menu.about }</Text>
                                    </HStack>
                                </Pressable>
                            </Box>
                            <Box>
                                <Pressable
                                    onPress={ () =>
                                    {
                                        window.open( " https://actavivo.net/" );
                                        setShowProfile( false );
                                        setShowBurgerMenu( !showBurgerMenu );
                                    } }
                                    _hover={ { backgroundColor: "AVColor.buttonBg" } }
                                >
                                    <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                        <img src={ help } height={ "25px" } width={ "25px" } />
                                        <Text fontSize={ "19px" }>{ Loc.currentLang.menu.help }</Text>
                                    </HStack>
                                </Pressable>
                            </Box>

                            {/*Feedback*/ }
                            <Pressable
                                onPress={ () =>
                                {
                                    navigate(
                                        "/teams/78b5b063-fd3e-4925-92bd-2a1888c6a46a/" +
                                        currentUser?.region,
                                        {
                                            state: {
                                                team: {
                                                    id: "78b5b063-fd3e-4925-92bd-2a1888c6a46a",
                                                    pk: "a46a",
                                                    region: currentUser?.region,
                                                    type: "Organization",
                                                    name: "Actavivo",
                                                },
                                                type: "Feedback",
                                            },
                                        }
                                    );

                                    setShowBurgerMenu( !showBurgerMenu );
                                    setIsCreateNew( !isCreateNew );
                                } }
                                _hover={ { backgroundColor: "AVColor.buttonBg" } }
                            >
                                <HStack space={ 3 } paddingY="8px" paddingLeft={ "20px" }>
                                    <HStack paddingY="1px" top="5px">
                                        <ChatIcon size={ "22px" } color={ "#32AE78" } />
                                    </HStack>
                                    <Text fontSize={ "19px" }>{ Loc.currentLang.menu.feedback }</Text>
                                </HStack>
                            </Pressable>
                            <Divider />

                            <Button
                                mx={ 5 }
                                mt={ 5 }
                                variant={ "unstyled" }
                                backgroundColor={ "#eeeeee" }
                                _text={ { color: "AVColor.secondary" } }
                                onPress={ () =>
                                {
                                    setIsConfirmLogout(true);//handleLogout();
                                } }
                            >
                                { Loc.currentLang.menu.logout }
                            </Button>
                        </ScrollView>
                    </Box>
                </Hidden>
            ) }

            { showunauthorizedDetails && (
                <Box
                    position={ "fixed" }
                    top={ 0 }
                    bottom={ 0 }
                    left={ 0 }
                    right={ 0 }
                    display={ "flex" }
                    alignItems={ "center" }
                    justifyContent={ "center" }
                    backgroundColor={ "rgba(0, 0, 0, 0.25)" }
                    zIndex={ 9999 }
                >
                    <div className={ `customModal` }>
                        <div className={ `show_unauthorized_details` }>
                            <VStack>
                                <Pressable
                                    padding={ 1.5 }
                                    rounded={ "full" }
                                    zIndex={ 999 }
                                    position={ "absolute" }
                                    top={ "20px" }
                                    right={ "20px" }
                                    _hover={ { backgroundColor: "AVColor.hovercolor2" } }
                                    backgroundColor={ "AVColor.buttonBg" }
                                    onPress={ () =>
                                    {
                                        setshowunauthorizedDetails( false );
                                    } }
                                >
                                    <CloseIcon size={ "16px" } color={ "AVColor.secondaryText" } />
                                </Pressable>
                                <HStack marginLeft={ "208px" } marginTop={ "46px" }>
                                    <img
                                        src={ unauthorPopup }
                                        style={ { width: "101px", height: "112px" } }
                                    />
                                </HStack>
                                <HStack justifyContent={ "center" }>
                                    <Text
                                        color={ "#32AE78" }
                                        fontSize={ "24px" }
                                        textAlign={ "center" }
                                    >
                                        { Loc.currentLang.menu.thisPosthasbeen }
                                    </Text>
                                </HStack>
                                <HStack justifyContent={ "center" } marginTop={ "5px" }>
                                    <Text color={ "#000000" }>
                                        { Loc.currentLang.menu.unableProcess }
                                    </Text>
                                </HStack>
                                <HStack justifyContent={ "center" } marginTop={ "55px" }>
                                    <Button
                                        rounded="full"
                                        backgroundColor={ "#EEEEEE" }
                                        width={ "108px" }
                                        height={ "40px" }
                                        onPress={ () =>
                                        {
                                            setshowunauthorizedDetails( false );
                                        } }
                                    >
                                        <Text
                                            fontSize={ "16px" }
                                            color={ "rgba(0,0,0,0.5)" }
                                            fontWeight={ "bold" }
                                        >
                                            { Loc.currentLang.menu.ok }
                                        </Text>
                                    </Button>
                                </HStack>
                            </VStack>
                        </div>
                    </div>
                </Box>
            ) }

            { isConfirmLogout && <AVConfirmationModal showconfirmationPopup={ isConfirmLogout } setshowconfirmationPopup={ setIsConfirmLogout }
                Confirmationtext={ Loc.currentLang.menu.logoutConfirmText } type={ "Logout" } item={ undefined } function={ handleLogout } isLoader={ isLoader } /> }

            {showCreditsPopup && (
              <PurchaseCreditsPopup
                entity={entity?.type === "Event" ? eventParentEntity : entity}
                setEntity={setEntity}
                sharedPlan={sharedPlan}
                setSharedPlan={setSharedPlan}
                showCreditsPopup={showCreditsPopup}
                setShowCreditsPopup={setShowCreditsPopup}
              />
            )}
        </>
    );
}

const ReplyLoadMedia = ( { item, isDetail = false } ) =>
{
    const [ imageUrls, setImagesUrl ] = useState<any>( [] );
    const [ videoUrls, setVideoUrl ] = useState<any>( [] );
    const [ media, setMedia ] = useState<any>( [] );
    let videomedia : any = [];
    let imagemedia : any = [];

    useEffect( () =>
    {
        setMedia( [] );
        if (
            item?.media?.storeId &&
            ( item?.galleryPost?.length == 0 || item?.galleryPost?.length == undefined )
        )
        {
            imageUrls.push( item?.media );
            setMedia( imageUrls );
        } else if ( item?.galleryPost?.length > 0 )
        {
            // Loop through gallery posts and add media
            for ( let i = 0; i < item?.galleryPost?.length; i++ )
            {
                imageUrls.push( item?.galleryPost[ i ].media );
            }
            setMedia( imageUrls );
        }
    }, [] );

    return (
        <>
            <VStack px={ 1 }>
                <HStack overflow="scroll" maxWidth={ "400px" }>
                    { media.map( ( item, i ) =>
                    {
                        return (
                            <Box
                                key={ item?.id || i }
                                m={ 1 }
                                width={ item?.type?.startsWith( "audio" ) ? "200px" : "100px" }
                                height={ item?.type?.startsWith( "audio" ) ? "42px" : "72px" }
                            >
                                <Box
                                    position={ "absolute" }
                                    top={ 1 }
                                    right={ 1 }
                                    bgColor={ "white" }
                                    rounded={ "full" }
                                    zIndex={ 100 }
                                ></Box>
                                { item?.type?.startsWith( "image" ) ||
                                    ( !item?.id &&
                                        typeof item === "string" &&
                                        item.startsWith( "data:image" ) ) ||
                                    item?.type == "Onedrive" ||
                                    item?.type == "dropbox" ? (
                                    <img
                                        src={
                                            item?.type === "dropbox"
                                                ? item?.orgFile
                                                : item?.linkURL
                                                    ? item?.linkURL
                                                    : !item?.id &&
                                                        typeof item === "string" &&
                                                        item.startsWith( "data:image" )
                                                        ? item
                                                        : Media.getURL( item )
                                        }
                                        alt=""
                                        className="Image"
                                        width="100%"
                                        height="100%"
                                        style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                    />
                                ) : item?.type === "iframe" ? (
                                    <iframe
                                        src={ item?.linkURL }
                                        width="100%"
                                        height="100%"
                                    ></iframe>
                                ) : item?.type == "linkPreview" ? (
                                    <SimpleLinkPreview url={ item } />
                                ) : item?.type?.startsWith( "application" ) ? (
                                    <img
                                        src={
                                            ( item?.type === "application/pdf" && settings.pdf ) ||
                                            ( ( item?.type === "application/msword" ||
                                                item?.type ===
                                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ) &&
                                                settings.word ) ||
                                            ( ( item?.type === "application/vnd.ms-powerpoint" ||
                                                item?.type ===
                                                "application/vnd.openxmlformats-officedocument.presentationml.presentation" ) &&
                                                settings.powerpoint ) ||
                                            ( ( item?.type === "application/vnd.ms-excel" ||
                                                item?.type ===
                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ) &&
                                                settings.excel ) ||
                                            settings.file
                                        }
                                        alt=""
                                        className="Image"
                                        width="100%"
                                        height="100%"
                                        style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                    />
                                ) : item?.type === "text/plain" ? (
                                    <img
                                        src={ settings.file }
                                        alt=""
                                        className="Image"
                                        width="100%"
                                        height="100%"
                                        style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                    />
                                ) : item?.type?.startsWith( "audio" ) ? (
                                    <HStack
                                        space={ 2 }
                                        width={ "100%" }
                                        marginLeft={ 20 }
                                        justifyContent={ "center" }
                                        alignItems="center"
                                        bg="rgba(0,0,0,0.05)"
                                        p={ 2 }
                                        borderRadius="md"
                                    >
                                        <MicIcon size="24px" color="AVColor.primary" />

                                        <Text color="#32AE78" fontSize="sm">
                                            { Loc.currentLang.menu.voiceMessage }
                                        </Text>
                                        {/* <Text color="gray.500" fontSize="xs">
                      {formatDuration(media?.duration || 0)}
                    </Text> */}
                                    </HStack>
                                ) : (
                                    //<video
                                    //    controls
                                    //    src={ item?.linkURL ? item?.linkURL : item }
                                    //    key={ i }
                                    //    width={ "100%" }
                                    //    height={ "100%" }
                                    ///>
                                     
                                    <div className="processing-container">
                                       <img
                                           src={ Media.getVideoPicURL( item ) }
                                           alt=""
                                           className="Image"
                                           width="100%"
                                           height="100%"
                                           style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                       />
                                        <Box
                                            position="absolute"
                                            top={ "50%"}
                                            left={ "50%"}
                                            style={{
                                                transform: [
                                                    { translateX: -30 },
                                                    { translateY: -30 }
                                                ]
                                            }}
                                        >
                                            <VideoIcon size={'60px'} color={'white'} />
                                        </Box>
                                    </div>
                                ) }
                            </Box>
                        );
                    } ) }
                </HStack>
            </VStack>
        </>
    );
};

const SimpleLinkPreview = ( { url } ) =>
{
    return (
        <div className="link-preview-wrapper">
            <div className="link-preview-image">
                <img src={ url?.orgFile } alt="images" />
            </div>
            <div className="link-preview-content">
                <Pressable onPress={ () => Linking.openURL( url?.linkURL ) }>
                    <p className="link-url">{ url?.linkURL }</p>
                </Pressable>
            </div>
        </div>
    );
};

const RenderImages = ( {
    images,
    setImages,
    setDeletedImages,
    setUpdateConvoImage,
    setUpdateConvoVideo,
    media,
    setMedia,
    isImageProcessing,
    editingImage,
    setEditingImage,
    itemEdit,
    setItemEdit,
    setIsdelete,
    setShowConvoFilePicker,
    useRichText = false,
    isExpanded = false,
} ) =>
{
    const [isAPICall, setIsAPICall] = useState(false);
    const [isConfirm, setIsConfirm] = useState(false);
    const [removedItems, setRemovedItems] = useState<any | null>(null);

    useEffect( () => { }, [ editingImage ] );

    let imgmedia : any = [];
    let vidmedia : any = [];

    images?.forEach( ( img ) =>
    {
        if ( editingImage )
        {
            if ( images?.length > 0 )
            {
                if ( img )
                {
                    imgmedia?.push( img );
                } else
                {
                    vidmedia.push( img );
                }
            }
        } else
        {
            if ( images?.length > 0 )
            {
                if ( img )
                {
                    imgmedia?.push( img );
                }
            } else vidmedia.push( img );
        }
    } );

    const handleRemoveItem = (item) => {
      setIsdelete?.(true);
      setIsConfirm(true);
      setRemovedItems(item);
    };

    const deleteImage = ( item : any ) =>
    {
        const deleteItem = removedItems ?? item;
        if (!deleteItem) return;

        setIsAPICall( true );
        setDeletedImages((prev) => [...prev, deleteItem?.id]);

        let filterImages = images?.filter((x, i) => x?.id !== deleteItem?.id);
        setImages( filterImages );

        setUpdateConvoImage(
            filterImages?.filter( ( x, i ) => !x?.type?.startsWith( "video" ) )
        );

        const filterVideos = filterImages?.filter(
            ( x, i ) => x?.type?.startsWith( "video" ) && x?.id !== deleteItem?.id
        );
        if ( filterVideos )
        {
            setUpdateConvoVideo( filterVideos );
        }

        let filterMedia = media?.filter( ( x, i ) => x?.id !== deleteItem?.id);
        setMedia( filterMedia );

        if (
            ( itemEdit?.id?.length === undefined || itemEdit?.id?.length === 0 ) &&
            filterImages?.length === 0
        )
        {
            setItemEdit( "" );
            setEditingImage( false );
            setShowConvoFilePicker( false );
        }
        setIsAPICall( false );
        setIsdelete?.( false );
        setIsConfirm( false );
    };

    return (
        <>
        <VStack px={ 1 }>
            <HStack space={ 1 } alignItems={ "center" }></HStack>
            <HStack overflow="scroll" maxWidth={ useRichText ? "100%" : "400px" }>
                { images.map( ( item, i ) =>
                {
                    return (
                        <Box key={ item?.id || i } m={ 1 } width={ item?.type?.startsWith( "audio" ) ? "205px" : "120px" } height={ "120px" }>
                            <Box
                                position={ "absolute" }
                                top={ 1 }
                                right={ 1 }
                                bgColor={ "white" }
                                rounded={ "full" }
                                zIndex={ 100 }
                            >
                                { !isImageProcessing && (
                                    <AVCancel
                                        size={ "10px" }
                                          callback={() => {
                                              handleRemoveItem(item);
                                          }}
                                        color={ undefined }
                                    />
                                ) }
                            </Box>
                            { item?.type?.startsWith( "image" ) ||
                                ( !item?.id &&
                                    typeof item === "string" &&
                                    item.startsWith( "data:image" ) ) ||
                                item?.type == "Onedrive" ||
                                item?.type == "dropbox" ? (
                                <img
                                    src={
                                        item?.type === "dropbox"
                                            ? item?.orgFile
                                            : item?.linkURL
                                                ? item?.linkURL
                                                : !item?.id &&
                                                    typeof item === "string" &&
                                                    item.startsWith( "data:image" )
                                                    ? item
                                                    : Media.getURL( item )
                                    }
                                    alt=""
                                    className="Image"
                                    width="100%"
                                    height="100%"
                                    style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                />
                            ) : item?.type === "iframe" ? (
                                <iframe src={ item?.linkURL } width="100%" height="100%"></iframe>
                            ) : item?.type == "linkPreview" ? (
                                <SimpleLinkPreview url={ item } />
                            ) : item?.type?.startsWith( "application" ) ? (
                                <img
                                    src={
                                        ( item?.type === "application/pdf" && settings.pdf ) ||
                                        ( ( item?.type === "application/msword" ||
                                            item?.type ===
                                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ) &&
                                            settings.word ) ||
                                        ( ( item?.type === "application/vnd.ms-powerpoint" ||
                                            item?.type ===
                                            "application/vnd.openxmlformats-officedocument.presentationml.presentation" ) &&
                                            settings.powerpoint ) ||
                                        ( ( item?.type === "application/vnd.ms-excel" ||
                                            item?.type ===
                                            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ) &&
                                            settings.excel ) ||
                                        settings.file
                                    }
                                    alt=""
                                    className="Image"
                                    width="100%"
                                    height="100%"
                                    style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                />
                            ) : item?.type === "text/plain" ? (
                                <img
                                    src={ settings.file }
                                    alt=""
                                    className="Image"
                                    width="100%"
                                    height="100%"
                                    style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                />
                            ) : item?.type?.startsWith( "audio" ) ? (
                                <VoiceMessage
                                    audioUrl={ Media.getURL( item ) }
                                    onRecordingComplete={ () => { } }
                                />
                            ) : (
                                //<video
                                //    controls
                                //    src={ item?.linkURL ? item?.linkURL : item }
                                //    key={ i }
                                //    width={ "100%" }
                                //    height={ "100%" }
                                ///>

                                <div className="processing-container">
                                   <img
                                       src={ Media.getVideoPicURL( item ) }
                                       alt=""
                                       className="Image"
                                       width="100%"
                                       height="100%"
                                       style={ { objectFit: "contain", backgroundColor: "#eeeeee" } }
                                   />
                                    <Box
                                        position="absolute"
                                        top={ "50%"}
                                        left={ "50%"}
                                        style={{
                                            transform: [
                                                { translateX: -30 },
                                                { translateY: -30 }
                                            ]
                                        }}
                                    >
                                        <VideoIcon size={'60px'} color={'white'} />
                                    </Box>
                                </div>
                            ) }
                        </Box>
                    );
                } ) }
            </HStack>
            </VStack>

            { isConfirm && <AVConfirmationModal showconfirmationPopup={ isConfirm } setshowconfirmationPopup={ setIsConfirm } setIsdelete={ setIsdelete }
                Confirmationtext={ Loc.currentLang.confirmationText.areYouSureYouWantToRemoveThisItem } type={ "ChatImageRemove" } item={ undefined } function={ deleteImage } isLoader={ isAPICall } /> }
        </>
    );
};

const UserMenu = ( {
    unreadAlertData,
    showAlertModal,
    setShowAlertModal,
    setShowConvoListModal,
    setShowFollowingModal,
    setShowProfile,
    showProfile,
    convoPost,
    isMobile,
    requestdata,
    followRequestData,
    currentUser,
    followreqlist,
    setShowBurgerMenu,
    showBurgerMenu,
    showAddinviteModal,
    setshowAddinviteModal,
    personname,
    setpersonname,
    personEmail,
    setpersonEmail,
    personPhone,
    customUniq,
    setpersonPhone,
    setMdlCreateConvoVisible,
    setMdlConvoVisible,
    setConvoLoading,
    handleMessageIconClick,
    ClearCachedData,
    setIsOpenConvo,
    isLoader,
    setIsLoader,
    isConfirmLogout,
    setIsConfirmLogout
} ) =>
{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const stateUser = useSelector( ( state : RootStateOrAny ) => state );
    const userisguardian = stateUser?.user?.userisguardian;
    const [ ispageLoading, setispageLoading ] = useState( false );
    const loginLink = stateUser?.user?.loginLink;
    const convoval = useSelector( ( state : RootStateOrAny ) => state.convo.convo[ 0 ] );
    const pathName = window.location.pathname;
    const [ isLoading, setisLoading ] = useState<any>( false );
    const [ data, setData ] = useState( [] );
    const [ responseData, setResponseData ] = useState( [] );
    const [ showpop, setisshowpop ] = useState( false );
    const useralertList = useSelector( ( state : RootStateOrAny ) =>
        state?.alerts.alert[ 0 ]?.length > 0 ? state?.alerts.alert[ 0 ] : []
    );
    const [ lastfeed, setlastfeed ] = useState<any>( [] );
    const lastUpdateFeed = useSelector(
        ( state : RootStateOrAny ) => state.user.lastUpdateFeed
    );
    const menuRef = useRef( null );
    useOutsideAlerter( menuRef );
    //Hook that alerts clicks outside of the passed ref
    function useOutsideAlerter ( ref )
    {
        useEffect( () =>
        {
            // Alert if clicked on outside of element
            function handleClickOutside ( event )
            {
                if ( ref.current && !ref.current.contains( event.target ) )
                {
                    setShowProfile( false );
                }
            }
            // Bind the event listener
            document.addEventListener( "mousedown", handleClickOutside );
            return () =>
            {
                // Unbind the event listener on clean up
                document.removeEventListener( "mousedown", handleClickOutside );
            };
        }, [ ref ] );
    }

    const handleuserchange = async (item) => {
        setispageLoading(true);
        let val = await Server.impersonate(item, currentUser);
        let val1 = await Server.GetLoginLink();
        await handlePersonData( item, val1 );
        setispageLoading(false);
    };

    const handlePersonData = async (item: any, val1: any) => {
      try {
        //await persistor.purge();
        const personData = await Person.getSelf(true);
        dispatch(setUser(personData));
        await dispatch(setLoginLink(val1));
        await dispatch(setuserisguardian(false));
        await dispatch(setFeeds([]));
        await dispatch(setFeeds([]));
        await dispatch(setProcessedHomeFeeds([]));
        await dispatch(setAlerts([]));
        await dispatch(setConvo([]));
        navigate( `/profile/${ item?.id }/${ item?.region }`, {
            state: {
                user: {
                    id: item?.id,
                    pk: item?.pk,
                    region: item?.region,
                    type: item?.type,
                    name: item?.title,
                },
            },
        } );

        //navigate("/");
        //await getConvo();
        //await gtalerts();
      } catch (error) {
        console.error('Error fetching person data:', error);
      }
    };

    const handleGuardianChange = async ( item ) =>
    {
        if ( !loginLink?.id )
        {
            await ClearCachedData();
            await dispatch( setFeeds( [] ) );
            await dispatch( setConvo( [] ) );
            await dispatch( setAlerts( [] ) );
            await Server.impersonate( item, currentUser );
            let user = await Server.GetLoginLink();
            dispatch( setLoginLink( user ) );
            dispatch( setuserisguardian( false ) );
        } else
        {
            await Server.impersonate();
            dispatch( setLoginLink( [] ) );
            dispatch( setuserisguardian( true ) );
        }
        setShowProfile( false );
        await AV.Person.getSelf( true ).then( ( x ) => dispatch( setUser( x ) ) );
        navigate( "/" );
        //navigate( `/profile/${ item?.id }/${ item?.region }`, {
        //    state: {
        //        user: {
        //            id: item?.id,
        //            pk: item?.pk,
        //            region: item?.region,
        //            type: item?.type,
        //            name: item?.title,
        //        },
        //    },
        //} )
    };


    let userTitle : any = Person.getLink( currentUser )?.title;
    let titleLength =
        userTitle?.trim()?.length <= 10
            ? "16px"
            : userTitle?.trim()?.length <= 13
                ? "13px"
                : userTitle?.trim()?.length <= 16
                    ? "11px"
                    : userTitle?.trim()?.length <= 18
                        ? "10px"
                        : userTitle?.trim()?.length <= 20
                            ? "9px"
                            : userTitle?.trim()?.length >= 20
                                ? "9px"
                                : "16px";
    let maxlength = 20;
    let TitleData = userTitle?.substring( 0, maxlength );

    const Invitefriends = async ( item ) =>
    {
        let contact : AV.ITokenProcessRequest = {
            type: "Invite",
            entity: AV.AVEntity.getLink( currentUser ),
        };
        let val : any = await AV.AVEntity.createTokenRequest( contact );
        let Window : any = window;
        Window.FB.init( {
            appId: "155052346752370", //Facebook AppID
            version: "v12.0",
            cookie: true,
            status: true,
            xfbml: true,
        } );

        Window.FB.ui( {
            method: "feed",
            name: "Invite Friends",
            link: `https://actavivo.com/${ val.type }/${ val.token }`,
            description: "Welcome to Actavivo",
            display: "popup",
            to: item.id,
        } );
    };

    const searchfollowing = async ( val ) =>
    {
        setData(
            responseData?.filter( ( x : any ) =>
                val?.trim()?.length > 0
                    ? x?.name !== undefined &&
                    x?.name?.toLocaleLowerCase().includes( val.toLocaleLowerCase() )
                    : responseData
            )
        );
    };

    const deviceFCMToken = useSelector(
        ( state : RootStateOrAny ) => state.user.devicefcmtoken
    );

    const clearCache = useClearCache();

    const handleClearCache = () =>
    {
        localStorage.clear(); // Clears all local storage data
        sessionStorage.clear(); // Clears all session storage data

        // If using authentication tokens in local storage
        localStorage.removeItem( "AVAuth" );
        localStorage.removeItem( "MediaStore" );
        localStorage.removeItem( "persist:root" );
    };

    const handleLogout = async () =>
    {
        try
        {
            setIsLoader(true);
            if ( deviceFCMToken?.length > 0 )
            {
                await Person.removeFCMToken( deviceFCMToken );
            }

            navigate("/", { state: { isLogout: "true" } });

            await clearCache( false );
            await handleClearCache();
            localStorage.clear();

            console.log( "Log out clearance is done!" );
            setTimeout(() => {
                AVAuth.logout();
            }, 100);
            setIsLoader(false);
        } catch ( error )
        {
            console.error( "Error during logout process:", error );
        }
    };

    const isOnline = useSelector(
        ( state : RootStateOrAny ) => state.user.isOnline
    );
    const convo = useralertList?.filter(
        ( x : any ) =>
            x?.actionTaken == undefined &&
            ( x?.alertType == "NewDM" || x?.alertType == "ReplyDM" ) &&
            x?.data?.person?.id !== currentUser?.id
    );
    const unreadconvo = Array.isArray( convo)
        ? _.uniqBy( convo, "data.feed.id" )
        : [];

    return (
        <>
            <HStack alignItems={ "center" } space={ [ 2 ] } borderWidth={ 0 }>
                <HStack
                    alignItems={ "center" }
                    justifyContent={ "space-between" }
                    bgColor={ "#EEEEEE" }
                    borderRadius={ "full" }
                    p={ 1.5 }
                    backgroundColor={ "AVColor.primary" }
                >
                    <Pressable
                        isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                        onPress={ () =>
                            navigate( `/profile/${ currentUser?.id }/${ currentUser?.region }`, {
                                state: { user: currentUser },
                            } )
                        }
                    >
                        <HStack space={ [ 0, 0, 2 ] }>
                            <EntityProfilePic
                                width={ [ 26, 30 ] }
                                height={ [ 26, 30 ] }
                                link={ Person.getLink( currentUser ) }
                            />
                            <Hidden till={ "md" }>
                                <Text
                                    fontWeight="medium"
                                    alignSelf="center"
                                    fontFamily={ "Roboto" }
                                    numberOfLines={ 1 }
                                    width={ "100px" }
                                    fontSize={ titleLength }
                                >
                                    { TitleData }
                                    { userTitle?.length > 20 ? "..." : "" }
                                </Text>
                            </Hidden>
                        </HStack>
                    </Pressable>
                    <Hidden till={ "md" }>
                        <div data-header-menu="true">
                            <Pressable
                                isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                                onPress={ () =>
                                {

                                    setShowProfile( ( prev ) => !prev );
                                    setShowConvoListModal( false );
                                    setMdlCreateConvoVisible( false );
                                    setShowAlertModal( false );
                                    setShowFollowingModal( false );
                                    setShowConvoListModal( false );
                                    setMdlConvoVisible( false );
                                    setMdlCreateConvoVisible( false );
                                    setConvoLoading( false );
                                    setIsOpenConvo( false );
                                    /*setShowDetails( false )*/
                                } }
                            >
                                <HStack>
                                    <Image source={ Dropdown } alt="Actavivo" size="25px" />
                                </HStack>
                            </Pressable>
                        </div>
                    </Hidden>
                </HStack>

                { ( currentUser?.requests?.length > 0 ||
                    requestdata.length > 0 ||
                    followRequestData?.length > 0 ) && (
                        <div data-header-menu="true">
                            <Pressable
                                onPress={ () =>
                                {
                                    if ( currentUser?.status !== "Deleted" )
                                    {
                                        setShowFollowingModal( true );
                                        setShowAlertModal( false );
                                        setShowConvoListModal( false );
                                        setShowProfile( false );
                                        setShowConvoListModal( false );
                                        setShowProfile( false );
                                        setShowBurgerMenu( false );
                                        setShowConvoListModal( false );
                                        setMdlConvoVisible( false );
                                        setIsOpenConvo(false);
                                        setMdlCreateConvoVisible( false );
                                        setConvoLoading( false );
                                    }
                                } }
                                bgColor={ "#FFA500" }
                                _hover={ { bgColor: "AVColor.secondary" } }
                                rounded={ "full" }
                            >
                                <Box p="8px">
                                    { ( requestdata.length > 0 ||
                                        currentUser?.requests?.length > 0 ||
                                        followRequestData?.length > 0 ) && (
                                            <Badge
                                                colorScheme="danger"
                                                rounded="full"
                                                variant="solid"
                                                alignSelf="flex-end"
                                                _text={ {
                                                    fontSize: 12,
                                                } }
                                                top={ -10 }
                                                right={ -3 }
                                                position="absolute"
                                            >
                                                { requestdata?.length }
                                            </Badge>
                                        ) }
                                    <FollowingIcon color={ "#000000" } size={ [ "24px" ] } />
                                </Box>
                            </Pressable>
                        </div>
                    ) }

                <div data-header-menu="true">
                    <Pressable
                        isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                        onPress={ () =>
                        {
                            if ( currentUser?.status !== "Deleted" )
                            {
                                setMdlCreateConvoVisible( false );
                                setShowFollowingModal( false );
                                setShowConvoListModal( false );
                                setShowProfile( false );
                                setShowAlertModal( !showAlertModal );
                                setMdlConvoVisible( false );
                                setIsOpenConvo( false );
                            }
                        } }
                        bgColor={ "#F5E732" }
                        _hover={ { bg: "#E0D42D" } }
                        rounded={ [ "full" ] }
                    >
                        <Box p="8px">
                            { unreadAlertData?.length > 0 && (
                                <Badge
                                    colorScheme="danger"
                                    rounded="full"
                                    variant="solid"
                                    alignSelf="flex-end"
                                    _text={ {
                                        fontSize: 12,
                                    } }
                                    top={ -10 }
                                    right={ -3 }
                                    position="absolute"
                                >
                                    { unreadAlertData?.length }
                                </Badge>
                            ) }
                            <NotificationIcon size={ "24px" } color={ "#000000" } />
                        </Box>
                    </Pressable>
                </div>

                <div data-header-menu="true">
                    <Pressable
                        isDisabled={ currentUser?.status === "NewUser" || currentUser?.status === 'Deleted' }
                        onPress={ () =>
                        {
                            if ( currentUser?.status !== "Deleted" )
                            {
                                handleMessageIconClick();
                            }
                        } }
                        bgColor={ "#F5E732" }
                        _hover={ {
                            bg: "#E0D42D",
                        } }
                        rounded={ [ "full" ] }
                    >
                        <Box p="8px">
                            { unreadconvo?.length > 0 && unreadconvo?.filter(
                                ( x ) => x?.data?.postObj?.owner?.type !== "GroupConvo" && x?.data?.postObj?.owner?.type !== "GameGroupConvo" && x?.wardName == undefined
                            ).length > 0 && (
                                    <Badge
                                        colorScheme="danger"
                                        rounded="full"
                                        variant="solid"
                                        alignSelf="flex-end"
                                        _text={ {
                                            fontSize: 12,
                                        } }
                                        top={ -10 }
                                        right={ -3 }
                                        position="absolute"
                                    >
                                        {
                                            unreadconvo?.length > 0 && unreadconvo?.filter(
                                                ( x ) => x?.data?.postObj?.owner?.type !== "GroupConvo" && x?.data?.postObj?.owner?.type !== "GameGroupConvo" && x?.wardName == undefined
                                            ).length
                                        }
                                    </Badge>
                                ) }
                            <MessageIcon size={ "24px" } color={ "#000000" } />
                        </Box>
                    </Pressable>
                </div>
                {/* hamburger menu */ }

                <Hidden from={ "lg" }>
                    <Pressable
                        backgroundColor={ "AVColor.buttonBg" }
                        rounded={ "full" }
                        _hover={ { backgroundColor: "AVColor.grey" } }
                        onPress={ () =>
                        {
                            setShowBurgerMenu( ( prev ) => !prev );
                            setMdlCreateConvoVisible( false );
                            setShowFollowingModal( false );
                            setShowConvoListModal( false );
                            setShowProfile( false );
                            setShowAlertModal( false );
                        } }
                    >
                        <Box p={ [ 2, 3 ] }>
                            { !showBurgerMenu && (
                                <HamburgerIcon size={ "20px" } color={ "AVColor.black" } />
                            ) }
                            { showBurgerMenu && (
                                <CloseIcon size={ "20px" } color={ "AVColor.black" } />
                            ) }
                        </Box>
                    </Pressable>
                </Hidden>
            </HStack>

            { showAddinviteModal && (
                <InviteFriends
                    setshowAddinviteModal={ setshowAddinviteModal }
                    showAddinviteModal={ showAddinviteModal }
                />
            ) }

            { showpop && (
                <Box position="fixed" bottom={ 0 } right={ 0 } top={ 0 } left={ 0 }>
                    <div
                        style={ {
                            position: "fixed",
                            top: "53%",
                            left: "50%",
                            background: "#ffffff",
                            borderRadius: "8px",
                            height: isMobile ? "55%" : "425px",
                            width: isMobile ? "82%" : "55%",
                            transform: "translate(-50%, -50%)",
                        } }
                    >
                        <HStack
                            isDisabled={ currentUser?.status === "Deleted" }
                            marginTop={ "10px" }
                            alignItems={ "center" }
                            justifyContent={ "space-between" }
                            borderBottomColor={ "AVColor.grey" }
                            px={ 5 }
                            zIndex={ 99 }
                        >
                            <Text fontSize={ 24 }>{ Loc.currentLang.menu.friends }</Text>
                            <Input
                                width={ "260px" }
                                borderWidth={ 0 }
                                placeholder={ Loc.currentLang.menu.search }
                                variant="AVSearchInput"
                                placeholderTextColor="AVColor.textLite"
                                backgroundColor={ "#F5F5F5" }
                                borderRadius={ "22px" }
                                fontSize={ "16px" }
                                InputLeftElement={
                                    <SearchIcon
                                        ml="2"
                                        size="24px"
                                        color="#000"
                                        left={ "10px" }
                                        p={ "7px" }
                                    />
                                }
                                onChangeText={ ( e ) => searchfollowing( e ) }
                            />
                            <HStack alignItems={ "center" } justifyContent={ "center" } space={ 2 }>
                                <AVCancel
                                    callback={ () => setisshowpop( false ) }
                                    color={ undefined }
                                    size={ undefined }
                                />
                            </HStack>
                        </HStack>

                        <Box
                            backgroundColor={ "AVColor.primary" }
                            marginTop={ "30px" }
                            marginLeft={ "115px" }
                            width={ "70%" }
                            paddingLeft={ "22px" }
                            borderRadius={ "5px" }
                        >
                            <HStack>
                                <HStack paddingX={ "4px" } width={ "85%" }>
                                    <Text
                                        fontWeight={ "medium" }
                                        fontSize={ "19px" }
                                        text-overflow={ "ellipsis" }
                                        textTransform={ "capitalize" }
                                        textAlign={ "center" }
                                        numberOfLines={ 1 }
                                        color={ "white" }
                                    >
                                        { Loc.currentLang.profile.name }
                                    </Text>
                                </HStack>
                                <HStack
                                    paddingX={ "4px" }
                                    width={ "15%" }
                                    justifyContent={ "center" }
                                >
                                    <Text
                                        fontWeight={ "medium" }
                                        fontSize={ "19px" }
                                        text-overflow={ "ellipsis" }
                                        textAlign={ "center" }
                                        numberOfLines={ 1 }
                                    ></Text>
                                </HStack>
                            </HStack>
                        </Box>

                        <VStack
                            height={ "300px" }
                            marginTop={ "10px" }
                            overflowY={ "auto" }
                            overflowX={ "hidden" }
                        >
                            { data?.map((item: any, index: number) => (
                                <Box
                                    key={ item?.id || index }
                                    backgroundColor={ "#EEEEEE" }
                                    marginTop={ "15px" }
                                    marginLeft={ "115px" }
                                    width={ "70%" }
                                    paddingLeft={ "22px" }
                                    borderRadius={ "5px" }
                                >
                                    <HStack>
                                        <HStack paddingX={ "4px" } width={ "85%" }>
                                            <Text
                                                fontWeight={ "medium" }
                                                fontSize={ "19px" }
                                                text-overflow={ "ellipsis" }
                                                numberOfLines={ 1 }
                                            >
                                                { item.name }
                                            </Text>
                                        </HStack>
                                        <HStack
                                            paddingX={ "4px" }
                                            width={ "15%" }
                                            justifyContent={ "center" }
                                        >
                                            <Pressable
                                                isDisabled={ currentUser?.status === "Deleted" }
                                                onPress={ () =>
                                                {
                                                    Invitefriends( item );
                                                } }
                                            >
                                                <Text
                                                    fontWeight={ "medium" }
                                                    fontSize={ "19px" }
                                                    text-overflow={ "ellipsis" }
                                                    numberOfLines={ 1 }
                                                    color={ "#00A7BC" }
                                                >
                                                    { Loc.currentLang.menu.invite }
                                                </Text>
                                            </Pressable>
                                        </HStack>
                                    </HStack>
                                </Box>
                            ) ) }
                        </VStack>
                    </div>
                </Box>
            ) }

            { showProfile && (
                <Box
                    shadow="9"
                    ref={ menuRef }
                    position={ "absolute" }
                    bgColor="#FFFFFF"
                    rounded="lg"
                    minHeight={ "200px" }
                    width={ "200px" }
                    top={ "50px" }
                    right={ currentUser?.requests?.length > 0 ? "130px" : "90px" }
                    zIndex={ "1" }
                >
                    <VStack padding={ "20px" }>
                        <Pressable
                            onPress={ () =>
                            {
                                navigate( `/profile/${ currentUser?.id }/${ currentUser?.region }`, {
                                    state: { user: currentUser },
                                } );
                                setShowProfile( false );
                            } }
                        >
                            <HStack marginBottom={ "10px" }>
                                <Box rounded="full">
                                    <EntityProfilePic
                                        width={ "48px" }
                                        height={ "48px" }
                                        link={ Person.getLink( currentUser ) }
                                    />
                                </Box>
                                <VStack marginLeft={ "10px" } flex={ 1 }>
                                    <Text
                                        fontWeight="medium"
                                        fontSize={ "20px" }
                                        fontFamily={ "Roboto" }
                                        numberOfLines={ 1 }
                                        width={ "110px" }
                                        lineHeight={ "24px" }
                                    >
                                        { Person.getLink( currentUser )?.title }
                                    </Text>

                                    <Text
                                        fontSize={ "14px" }
                                        fontFamily={ "Roboto" }
                                        marginLeft={ "1px" }
                                        color={ "#00A7BC" }
                                        lineHeight={ "24px" }
                                        numberOfLines={ 1 }
                                        ellipsizeMode="tail"
                                    >
                                        { Loc.currentLang.menu.viewMyPage }
                                    </Text>
                                </VStack>
                            </HStack>
                        </Pressable>
                        <Divider />

                        <Pressable
                            isDisabled={ currentUser?.status === "Deleted" }
                            onPress={ () =>
                            {
                                navigate( `/manageFollowings` );
                                setShowProfile( false );
                            } }
                        >
                            <Text
                                marginTop={ "20px" }
                                marginLeft={ "10px" }
                                color={ "#00A7BC" }
                                fontSize={ "16px" }
                                lineHeight={ "10px" }
                            >
                                { Loc.currentLang.menu.followings }
                            </Text>
                        </Pressable>
                        {/*<Pressable*/ }
                        {/*  isDisabled={ currentUser?.status === 'Deleted' }*/ }
                        {/*  onPress={ () => {*/ }
                        {/*    navigate(`/signal`);*/ }
                        {/*    setShowProfile(false);*/ }
                        {/*  } }*/ }
                        {/*>*/ }
                        {/*  <Text*/ }
                        {/*    marginTop={ '20px' }*/ }
                        {/*    marginLeft={ '10px' }*/ }
                        {/*    color={ '#00A7BC' }*/ }
                        {/*    fontSize={ '16px' }*/ }
                        {/*    lineHeight={ '10px' }*/ }
                        {/*  >*/ }
                        {/*    signal R*/ }
                        {/*  </Text>*/ }
                        {/*</Pressable>*/ }
                        <Pressable
                            isDisabled={ currentUser?.status === "Deleted" }
                            onPress={ () =>
                            {
                                navigate(
                                    `/accountsettings/${ currentUser?.id }/${ currentUser?.region }`,
                                    {
                                        state: {
                                            page: pathName,
                                            accountsetting: "HomePage",
                                            Entity: currentUser,
                                        },
                                    }
                                );
                                setShowProfile( false );
                            } }
                        >
                            <Text
                                marginTop={ "20px" }
                                marginLeft={ "10px" }
                                fontSize={ "16px" }
                                color={ "#00A7BC" }
                                lineHeight={ "10px" }
                            >
                                { Loc.currentLang.menu.settings }
                            </Text>
                        </Pressable>

                        <Pressable
                            isDisabled={ currentUser?.status === "Deleted" }
                            onPress={ () =>
                            {
                                navigate( "/donate" );
                                setShowProfile( false );
                            } }
                        >
                            <Text
                                marginTop="20px"
                                marginLeft="10px"
                                fontSize="16px"
                                color="#00A7BC"
                                lineHeight="10px"
                            >
                                { Loc.currentLang.menu.donate }
                            </Text>
                        </Pressable>
                        <Divider marginTop={ "15px" }></Divider>
                        <Pressable
                            onPress={ () =>
                            {
                                window.open( "https://actavivo.net/" );
                            } }
                        >
                            <Text
                                marginTop={ "20px" }
                                marginLeft={ "10px" }
                                fontSize={ "16px" }
                                color={ "#00A7BC" }
                                lineHeight={ "10px" }
                            >
                                { Loc.currentLang.menu.about }
                            </Text>
                        </Pressable>
                        <Pressable
                            onPress={ () =>
                            {
                                window.open( "https://actavivo.net/how-to/" );
                            } }
                        >
                            <Text
                                marginTop={ "20px" }
                                marginLeft={ "10px" }
                                fontSize={ "16px" }
                                color={ "#00A7BC" }
                                lineHeight={ "10px" }
                            >
                                { Loc.currentLang.menu.help }
                            </Text>
                        </Pressable>
                        <Pressable
                            isDisabled={ currentUser?.status === "Deleted" }
                            onPress={ () =>
                            {
                                navigate(
                                    "/teams/78b5b063-fd3e-4925-92bd-2a1888c6a46a/" +
                                    currentUser?.region,
                                    {
                                        state: {
                                            team: {
                                                id: "78b5b063-fd3e-4925-92bd-2a1888c6a46a",
                                                pk: "a46a",
                                                region: currentUser?.region,
                                                type: "Organization",
                                                name: "Actavivo",
                                            },
                                            type: "Feedback",
                                        },
                                    }
                                );
                            } }
                        >
                            <Text
                                marginTop={ "20px" }
                                marginLeft={ "10px" }
                                fontSize={ "16px" }
                                color={ "#00A7BC" }
                                lineHeight={ "10px" }
                            >
                                { Loc.currentLang.menu.feedback }
                            </Text>
                        </Pressable>
                        <Divider marginTop={ "15px" }></Divider>
                        <Pressable
                            isDisabled={ currentUser?.status === "Deleted" }
                            onPress={ () =>
                            {
                                setshowAddinviteModal( true );
                                setShowProfile( false );
                                setpersonEmail( "" );
                                setpersonname( "" );
                                setpersonPhone( "" );
                                setisLoading( false );
                            } }
                        >
                            <Text
                                marginTop={ "18px" }
                                marginLeft={ "10px" }
                                fontSize={ "16px" }
                                color={ "#00A7BC" }
                                //lineHeight={ "10px" }
                                numberOfLines={ 1 }
                                ellipsizeMode="tail"
                            >
                                { Loc.currentLang.menu.inviteFriends }
                            </Text>
                        </Pressable>
                        <Button
                            width={ "100%" }
                            height={ "38px" }
                            alignContent={ "space-around" }
                            alignSelf={ "center" }
                            marginTop={ "20px" }
                            borderRadius={ "6px" }
                            background={ "#EEEEEE" }
                            onPress={ () =>
                            {
                                setIsConfirmLogout(true);//handleLogout();
                            } }
                        >
                            <Text fontSize={ 14 } color={ "#00A7BC" }>
                                { Loc.currentLang.menu.logout }
                            </Text>
                        </Button>
                    </VStack>
                    { currentUser?.wards?.length > 0 && <Divider /> }

                    { !ispageLoading && (
                        <ScrollView>
                            <VStack
                                minHeight={ "0px" }
                                maxHeight={ "140px" }
                                overflowY={ "scroll" }
                            >
                                <Text
                                    marginTop={ "7px" }
                                    fontWeight={ "bold" }
                                    marginLeft={ "10px" }
                                    fontSize={ "16px" }
                                    lineHeight={ "24px" }
                                >
                                    { currentUser?.wards?.length > 0 && !loginLink?.id
                                        ? Loc.currentLang.menu.myDependents
                                        : "" }
                                </Text>

                                { currentUser?.wards?.length > 0 &&
                                    userisguardian &&
                                    !loginLink?.id &&
                                    currentUser?.wards?.map((item, index) => (
                                        <React.Fragment key={ item?.id || index }>
                                            <VStack padding="2px">
                                               <Pressable
                                                   isDisabled={ !isOnline }
                                                   onPress={ () =>
                                                   {
                                                       handleuserchange( item );
                                                   } }
                                               >
                                                   <HStack marginBottom={ "5px" }>
                                                       <Box rounded="full" marginLeft={ "18px" }>
                                                           <EntityProfilePic
                                                               width={ "35px" }
                                                               height={ "35px" }
                                                               link={ item }
                                                           />
                                                       </Box>
                                                       <VStack marginLeft={ "10px" }>
                                                           <Text
                                                               fontWeight="medium"
                                                               fontSize={ "16px" }
                                                               fontFamily={ "Roboto" }
                                                               numberOfLines={ 1 }
                                                               width={ "110px" }
                                                           >
                                                               { item?.title }
                                                           </Text>

                                                           <Text
                                                               fontSize={ "12px" }
                                                               fontFamily={ "Roboto" }
                                                               marginLeft={ "1px" }
                                                               color={ "#00A7BC" }
                                                               lineHeight={ "24px" }
                                                           >
                                                               { Loc.currentLang.menu.viewMyPage }
                                                           </Text>
                                                       </VStack>
                                                   </HStack>
                                               </Pressable>
                                            </VStack>
                                        </React.Fragment>
                                    ) ) }

                                { loginLink?.id && loginLink?.id !== currentUser?.id && (
                                    <VStack padding={ "2px" }>
                                       <Pressable
                                           isDisabled={ !isOnline }
                                           onPress={ () =>
                                           {
                                               handleGuardianChange( loginLink );
                                           } }
                                       >
                                           <HStack marginBottom={ "5px" }>
                                               <Box rounded="full" marginLeft={ "18px" }>
                                                   <EntityProfilePic
                                                       width={ "35px" }
                                                       height={ "35px" }
                                                       link={ Person.getLink( loginLink ) }
                                                   />
                                               </Box>
                                               <VStack marginLeft={ "10px" }>
                                                   <Text
                                                       fontWeight="medium"
                                                       fontSize={ "16px" }
                                                       fontFamily={ "Roboto" }
                                                       numberOfLines={ 1 }
                                                       width={ "110px" }
                                                   >
                                                       { Person.getLink( loginLink )?.title }
                                                   </Text>

                                                   <Text
                                                       fontSize={ "12px" }
                                                       fontFamily={ "Roboto" }
                                                       marginLeft={ "1px" }
                                                       color={ "#00A7BC" }
                                                       lineHeight={ "24px" }
                                                   >
                                                       { Loc.currentLang.menu.viewMyPage }
                                                   </Text>
                                               </VStack>
                                           </HStack>
                                       </Pressable>
                                    </VStack>
                                ) }
                            </VStack>
                        </ScrollView>
                    ) }

                    {ispageLoading && (
                      <HStack 
                        margin="20px" 
                        justifyContent="center" 
                        height="40px"
                        alignItems="center"
                      >
                        <div className="loader" style={{ borderLeftColor: "#32AE78" }}></div>
                      </HStack>
                    )}
                </Box>
            ) }

            { isConfirmLogout && <AVConfirmationModal showconfirmationPopup={ isConfirmLogout } setshowconfirmationPopup={ setIsConfirmLogout }
                Confirmationtext={ Loc.currentLang.menu.logoutConfirmText } type={ "Logout" } item={ undefined } function={ handleLogout } isLoader={ isLoader } /> }
        </>
    );
};

export default React.memo( Header );
